const Alphabets = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ё', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'Ө', 'П', 'Р', 'С', 'Т', 'У', 'Ү', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ы', 'Ь', 'Э', 'Ю', 'Я']

const Occupations = [
  {
    id: 'Банк, санхүү',
    name: 'Банк, санхүү',
  },
  {
    id: 'Даатгал',
    name: 'Даатгал',
  },
  {
    id: 'Эрүүл мэнд',
    name: 'Эрүүл мэнд',
  },
  {
    id: 'Харилцаа, холбоо',
    name: 'Харилцаа, холбоо',
  },
  {
    id: 'Мэдээлэл, технологи',
    name: 'Мэдээлэл, технологи',
  },
  {
    id: 'Уул, уурхай',
    name: 'Уул, уурхай',
  },
  {
    id: 'Боловсрол',
    name: 'Боловсрол',
  },
  {
    id: 'Үйлдвэрлэл, худалдаа',
    name: 'Үйлдвэрлэл, худалдаа',
  },
  {
    id: 'Бусад',
    name: 'Бусад',
  },
]

const Educations = [
  {
    id: '1',
    name: 'Доктор',
  },
  {
    id: '2',
    name: 'Магистр',
  },
  {
    id: '3',
    name: 'Бакалавр',
  },
  {
    id: '4',
    name: 'Бүрэн дунд',
  },
  {
    id: '5',
    name: 'Тусгай мэргэжил',
  },
  {
    id: '0',
    name: 'Бусад',
  }
]

const Cities = [
  {
    code: '11',
    name: 'Улаанбаатар',
  },
  {
    code: '22',
    name: 'Сүхбаатар',
  },
  {
    code: '44',
    name: 'Дорноговь',
  },
  {
    code: '45',
    name: 'Дархан-Уул',
  },
  {
    code: '67',
    name: 'Хөвсгөл',
  },
  {
    code: '23',
    name: 'Хэнтий',
  },
  {
    code: '46',
    name: 'Өмнөговь',
  },
  {
    code: '48',
    name: 'Дундговь',
  },
  {
    code: '81',
    name: 'Завхан',
  },
  {
    code: '82',
    name: 'Говь-Алтай',
  },
  {
    code: '61',
    name: 'Орхон',
  },
  {
    code: '83',
    name: 'Баян-Өлгий',
  },
  {
    code: '62',
    name: 'Өвөрхангай',
  },
  {
    code: '84',
    name: 'Ховд',
  },
  {
    code: '85',
    name: 'Увс',
  },
  {
    code: '41',
    name: 'Төв',
  },
  {
    code: '63',
    name: 'Булган',
  },
  {
    code: '42',
    name: 'Говьсүмбэр',
  },
  {
    code: '64',
    name: 'Баянхонгор',
  },
  {
    code: '21',
    name: 'Дорнод',
  },
  {
    code: '43',
    name: 'Сэлэнгэ',
  },
  {
    code: '65',
    name: 'Архангай',
  },
]

const Districts = [
  {
    code: '63-01',
    name: 'Булган',
  },
  {
    code: '62-34',
    name: 'Өлзийт',
  },
  {
    code: '85-31',
    name: 'Өмнөговь',
  },
  {
    code: '67-49',
    name: 'Цагааннуур',
  },
  {
    code: '63-04',
    name: 'Баян-Агт',
  },
  {
    code: '62-37',
    name: 'Сант',
  },
  {
    code: '63-07',
    name: 'Баяннуур',
  },
  {
    code: '11-01',
    name: 'Багануур',
  },
  {
    code: '22-16',
    name: 'Наран',
  },
  {
    code: '22-19',
    name: 'Онгон',
  },
  {
    code: '22-10',
    name: 'Дарьганга',
  },
  {
    code: '22-13',
    name: 'Мөнххаан',
  },
  {
    code: '11-04',
    name: 'Багахангай',
  },
  {
    code: '85-37',
    name: 'Сагил',
  },
  {
    code: '67-43',
    name: 'Улаан-Уул',
  },
  {
    code: '67-40',
    name: 'Түнэл',
  },
  {
    code: '85-34',
    name: 'Өндөрхангай',
  },
  {
    code: '67-46',
    name: 'Ханх',
  },
  {
    code: '44-40',
    name: 'Эрдэнэ',
  },
  {
    code: '21-40',
    name: 'Чулуунхороот',
  },
  {
    code: '11-07',
    name: 'Баянгол',
  },
  {
    code: '45-10',
    name: 'Шарын Гол',
  },
  {
    code: '62-31',
    name: 'Нарийнтээл',
  },
  {
    code: '62-43',
    name: 'Төгрөг',
  },
  {
    code: '63-13',
    name: 'Бүрэгхангай',
  },
  {
    code: '62-46',
    name: 'Уянга',
  },
  {
    code: '44-37',
    name: 'Хөвсгөл',
  },
  {
    code: '45-04',
    name: 'Орхон',
  },
  {
    code: '63-16',
    name: 'Гурван Булаг',
  },
  {
    code: '11-10',
    name: 'Баянзүрх',
  },
  {
    code: '45-07',
    name: 'Хонгор',
  },
  {
    code: '62-49',
    name: 'Хайрхандулаан',
  },
  {
    code: '11-13',
    name: 'Налайх',
  },
  {
    code: '63-19',
    name: 'Дашинчилэн',
  },
  {
    code: '22-25',
    name: 'Түвшинширээ',
  },
  {
    code: '22-28',
    name: 'Түмэнцогт',
  },
  {
    code: '22-22',
    name: 'Сүхбаатар',
  },
  {
    code: '45-01',
    name: 'Дархан',
  },
  {
    code: '85-28',
    name: 'Өлгий',
  },
  {
    code: '67-52',
    name: 'Цагаан-Уул',
  },
  {
    code: '44-34',
    name: 'Хатанбулаг',
  },
  {
    code: '11-16',
    name: 'Сонгинохайрхан',
  },
  {
    code: '11-19',
    name: 'Сүхбаатар',
  },
  {
    code: '85-22',
    name: 'Малчин',
  },
  {
    code: '67-58',
    name: 'Цэцэрлэг',
  },
  {
    code: '62-40',
    name: 'Тарагт',
  },
  {
    code: '85-25',
    name: 'Наранбулаг',
  },
  {
    code: '67-55',
    name: 'Цагаан-Үүр',
  },
  {
    code: '44-31',
    name: 'Улаанбадрах',
  },
  {
    code: '63-10',
    name: 'Бугат',
  },
  {
    code: '85-52',
    name: 'Хяргас',
  },
  {
    code: '63-22',
    name: 'Могод',
  },
  {
    code: '62-55',
    name: 'Хужирт',
  },
  {
    code: '63-25',
    name: 'Орхон',
  },
  {
    code: '21-28',
    name: 'Халхгол',
  },
  {
    code: '44-25',
    name: 'Өргөн',
  },
  {
    code: '44-28',
    name: 'Сайхандулаан',
  },
  {
    code: '63-28',
    name: 'Рашаант',
  },
  {
    code: '21-25',
    name: 'Сэргэлэн',
  },
  {
    code: '81-19',
    name: 'Завханмандал',
  },
  {
    code: '81-16',
    name: 'Дөрвөлжин',
  },
  {
    code: '67-61',
    name: 'Чандмань-Өндөр',
  },
  {
    code: '67-64',
    name: 'Шинэ-Идэр',
  },
  {
    code: '44-22',
    name: 'Мандах',
  },
  {
    code: '21-22',
    name: 'Матад',
  },
  {
    code: '81-13',
    name: 'Баянхайрхан',
  },
  {
    code: '85-55',
    name: 'Цагаанхайрхан',
  },
  {
    code: '62-52',
    name: 'Хархорин',
  },
  {
    code: '67-67',
    name: 'Эрдэнэбулган',
  },
  {
    code: '81-10',
    name: 'Баянтэс',
  },
  {
    code: '44-19',
    name: 'Иххэт',
  },
  {
    code: '85-40',
    name: 'Тариалан',
  },
  {
    code: '63-34',
    name: 'Сэлэнгэ',
  },
  {
    code: '64-01',
    name: 'Баянхонгор',
  },
  {
    code: '85-43',
    name: 'Түргэн',
  },
  {
    code: '64-04',
    name: 'Баацагаан',
  },
  {
    code: '63-37',
    name: 'Тэшиг',
  },
  {
    code: '43-46',
    name: 'Цагааннуур',
  },
  {
    code: '21-37',
    name: 'Чойбалсан',
  },
  {
    code: '64-07',
    name: 'Баянбулаг',
  },
  {
    code: '43-49',
    name: 'Шаамар',
  },
  {
    code: '44-16',
    name: 'Замын-Үүд',
  },
  {
    code: '22-04',
    name: 'Асгат',
  },
  {
    code: '22-07',
    name: 'Баяндэлгэр',
  },
  {
    code: '81-04',
    name: 'Алдархаан',
  },
  {
    code: '22-01',
    name: 'Баруун-Урт',
  },
  {
    code: '81-07',
    name: 'Асгат',
  },
  {
    code: '85-49',
    name: 'Ховд',
  },
  {
    code: '21-34',
    name: 'Цагаан-Овоо',
  },
  {
    code: '81-01',
    name: 'Улиастай',
  },
  {
    code: '43-43',
    name: 'Хушаат',
  },
  {
    code: '44-10',
    name: 'Даланжаргалан',
  },
  {
    code: '44-13',
    name: 'Дэлгэрэх',
  },
  {
    code: '21-31',
    name: 'Хөлөнбуйр',
  },
  {
    code: '63-31',
    name: 'Сайхан',
  },
  {
    code: '43-40',
    name: 'Хүдэр',
  },
  {
    code: '85-46',
    name: 'Тэс',
  },
  {
    code: '64-13',
    name: 'Баянлиг',
  },
  {
    code: '44-07',
    name: 'Алтанширээ',
  },
  {
    code: '63-46',
    name: 'Хутаг-Өндөр',
  },
  {
    code: '21-07',
    name: 'Баянтүмэн',
  },
  {
    code: '44-04',
    name: 'Айраг',
  },
  {
    code: '64-16',
    name: 'Баян-Овоо',
  },
  {
    code: '21-04',
    name: 'Баяндун',
  },
  {
    code: '64-19',
    name: 'Баян-Өндөр',
  },
  {
    code: '43-37',
    name: 'Түшиг',
  },
  {
    code: '48-40',
    name: 'Цагаандэлгэр',
  },
  {
    code: '81-37',
    name: 'Сонгино',
  },
  {
    code: '82-07',
    name: 'Баян-Уул',
  },
  {
    code: '82-01',
    name: 'Есөнбулаг',
  },
  {
    code: '43-31',
    name: 'Сайхан',
  },
  {
    code: '21-01',
    name: 'Хэрлэн',
  },
  {
    code: '81-34',
    name: 'Сантмаргац',
  },
  {
    code: '82-04',
    name: 'Алтай',
  },
  {
    code: '43-34',
    name: 'Сант',
  },
  {
    code: '44-01',
    name: 'Сайншанд',
  },
  {
    code: '63-40',
    name: 'Хангал',
  },
  {
    code: '81-31',
    name: 'Отгон',
  },
  {
    code: '48-43',
    name: 'Эрдэнэдалай',
  },
  {
    code: '63-43',
    name: 'Хишиг-Өндөр',
  },
  {
    code: '64-10',
    name: 'Баянговь',
  },
  {
    code: '43-28',
    name: 'Орхонтуул',
  },
  {
    code: '21-19',
    name: 'Дашбалбар',
  },
  {
    code: '64-25',
    name: 'Богд',
  },
  {
    code: '64-28',
    name: 'Бөмбөгөр',
  },
  {
    code: '21-16',
    name: 'Гурванзагал',
  },
  {
    code: '43-25',
    name: 'Орхон',
  },
  {
    code: '21-13',
    name: 'Булган',
  },
  {
    code: '48-31',
    name: 'Өндөршил',
  },
  {
    code: '81-28',
    name: 'Нөмрөг',
  },
  {
    code: '81-22',
    name: 'Идэр',
  },
  {
    code: '43-22',
    name: 'Мандал',
  },
  {
    code: '21-10',
    name: 'Баян-Уул',
  },
  {
    code: '81-25',
    name: 'Их-Уул',
  },
  {
    code: '48-37',
    name: 'Хулд',
  },
  {
    code: '48-34',
    name: 'Сайхан-Овоо',
  },
  {
    code: '64-22',
    name: 'Баянцагаан',
  },
  {
    code: '64-34',
    name: 'Галуут',
  },
  {
    code: '41-79',
    name: 'Эрдэнэсант',
  },
  {
    code: '64-37',
    name: 'Гурванбулаг',
  },
  {
    code: '43-19',
    name: 'Зүүнбүрэн',
  },
  {
    code: '65-04',
    name: 'Батцэнгэл',
  },
  {
    code: '65-07',
    name: 'Булган',
  },
  {
    code: '43-13',
    name: 'Ерөө',
  },
  {
    code: '43-16',
    name: 'Жавхлант',
  },
  {
    code: '82-28',
    name: 'Тонхил',
  },
  {
    code: '81-55',
    name: 'Цагаанхайрхан',
  },
  {
    code: '43-10',
    name: 'Баянгол',
  },
  {
    code: '48-28',
    name: 'Өлзийт',
  },
  {
    code: '82-25',
    name: 'Тайшир',
  },
  {
    code: '41-70',
    name: 'Угтаалцайдам',
  },
  {
    code: '48-25',
    name: 'Луус',
  },
  {
    code: '81-58',
    name: 'Цагаанчулуут',
  },
  {
    code: '64-31',
    name: 'Бууцагаан',
  },
  {
    code: '41-76',
    name: 'Эрдэнэ',
  },
  {
    code: '81-52',
    name: 'Ургамал',
  },
  {
    code: '65-01',
    name: 'Эрдэнэбулган',
  },
  {
    code: '82-22',
    name: 'Жаргалан',
  },
  {
    code: '41-73',
    name: 'Цээл',
  },
  {
    code: '48-22',
    name: 'Дэрэн',
  },
  {
    code: '64-46',
    name: 'Заг',
  },
  {
    code: '65-13',
    name: 'Их Тамир',
  },
  {
    code: '43-07',
    name: 'Баруунбүрэн',
  },
  {
    code: '65-16',
    name: 'Өгийнуур',
  },
  {
    code: '41-67',
    name: 'Сэргэлэн',
  },
  {
    code: '64-49',
    name: 'Өлзийт',
  },
  {
    code: '43-04',
    name: 'Алтанбулаг',
  },
  {
    code: '65-19',
    name: 'Өлзийт',
  },
  {
    code: '48-19',
    name: 'Дэлгэрцогт',
  },
  {
    code: '82-16',
    name: 'Дарив',
  },
  {
    code: '81-49',
    name: 'Тэс',
  },
  {
    code: '82-19',
    name: 'Дэлгэр',
  },
  {
    code: '41-61',
    name: 'Өндөрширээт',
  },
  {
    code: '48-16',
    name: 'Дэлгэрхангай',
  },
  {
    code: '82-13',
    name: 'Бугат',
  },
  {
    code: '81-46',
    name: 'Тэлмэн',
  },
  {
    code: '64-40',
    name: 'Жаргалант',
  },
  {
    code: '43-01',
    name: 'Сүхбаатар',
  },
  {
    code: '81-40',
    name: 'Тосонцэнгэл',
  },
  {
    code: '65-10',
    name: 'Жаргалант',
  },
  {
    code: '41-64',
    name: 'Сүмбэр',
  },
  {
    code: '48-13',
    name: 'Гурвансайхан',
  },
  {
    code: '82-10',
    name: 'Бигэр',
  },
  {
    code: '48-10',
    name: 'Говь-Угтаал',
  },
  {
    code: '81-43',
    name: 'Түдэвтэй',
  },
  {
    code: '64-43',
    name: 'Жинст',
  },
  {
    code: '65-25',
    name: 'Тариат',
  },
  {
    code: '41-58',
    name: 'Мөнгөнморьт',
  },
  {
    code: '81-70',
    name: 'Яруу',
  },
  {
    code: '82-40',
    name: 'Цогт',
  },
  {
    code: '64-58',
    name: 'Эрдэнэцогт',
  },
  {
    code: '41-55',
    name: 'Лүн',
  },
  {
    code: '65-28',
    name: 'Төвшрүүлэх',
  },
  {
    code: '48-07',
    name: 'Баянжаргалан',
  },
  {
    code: '82-49',
    name: 'Шарга',
  },
  {
    code: '83-19',
    name: 'Буянт',
  },
  {
    code: '82-46',
    name: 'Чандмань',
  },
  {
    code: '83-13',
    name: 'Бугат',
  },
  {
    code: '83-16',
    name: 'Булган',
  },
  {
    code: '48-04',
    name: 'Адаацаг',
  },
  {
    code: '83-10',
    name: 'Баяннуур',
  },
  {
    code: '48-01',
    name: 'Сайнцагаан',
  },
  {
    code: '64-52',
    name: 'Хүрээмарал',
  },
  {
    code: '82-43',
    name: 'Цээл',
  },
  {
    code: '64-55',
    name: 'Шинэжинст',
  },
  {
    code: '41-52',
    name: 'Заамар',
  },
  {
    code: '65-22',
    name: 'Өндөр-Улаан',
  },
  {
    code: '41-46',
    name: 'Дэлгэрхаан',
  },
  {
    code: '81-61',
    name: 'Цэцэн-Уул',
  },
  {
    code: '65-37',
    name: 'Хашаат',
  },
  {
    code: '41-49',
    name: 'Жаргалант',
  },
  {
    code: '83-07',
    name: 'Алтанцөгц',
  },
  {
    code: '82-34',
    name: 'Халиун',
  },
  {
    code: '81-67',
    name: 'Эрдэнэхайрхан',
  },
  {
    code: '82-37',
    name: 'Хөхморьт',
  },
  {
    code: '83-04',
    name: 'Алтай',
  },
  {
    code: '41-43',
    name: 'Бүрэн',
  },
  {
    code: '82-31',
    name: 'Төгрөг',
  },
  {
    code: '65-31',
    name: 'Хайрхан',
  },
  {
    code: '81-64',
    name: 'Шилүүстэй',
  },
  {
    code: '83-01',
    name: 'Өлгий',
  },
  {
    code: '65-34',
    name: 'Хангай',
  },
  {
    code: '41-40',
    name: 'Борнуур',
  },
  {
    code: '65-46',
    name: 'Цэнхэр',
  },
  {
    code: '65-49',
    name: 'Цэцэрлэг',
  },
  {
    code: '41-34',
    name: 'Баянцогт',
  },
  {
    code: '42-07',
    name: 'Шивээговь',
  },
  {
    code: '42-01',
    name: 'Сүмбэр',
  },
  {
    code: '41-37',
    name: 'Баянчандмань',
  },
  {
    code: '42-04',
    name: 'Баянтал',
  },
  {
    code: '23-49',
    name: 'Цэнхэрмандал',
  },
  {
    code: '23-40',
    name: 'Мөрөн',
  },
  {
    code: '46-40',
    name: 'Цогт-Овоо',
  },
  {
    code: '23-43',
    name: 'Норовлин',
  },
  {
    code: '84-07',
    name: 'Булган',
  },
  {
    code: '23-46',
    name: 'Өмнөдэлгэр',
  },
  {
    code: '84-04',
    name: 'Алтай',
  },
  {
    code: '61-04',
    name: 'Жаргалант',
  },
  {
    code: '83-37',
    name: 'Цэнгэл',
  },
  {
    code: '65-40',
    name: 'Хотонт',
  },
  {
    code: '65-43',
    name: 'Цахир',
  },
  {
    code: '46-43',
    name: 'Цогтцэций',
  },
  {
    code: '61-01',
    name: 'Баян-Өндөр',
  },
  {
    code: '83-31',
    name: 'Толбо',
  },
  {
    code: '41-31',
    name: 'Баянцагаан',
  },
  {
    code: '83-34',
    name: 'Улаанхус',
  },
  {
    code: '84-01',
    name: 'Жаргалант',
  },
  {
    code: '41-25',
    name: 'Баян-Өнжүүл',
  },
  {
    code: '41-22',
    name: 'Баянжаргалан',
  },
  {
    code: '41-28',
    name: 'Баянхангай',
  },
  {
    code: '23-52',
    name: 'Бор-Өндөр',
  },
  {
    code: '83-28',
    name: 'Сагсай',
  },
  {
    code: '83-25',
    name: 'Ногооннуур',
  },
  {
    code: '46-37',
    name: 'Хүрмэн',
  },
  {
    code: '65-52',
    name: 'Чулуут',
  },
  {
    code: '46-34',
    name: 'Ханхонгор',
  },
  {
    code: '82-52',
    name: 'Эрдэнэ',
  },
  {
    code: '83-22',
    name: 'Дэлүүн',
  },
  {
    code: '65-55',
    name: 'Эрдэнэмандал',
  },
  {
    code: '46-31',
    name: 'Ханбогд',
  },
  {
    code: '67-07',
    name: 'Арбулаг',
  },
  {
    code: '41-13',
    name: 'Батсүмбэр',
  },
  {
    code: '67-04',
    name: 'Алаг-Эрдэнэ',
  },
  {
    code: '41-16',
    name: 'Баян',
  },
  {
    code: '46-28',
    name: 'Сэврэй',
  },
  {
    code: '23-28',
    name: 'Дадал',
  },
  {
    code: '41-19',
    name: 'Баяндэлгэр',
  },
  {
    code: '23-22',
    name: 'Биндэр',
  },
  {
    code: '23-25',
    name: 'Галшар',
  },
  {
    code: '46-25',
    name: 'Номгон',
  },
  {
    code: '84-25',
    name: 'Манхан',
  },
  {
    code: '84-28',
    name: 'Мөнххайрхан',
  },
  {
    code: '84-22',
    name: 'Зэрэг',
  },
  {
    code: '41-10',
    name: 'Архуст',
  },
  {
    code: '46-22',
    name: 'Ноён',
  },
  {
    code: '67-01',
    name: 'Мөрөн',
  },
  {
    code: '62-01',
    name: 'Арвайхээр',
  },
  {
    code: '41-01',
    name: 'Зуунмод',
  },
  {
    code: '67-16',
    name: 'Галт',
  },
  {
    code: '41-07',
    name: 'Аргалант',
  },
  {
    code: '62-04',
    name: 'Баруунбаян-Улаан',
  },
  {
    code: '46-19',
    name: 'Манлай',
  },
  {
    code: '67-19',
    name: 'Жаргалант',
  },
  {
    code: '46-16',
    name: 'Мандал-Овоо',
  },
  {
    code: '41-04',
    name: 'Алтанбулаг',
  },
  {
    code: '62-07',
    name: 'Бат-Өлзий',
  },
  {
    code: '23-37',
    name: 'Жаргалтхаан',
  },
  {
    code: '23-31',
    name: 'Дархан',
  },
  {
    code: '84-19',
    name: 'Дуут',
  },
  {
    code: '23-34',
    name: 'Дэлгэрхаан',
  },
  {
    code: '67-10',
    name: 'Баянзүрх',
  },
  {
    code: '84-16',
    name: 'Дөргөн',
  },
  {
    code: '46-13',
    name: 'Гурвантэс',
  },
  {
    code: '67-13',
    name: 'Бүрэнтогтох',
  },
  {
    code: '46-10',
    name: 'Булган',
  },
  {
    code: '84-10',
    name: 'Буянт',
  },
  {
    code: '84-13',
    name: 'Дарви',
  },
  {
    code: '84-40',
    name: 'Ховд',
  },
  {
    code: '67-28',
    name: 'Рэнчинлхүмбэ',
  },
  {
    code: '62-10',
    name: 'Баянгол',
  },
  {
    code: '85-10',
    name: 'Давст',
  },
  {
    code: '62-13',
    name: 'Баян-Өндөр',
  },
  {
    code: '46-07',
    name: 'Баян-Овоо',
  },
  {
    code: '11-22',
    name: 'Хан-Уул',
  },
  {
    code: '62-16',
    name: 'Богд',
  },
  {
    code: '23-04',
    name: 'Батноров',
  },
  {
    code: '62-19',
    name: 'Бүрд',
  },
  {
    code: '22-37',
    name: 'Эрдэнэцагаан',
  },
  {
    code: '23-07',
    name: 'Батширээт',
  },
  {
    code: '22-31',
    name: 'Уулбаян',
  },
  {
    code: '85-19',
    name: 'Зүүнхангай',
  },
  {
    code: '23-01',
    name: 'Хэрлэн',
  },
  {
    code: '22-34',
    name: 'Халзан',
  },
  {
    code: '85-16',
    name: 'Зүүнговь',
  },
  {
    code: '46-04',
    name: 'Баяндалай',
  },
  {
    code: '11-25',
    name: 'Чингэлтэй',
  },
  {
    code: '46-01',
    name: 'Даланзадгад',
  },
  {
    code: '84-49',
    name: 'Эрдэнэбүрэн',
  },
  {
    code: '84-43',
    name: 'Цэцэг',
  },
  {
    code: '67-25',
    name: 'Рашаант',
  },
  {
    code: '84-46',
    name: 'Чандмань',
  },
  {
    code: '67-22',
    name: 'Их-Уул',
  },
  {
    code: '85-13',
    name: 'Завхан',
  },
  {
    code: '62-22',
    name: 'Гучин-Ус',
  },
  {
    code: '84-31',
    name: 'Мөст',
  },
  {
    code: '67-37',
    name: 'Төмөрбулаг',
  },
  {
    code: '62-25',
    name: 'Есөн Зүйл',
  },
  {
    code: '62-28',
    name: 'Зүүнбаян-Улаан',
  },
  {
    code: '23-16',
    name: 'Баян-Овоо',
  },
  {
    code: '23-19',
    name: 'Баянхутаг',
  },
  {
    code: '23-10',
    name: 'Баян-Адарга',
  },
  {
    code: '23-13',
    name: 'Баянмөнх',
  },
  {
    code: '84-37',
    name: 'Үенч',
  },
  {
    code: '67-31',
    name: 'Тариалан',
  },
  {
    code: '85-04',
    name: 'Баруунтуруун',
  },
  {
    code: '85-07',
    name: 'Бөхмөрөн',
  },
  {
    code: '85-01',
    name: 'Улаангом',
  },
  {
    code: '84-34',
    name: 'Мянгад',
  },
  {
    code: '67-34',
    name: 'Тосонцэнгэл',
  },
]

const Commissions = [
  {
    code: '83-28-053',
    name: '2-р баг, Хол агаш',
  },
  {
    code: '83-28-055',
    name: '3-р баг, Ахкорим',
  },
  {
    code: '83-28-057',
    name: '4-р баг, Хаг',
  },
  {
    code: '83-28-059',
    name: '5-р баг, Уужим',
  },
  {
    code: '83-28-051',
    name: '1-р баг, Ямаат',
  },
  {
    code: '84-07-061',
    name: '6-р баг, Бүрэнхайрхан',
  },
  {
    code: '43-07-055',
    name: '3-р баг, Цагаан-Овоо',
  },
  {
    code: '43-07-053',
    name: '2-р баг, Бургалтай',
  },
  {
    code: '43-07-051',
    name: '1-р баг, Ивэн',
  },
  {
    code: '23-19-055',
    name: '3-р баг, Цантын хоолой',
  },
  {
    code: '23-19-053',
    name: '2-р баг, Улаан-Өндөр',
  },
  {
    code: '23-19-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '83-28-061',
    name: '6-р баг, Даян',
  },
  {
    code: '81-25-057',
    name: '4-р баг, Хонгор',
  },
  {
    code: '81-25-059',
    name: '5-р баг, Цэцүүх',
  },
  {
    code: '81-25-053',
    name: '2-р баг, Үржил',
  },
  {
    code: '81-25-055',
    name: '3-р баг, Хуягт',
  },
  {
    code: '81-16-055',
    name: '3-р баг, Тавантолгой',
  },
  {
    code: '81-25-051',
    name: '1-р баг, Баян-Ухаа',
  },
  {
    code: '81-16-057',
    name: '4-р баг, Буурал',
  },
  {
    code: '81-16-051',
    name: '1-р баг, Буга',
  },
  {
    code: '81-16-053',
    name: '2-р баг, Цогт',
  },
  {
    code: '83-37-061',
    name: '6-р баг, Уст тохой',
  },
  {
    code: '83-37-063',
    name: '7-р баг, Долоон гаталга',
  },
  {
    code: '83-37-065',
    name: '8-р баг, Партизан',
  },
  {
    code: '81-25-061',
    name: '6-р баг, Зарт',
  },
  {
    code: '83-37-067',
    name: '9-р баг, Хөшөөт',
  },
  {
    code: '48-40-053',
    name: '2-р баг, Дэлгэрэх зам',
  },
  {
    code: '48-40-051',
    name: '1-р баг, Хараат',
  },
  {
    code: '48-40-057',
    name: '4-р баг, Замын-Улаан',
  },
  {
    code: '48-40-055',
    name: '3-р баг, Жаргалант',
  },
  {
    code: '83-19-053',
    name: '2-р баг, Хөлцөөт',
  },
  {
    code: '83-19-051',
    name: '1-р баг, Хөх эрэг',
  },
  {
    code: '83-19-057',
    name: '4-р баг, Шар тохойт',
  },
  {
    code: '83-19-055',
    name: '3-р баг, Өмнөгол',
  },
  {
    code: '41-67-059',
    name: '5-р баг, Авдар',
  },
  {
    code: '41-67-053',
    name: '2-р баг, Хайрхан',
  },
  {
    code: '41-67-051',
    name: '1-р баг, Баянбүрд',
  },
  {
    code: '41-67-057',
    name: '4-р баг, Эрдэнэ-Уул',
  },
  {
    code: '41-67-055',
    name: '3-р баг, Хөшиг',
  },
  {
    code: '41-49-055',
    name: '3-р баг, Баянбулаг',
  },
  {
    code: '81-16-059',
    name: '5-р баг, Онц',
  },
  {
    code: '41-49-057',
    name: '4-р баг, Загдал',
  },
  {
    code: '41-49-051',
    name: '1-р баг, Буурал',
  },
  {
    code: '41-49-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '84-16-055',
    name: '3-р баг, Аргалант',
  },
  {
    code: '84-16-057',
    name: '4-р баг, Өгөөмөр',
  },
  {
    code: '84-16-051',
    name: '1-р баг, Агваш',
  },
  {
    code: '84-16-053',
    name: '2-р баг, Сээр',
  },
  {
    code: '43-16-053',
    name: '2-р баг, Моностой',
  },
  {
    code: '62-16-059',
    name: '5-р баг, Далан',
  },
  {
    code: '43-16-051',
    name: '1-р баг, Бумбат',
  },
  {
    code: '62-16-057',
    name: '4-р баг, Гүн-Ус',
  },
  {
    code: '62-16-055',
    name: '3-р баг, Баян төхөм',
  },
  {
    code: '62-16-053',
    name: '2-р баг, Хөөвөр',
  },
  {
    code: '62-16-051',
    name: '1-р баг, Өлзийт хошуу',
  },
  {
    code: '64-19-055',
    name: '3-р баг, Булган',
  },
  {
    code: '64-19-053',
    name: '2-р баг, Элгэн',
  },
  {
    code: '82-49-057',
    name: '4-р баг, Улаан туг',
  },
  {
    code: '82-49-055',
    name: '3-р баг, Сондуулт',
  },
  {
    code: '64-19-057',
    name: '4-р баг, Идрэн',
  },
  {
    code: '82-49-053',
    name: '2-р баг, Хамтын хүч',
  },
  {
    code: '82-49-051',
    name: '1-р баг, Баянгол',
  },
  {
    code: '21-16-051',
    name: '1-р баг, Рашаант',
  },
  {
    code: '64-19-051',
    name: '1-р баг, Улаан үзүүр',
  },
  {
    code: '21-16-055',
    name: '3-р баг, Сүмийн булаг',
  },
  {
    code: '21-16-053',
    name: '2-р баг, Цагаан хошуу',
  },
  {
    code: '62-16-063',
    name: '7-р баг, Ховд',
  },
  {
    code: '62-16-061',
    name: '6-р баг, Ялаатай',
  },
  {
    code: '61-01-083',
    name: '17-р баг, Эрдэнэ',
  },
  {
    code: '61-01-085',
    name: '18-р баг, Баянбулаг',
  },
  {
    code: '61-01-087',
    name: '19-р баг, Их залуу',
  },
  {
    code: '63-04-059',
    name: '5-р баг, Халтар',
  },
  {
    code: '61-01-089',
    name: '20-р баг, Даваат',
  },
  {
    code: '63-04-057',
    name: '4-р баг, Дулаанхаан',
  },
  {
    code: '63-04-055',
    name: '3-р баг, Баянхайрхан',
  },
  {
    code: '63-04-053',
    name: '2-р баг, Баянзүрх',
  },
  {
    code: '63-04-051',
    name: '1-р баг, Шарга',
  },
  {
    code: '61-01-081',
    name: '16-р баг, Малчин',
  },
  {
    code: '23-37-057',
    name: '4-р баг, Чулуут',
  },
  {
    code: '61-01-071',
    name: '11-р баг, Цагаанчулуут',
  },
  {
    code: '23-37-059',
    name: '5-р баг, Төвийн',
  },
  {
    code: '61-01-073',
    name: '12-р баг, Булаг',
  },
  {
    code: '23-37-053',
    name: '2-р баг, Баянцогт',
  },
  {
    code: '21-34-061',
    name: '6-р баг, Хөөвөр',
  },
  {
    code: '61-01-075',
    name: '13-р баг, Баянцагаан',
  },
  {
    code: '67-19-059',
    name: '5-р баг, Оргил',
  },
  {
    code: '23-37-055',
    name: '3-р баг, Баян-Эрдэнэ',
  },
  {
    code: '61-01-077',
    name: '14-р баг, Говил',
  },
  {
    code: '67-19-057',
    name: '4-р баг, Харгана',
  },
  {
    code: '61-01-079',
    name: '15-р баг, Рашаант',
  },
  {
    code: '67-19-055',
    name: '3-р баг, Цагаан бургас',
  },
  {
    code: '67-19-053',
    name: '2-р баг, Цэцүүх',
  },
  {
    code: '63-04-061',
    name: '6-р баг, Хүрэмт',
  },
  {
    code: '67-19-051',
    name: '1-р баг, Хөнжил',
  },
  {
    code: '82-13-059',
    name: '5-р баг, Баянгол',
  },
  {
    code: '82-13-055',
    name: '3-р баг, Гаханч',
  },
  {
    code: '81-34-053',
    name: '2-р баг, Баяннуур',
  },
  {
    code: '82-13-057',
    name: '4-р баг, Сүж',
  },
  {
    code: '81-34-051',
    name: '1-р баг, Баян-Улаан',
  },
  {
    code: '82-13-051',
    name: '1-р баг, Биж',
  },
  {
    code: '81-34-057',
    name: '4-р баг, Холбоо',
  },
  {
    code: '23-37-051',
    name: '1-р баг, Гичгэнэ',
  },
  {
    code: '82-13-053',
    name: '2-р баг, Ферм',
  },
  {
    code: '81-34-055',
    name: '3-р баг, Баяндавс',
  },
  {
    code: '62-25-053',
    name: '2-р баг, Мөнхбулаг',
  },
  {
    code: '62-25-055',
    name: '3-р баг, Хайрхан',
  },
  {
    code: '21-34-051',
    name: '1-р баг, Баянгол',
  },
  {
    code: '62-25-051',
    name: '1-р баг, Тахилга',
  },
  {
    code: '62-25-057',
    name: '4-р баг, Эрээн',
  },
  {
    code: '41-76-051',
    name: '1-р баг, Өгөөмөр',
  },
  {
    code: '23-46-061',
    name: '6-р баг, Төвийн',
  },
  {
    code: '65-07-057',
    name: '4-р баг, Баянбулаг',
  },
  {
    code: '41-76-053',
    name: '2-р баг, Чулуут',
  },
  {
    code: '23-46-063',
    name: '7-р баг, Гурванбаян',
  },
  {
    code: '65-07-055',
    name: '3-р баг, Тамир',
  },
  {
    code: '41-76-055',
    name: '3-р баг, Баянтуул',
  },
  {
    code: '41-76-057',
    name: '4-р баг, Хушинга',
  },
  {
    code: '85-49-053',
    name: '2-р баг, Шивэр',
  },
  {
    code: '41-76-059',
    name: '5-р баг, Тамган',
  },
  {
    code: '85-49-051',
    name: '1-р баг, Ховд',
  },
  {
    code: '21-34-053',
    name: '2-р баг, Элст',
  },
  {
    code: '85-49-057',
    name: '4-р баг, Халиунбулаг',
  },
  {
    code: '21-34-055',
    name: '3-р баг, Зүрх',
  },
  {
    code: '85-49-055',
    name: '3-р баг, Ачит',
  },
  {
    code: '21-34-057',
    name: '4-р баг, Хүрээт',
  },
  {
    code: '65-07-053',
    name: '2-р баг, Зуунмод',
  },
  {
    code: '21-34-059',
    name: '5-р баг, Гүн цэнгэлэг',
  },
  {
    code: '65-07-051',
    name: '1-р баг, Тусгалт',
  },
  {
    code: '61-01-093',
    name: '22-р баг, Яргуйт',
  },
  {
    code: '67-31-059',
    name: '5-р баг, Баянхошуу',
  },
  {
    code: '23-46-059',
    name: '5-р баг, Чандган',
  },
  {
    code: '23-46-055',
    name: '3-р баг, Хэнтий',
  },
  {
    code: '23-46-057',
    name: '4-р баг, Талын булаг',
  },
  {
    code: '23-46-051',
    name: '1-р баг, Наран',
  },
  {
    code: '23-46-053',
    name: '2-р баг, Баянзүрх',
  },
  {
    code: '67-31-057',
    name: '4-р баг, Сэлэнгэ',
  },
  {
    code: '67-31-055',
    name: '3-р баг, Таван толгой',
  },
  {
    code: '67-31-053',
    name: '2-р баг, Ар тархи',
  },
  {
    code: '67-31-051',
    name: '1-р баг, Мандал',
  },
  {
    code: '61-01-091',
    name: '21-р баг, Уртын гол',
  },
  {
    code: '41-04-051',
    name: '1-р баг, Сумт',
  },
  {
    code: '11-22-079',
    name: '15-р хороо',
  },
  {
    code: '11-22-077',
    name: '14-р хороо',
  },
  {
    code: '41-04-055',
    name: '3-р баг, Алтан-Овоо',
  },
  {
    code: '83-37-051',
    name: '1-р баг, Шарговь',
  },
  {
    code: '41-04-053',
    name: '2-р баг, Аргал',
  },
  {
    code: '83-37-053',
    name: '2-р баг, Загаст нуур',
  },
  {
    code: '83-37-055',
    name: '3-р баг, Цагаан түнгэ',
  },
  {
    code: '41-04-057',
    name: '4-р баг, Замт',
  },
  {
    code: '83-37-057',
    name: '4-р баг, Хар уул',
  },
  {
    code: '83-37-059',
    name: '5-р баг, Бор бургас',
  },
  {
    code: '64-28-051',
    name: '1-р баг, Улаан сайр',
  },
  {
    code: '64-28-053',
    name: '2-р баг, Хөх толгой',
  },
  {
    code: '11-22-071',
    name: '11-р хороо',
  },
  {
    code: '64-28-055',
    name: '3-р баг, Бургас',
  },
  {
    code: '64-28-057',
    name: '4-р баг, Задгай',
  },
  {
    code: '11-22-075',
    name: '13-р хороо',
  },
  {
    code: '11-22-073',
    name: '12-р хороо',
  },
  {
    code: '67-31-061',
    name: '6-р баг, Давааны ар',
  },
  {
    code: '21-07-051',
    name: '1-р баг, Цагаан дэрс',
  },
  {
    code: '21-07-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '83-01-075',
    name: '13-р баг, Жана ауыл',
  },
  {
    code: '21-07-055',
    name: '3-р баг, Өлзийт',
  },
  {
    code: '83-01-071',
    name: '11-р баг, Бүркит',
  },
  {
    code: '21-07-057',
    name: '4-р баг, Хотонт',
  },
  {
    code: '83-01-073',
    name: '12-р баг, Жасыл бах',
  },
  {
    code: '85-04-057',
    name: '4-р баг, Зүүн туруун',
  },
  {
    code: '84-25-051',
    name: '1-р баг, Тахилт',
  },
  {
    code: '84-25-053',
    name: '2-р баг, Зэрэг гол',
  },
  {
    code: '84-25-055',
    name: '3-р баг, Улаан хүрээ',
  },
  {
    code: '84-25-057',
    name: '4-р баг, Баянгол',
  },
  {
    code: '11-22-081',
    name: '16-р хороо',
  },
  {
    code: '85-04-051',
    name: '1-р баг, Туруун',
  },
  {
    code: '84-25-059',
    name: '5-р баг, Ботгон',
  },
  {
    code: '85-04-053',
    name: '2-р баг, Шанд',
  },
  {
    code: '85-04-055',
    name: '3-р баг, Баян-Айраг',
  },
  {
    code: '61-01-061',
    name: '6-р баг, Согоот',
  },
  {
    code: '11-22-057',
    name: '4-р хороо',
  },
  {
    code: '61-01-063',
    name: '7-р баг, Дэнж',
  },
  {
    code: '11-22-055',
    name: '3-р хороо',
  },
  {
    code: '61-01-065',
    name: '8-р баг, Бүрэнбүст',
  },
  {
    code: '83-01-069',
    name: '10-р баг, Харасай',
  },
  {
    code: '61-01-067',
    name: '9-р баг, Шанд',
  },
  {
    code: '11-22-059',
    name: '5-р хороо',
  },
  {
    code: '61-01-069',
    name: '10-р баг, Наран',
  },
  {
    code: '83-01-065',
    name: '8-р баг, Ах хус тау',
  },
  {
    code: '83-01-067',
    name: '9-р баг, Хөх хад',
  },
  {
    code: '83-01-061',
    name: '6-р баг, Хөх толгой',
  },
  {
    code: '83-01-063',
    name: '7-р баг, Хотгор',
  },
  {
    code: '84-25-061',
    name: '6-р баг, Төгрөг гол',
  },
  {
    code: '81-07-053',
    name: '1-р баг, Суварга',
  },
  {
    code: '81-07-051',
    name: '2-р баг, Аргалант',
  },
  {
    code: '11-22-053',
    name: '2-р хороо',
  },
  {
    code: '11-22-051',
    name: '1-р хороо',
  },
  {
    code: '11-22-069',
    name: '10-р хороо',
  },
  {
    code: '11-22-067',
    name: '9-р хороо',
  },
  {
    code: '61-01-051',
    name: '1-р баг, Зэст',
  },
  {
    code: '83-01-057',
    name: '4-р баг, Их булан',
  },
  {
    code: '61-01-053',
    name: '2-р баг, Оюут',
  },
  {
    code: '83-01-059',
    name: '5-р баг, Ховд гол',
  },
  {
    code: '61-01-055',
    name: '3-р баг, Уурхайчин',
  },
  {
    code: '83-01-053',
    name: '2-р баг, Цагаан эрэг',
  },
  {
    code: '61-01-057',
    name: '4-р баг, Хүрэнбулаг',
  },
  {
    code: '64-40-057',
    name: '4-р баг, Эмээл толгой',
  },
  {
    code: '83-01-055',
    name: '3-р баг, Бөхөн-Уул',
  },
  {
    code: '61-01-059',
    name: '5-р баг, Уртбулаг',
  },
  {
    code: '83-01-051',
    name: '1-р баг, Хуст арал',
  },
  {
    code: '64-40-051',
    name: '1-р баг, Намтолгой',
  },
  {
    code: '64-40-055',
    name: '3-р баг, Хөндлөн булаг',
  },
  {
    code: '64-40-053',
    name: '2-р баг, Өлзийт-Өндөр',
  },
  {
    code: '11-22-061',
    name: '6-р хороо',
  },
  {
    code: '46-10-055',
    name: '3-р баг, Хавцгайт',
  },
  {
    code: '46-10-057',
    name: '4-р баг, Булган',
  },
  {
    code: '11-22-065',
    name: '8-р хороо',
  },
  {
    code: '46-10-051',
    name: '1-р баг, Дэн',
  },
  {
    code: '11-22-063',
    name: '7-р хороо',
  },
  {
    code: '46-10-053',
    name: '2-р баг, Дал',
  },
  {
    code: '64-55-057',
    name: '4-р баг, Эхэн хавцгай',
  },
  {
    code: '67-37-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '64-55-053',
    name: '2-р баг, Уртын гол',
  },
  {
    code: '64-55-055',
    name: '3-р баг, Эрдэнэшанд',
  },
  {
    code: '22-22-055',
    name: '3-р баг, Хулгар',
  },
  {
    code: '44-13-057',
    name: '4-р баг, Хонгор',
  },
  {
    code: '22-22-057',
    name: '4-р баг, Ланз',
  },
  {
    code: '22-22-059',
    name: '5-р баг, Шинэбулаг',
  },
  {
    code: '44-13-053',
    name: '2-р баг, Аман шанд',
  },
  {
    code: '44-13-055',
    name: '3-р баг, Бумбат',
  },
  {
    code: '44-13-051',
    name: '1-р баг, Цагаанхад',
  },
  {
    code: '22-22-051',
    name: '1-р баг, Баянгол',
  },
  {
    code: '22-22-053',
    name: '2-р баг, Хайлааст',
  },
  {
    code: '67-37-055',
    name: '3-р баг, Тариат',
  },
  {
    code: '67-37-053',
    name: '2-р баг, Нарийн',
  },
  {
    code: '64-55-051',
    name: '1-р баг, Зараа',
  },
  {
    code: '67-37-059',
    name: '5-р баг, Сумын төв',
  },
  {
    code: '67-37-057',
    name: '4-р баг, Тээл',
  },
  {
    code: '41-70-055',
    name: '3-р баг, Хар чулуут',
  },
  {
    code: '81-52-051',
    name: '1-р баг, Тосгуур',
  },
  {
    code: '46-01-055',
    name: '3-р баг, Далан',
  },
  {
    code: '67-22-057',
    name: '4-р баг, Мандал',
  },
  {
    code: '81-52-053',
    name: '2-р баг, Хульж',
  },
  {
    code: '82-31-059',
    name: '5-р баг, Тунгалаг',
  },
  {
    code: '46-01-053',
    name: '2-р баг, Хан-Уул',
  },
  {
    code: '67-22-059',
    name: '5-р баг, Сэлэнгэ',
  },
  {
    code: '41-70-051',
    name: '1-р баг, Талын уул',
  },
  {
    code: '81-52-055',
    name: '3-р баг, Нуур зөөхий',
  },
  {
    code: '46-01-051',
    name: '1-р баг, Баруунсайхан',
  },
  {
    code: '41-70-053',
    name: '2-р баг, Асгат',
  },
  {
    code: '81-52-057',
    name: '4-р баг, Хүнгий',
  },
  {
    code: '81-52-059',
    name: '5-р баг, Баян-Улаан',
  },
  {
    code: '82-31-053',
    name: '2-р баг, Төгрөгийн эх',
  },
  {
    code: '82-31-051',
    name: '1-р баг, Хүрэн гол',
  },
  {
    code: '82-31-057',
    name: '4-р баг, Цагаан хайрхан',
  },
  {
    code: '82-31-055',
    name: '3-р баг, Мааньт',
  },
  {
    code: '65-34-061',
    name: '6-р баг, Ноён хангай',
  },
  {
    code: '67-22-051',
    name: '1-р баг, Шивээ',
  },
  {
    code: '46-01-059',
    name: '5-р баг, Зүүнсайхан',
  },
  {
    code: '67-22-053',
    name: '2-р баг, Их-уул',
  },
  {
    code: '46-01-057',
    name: '4-р баг, Дундсайхан',
  },
  {
    code: '67-22-055',
    name: '3-р баг, Асгат',
  },
  {
    code: '46-01-065',
    name: '8-р баг, Цагаан булаг',
  },
  {
    code: '46-01-063',
    name: '7-р баг, Оюут',
  },
  {
    code: '43-34-053',
    name: '2-р баг, Хушаат',
  },
  {
    code: '46-01-061',
    name: '6-р баг, Их уул',
  },
  {
    code: '46-16-051',
    name: '1-р баг, Өтгөн',
  },
  {
    code: '65-34-059',
    name: '5-р баг, Тэрх',
  },
  {
    code: '65-34-057',
    name: '4-р баг, Баян-Улаан',
  },
  {
    code: '65-34-055',
    name: '3-р баг, Арбаясгалан',
  },
  {
    code: '65-34-053',
    name: '2-р баг, Гичгэнэ',
  },
  {
    code: '65-34-051',
    name: '1-р баг, Чандмань',
  },
  {
    code: '43-43-053',
    name: '2-р баг, Мөнхтолгой',
  },
  {
    code: '43-43-051',
    name: '1-р баг, Даагат',
  },
  {
    code: '46-16-055',
    name: '3-р баг, Мандал',
  },
  {
    code: '43-34-051',
    name: '1-р баг, Ивэн',
  },
  {
    code: '46-16-053',
    name: '2-р баг, Баянхошуу',
  },
  {
    code: '41-31-053',
    name: '2-р баг, Баян айраг',
  },
  {
    code: '23-31-051',
    name: '1-р баг, Дотуур булаг',
  },
  {
    code: '41-31-051',
    name: '1-р баг, Өлзийт',
  },
  {
    code: '23-31-053',
    name: '2-р баг, Хараат',
  },
  {
    code: '23-31-055',
    name: '3-р баг, Шажин',
  },
  {
    code: '23-31-057',
    name: '4-р баг, Мэргэн хошуу',
  },
  {
    code: '23-31-059',
    name: '5-р баг, Бор-Өндөр',
  },
  {
    code: '84-34-057',
    name: '4-р баг, Цагаанбулан',
  },
  {
    code: '41-31-059',
    name: '5-р баг, Зогсоол',
  },
  {
    code: '84-34-055',
    name: '3-р баг, Гахайт',
  },
  {
    code: '41-31-057',
    name: '4-р баг, Алтат',
  },
  {
    code: '84-34-053',
    name: '2-р баг, Баянбулаг',
  },
  {
    code: '41-31-055',
    name: '3-р баг, Гурван түрүү',
  },
  {
    code: '84-34-051',
    name: '1-р баг, Чацаргант',
  },
  {
    code: '84-34-059',
    name: '5-р баг, Баянхошуу',
  },
  {
    code: '22-13-055',
    name: '3-р баг, Баянцагаан',
  },
  {
    code: '22-13-053',
    name: '2-р баг, Баян-Уул',
  },
  {
    code: '22-13-059',
    name: '5-р баг, Бүрэнцогт',
  },
  {
    code: '22-13-057',
    name: '4-р баг, Баясгалант',
  },
  {
    code: '48-04-057',
    name: '4-р баг, Сүм',
  },
  {
    code: '48-04-055',
    name: '3-р баг, Өвөр-Урт',
  },
  {
    code: '48-04-059',
    name: '5-р баг, Хашаат',
  },
  {
    code: '83-10-053',
    name: '2-р баг, Баяннуур',
  },
  {
    code: '83-10-051',
    name: '1-р баг, Цэцэгт',
  },
  {
    code: '48-04-053',
    name: '2-р баг, Ар-Урт',
  },
  {
    code: '83-10-057',
    name: '4-р баг, Шар цэхээ',
  },
  {
    code: '48-04-051',
    name: '1-р баг, Тавин',
  },
  {
    code: '83-10-055',
    name: '3-р баг, Цагаан арал',
  },
  {
    code: '83-10-059',
    name: '5-р баг, Цул улаан',
  },
  {
    code: '22-13-051',
    name: '1-р баг, баянтэрэм',
  },
  {
    code: '63-31-061',
    name: '6-р баг, Сайхан-Овоо',
  },
  {
    code: '41-40-055',
    name: '3-р баг, Бичигт',
  },
  {
    code: '41-40-053',
    name: '2-р баг, Мандал',
  },
  {
    code: '41-40-051',
    name: '1-р баг, Өгөөмөр',
  },
  {
    code: '41-40-057',
    name: '4-р баг, Нарт',
  },
  {
    code: '11-13-051',
    name: '1-р хороо',
  },
  {
    code: '65-16-051',
    name: '2-р баг, Дойт',
  },
  {
    code: '65-16-053',
    name: '1-р баг, Тоглох',
  },
  {
    code: '65-16-055',
    name: '3-р баг, Өгий',
  },
  {
    code: '65-16-057',
    name: '5-р баг, Зэгстэй',
  },
  {
    code: '65-16-059',
    name: '4-р баг, Орхон',
  },
  {
    code: '11-13-057',
    name: '4-р хороо',
  },
  {
    code: '11-13-059',
    name: '5-р хороо',
  },
  {
    code: '65-01-061',
    name: '6-р баг',
  },
  {
    code: '11-13-053',
    name: '2-р хороо',
  },
  {
    code: '11-13-055',
    name: '3-р хороо',
  },
  {
    code: '65-01-059',
    name: '5-р баг',
  },
  {
    code: '85-13-051',
    name: '1-р баг, Айраг нуур',
  },
  {
    code: '65-01-057',
    name: '4-р баг',
  },
  {
    code: '85-13-053',
    name: '2-р баг, Хармагт',
  },
  {
    code: '65-01-055',
    name: '3-р баг',
  },
  {
    code: '85-13-055',
    name: '3-р баг, Хяргас нуур',
  },
  {
    code: '65-01-053',
    name: '2-р баг',
  },
  {
    code: '85-13-057',
    name: '4-р баг, Шар булаг',
  },
  {
    code: '64-10-059',
    name: '5-р баг, Өргөн',
  },
  {
    code: '64-10-055',
    name: '3-р баг, Залаа',
  },
  {
    code: '64-10-057',
    name: '4-р баг, Цоохор',
  },
  {
    code: '63-13-055',
    name: '3-р баг, Дэрст',
  },
  {
    code: '64-10-051',
    name: '1-р баг, Хэлтгий булаг',
  },
  {
    code: '63-13-057',
    name: '4-р баг, Дархан',
  },
  {
    code: '64-10-053',
    name: '2-р баг, Өрхт',
  },
  {
    code: '63-13-051',
    name: '1-р баг, Бумбат',
  },
  {
    code: '63-13-053',
    name: '2-р баг, Цахт',
  },
  {
    code: '65-01-051',
    name: '1-р баг',
  },
  {
    code: '41-13-051',
    name: '1-р баг, Мандал',
  },
  {
    code: '41-13-053',
    name: '2-р баг, цогтөндөр',
  },
  {
    code: '41-13-055',
    name: '3-р баг, Баянгол',
  },
  {
    code: '41-13-057',
    name: '4-р баг, Үдлэг',
  },
  {
    code: '64-37-057',
    name: '4-р баг, Хөвийн ам',
  },
  {
    code: '64-37-059',
    name: '5-р баг, Пионер толгой',
  },
  {
    code: '64-37-051',
    name: '1-р баг, Цэнгэл',
  },
  {
    code: '64-37-053',
    name: '2-р баг, Давааны ам',
  },
  {
    code: '64-37-055',
    name: '3-р баг, Буга',
  },
  {
    code: '11-13-061',
    name: '6-р хороо',
  },
  {
    code: '11-13-063',
    name: '7-р хороо',
  },
  {
    code: '48-31-053',
    name: '2-р баг, Талын нар',
  },
  {
    code: '48-31-051',
    name: '1-р баг, Цог',
  },
  {
    code: '62-34-053',
    name: '2-р баг, Агуйт',
  },
  {
    code: '62-34-051',
    name: '1-р баг, Бор хошуут',
  },
  {
    code: '62-34-057',
    name: '4-р баг, Гуулин',
  },
  {
    code: '62-34-055',
    name: '3-р баг, Яргайт',
  },
  {
    code: '46-43-057',
    name: '4-р баг, Өгөөмөр',
  },
  {
    code: '46-43-055',
    name: '3-р баг ,Цагаан-Овоо',
  },
  {
    code: '46-43-053',
    name: '2-р баг, Билгэх',
  },
  {
    code: '46-43-051',
    name: '1-р баг, Сийрст',
  },
  {
    code: '48-19-055',
    name: '3-р баг, Дэлгэр-Эмт',
  },
  {
    code: '64-22-051',
    name: '1-р баг, Гичгэнэ',
  },
  {
    code: '48-19-053',
    name: '2-р баг, Цахиурт',
  },
  {
    code: '48-19-051',
    name: '1-р баг, Баянбулаг',
  },
  {
    code: '64-22-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '64-22-059',
    name: '5-р баг, Баянбулаг',
  },
  {
    code: '64-22-053',
    name: '2-р баг, Дэлгэрэх',
  },
  {
    code: '64-22-055',
    name: '3-р баг, Цэцэн',
  },
  {
    code: '65-46-053',
    name: '2-р баг, Цэцэрлэг',
  },
  {
    code: '65-46-055',
    name: '3-р баг, Цэнхэр',
  },
  {
    code: '65-46-057',
    name: '4-р баг, Алтан-Овоо',
  },
  {
    code: '65-46-059',
    name: '5-р баг, Буйлан',
  },
  {
    code: '65-46-051',
    name: '1-р баг, Орхон',
  },
  {
    code: '65-46-061',
    name: '6-р баг, Тамир',
  },
  {
    code: '84-07-051',
    name: '1-р баг, Баянгол',
  },
  {
    code: '41-43-053',
    name: '2-р баг, Баянцогт',
  },
  {
    code: '84-07-055',
    name: '3-р баг, Байтаг',
  },
  {
    code: '41-43-055',
    name: '3-р баг, Монгол',
  },
  {
    code: '84-07-053',
    name: '2-р баг, Баянсудал',
  },
  {
    code: '41-43-057',
    name: '4-р баг, Эрдэнэхангай',
  },
  {
    code: '84-07-059',
    name: '5-р баг, Далт',
  },
  {
    code: '41-43-059',
    name: '5-р баг, Өнжүүл',
  },
  {
    code: '84-07-057',
    name: '4-р баг, Алагтолгой',
  },
  {
    code: '62-07-051',
    name: '1-р баг, Улаан-Ам',
  },
  {
    code: '41-43-051',
    name: '1-р баг, Төхөм',
  },
  {
    code: '62-07-059',
    name: '5-р баг, Хүйтэн',
  },
  {
    code: '62-07-057',
    name: '4-р баг, Зөрүүлэг',
  },
  {
    code: '62-07-055',
    name: '3-р баг, Өвт',
  },
  {
    code: '62-07-053',
    name: '2-р баг, Бүрэгтий',
  },
  {
    code: '85-43-051',
    name: '1-р баг, Баянхайрхан',
  },
  {
    code: '41-58-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '41-58-055',
    name: '3-р баг, Булаг',
  },
  {
    code: '41-58-053',
    name: '2-р баг, Байдлаг',
  },
  {
    code: '63-43-051',
    name: '1-р баг, Банзар',
  },
  {
    code: '82-04-051',
    name: '1-р баг, Бадрал',
  },
  {
    code: '63-43-055',
    name: '3-р баг, Тээг',
  },
  {
    code: '63-43-053',
    name: '2-р баг, Хүрэмт',
  },
  {
    code: '63-43-059',
    name: '5-р баг, Мааньт',
  },
  {
    code: '63-43-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '82-04-057',
    name: '4-р баг, Баян-Овоо',
  },
  {
    code: '82-04-055',
    name: '3-р баг, Урт',
  },
  {
    code: '85-43-055',
    name: '3-р баг, Эрдэнэхайрхан',
  },
  {
    code: '82-04-053',
    name: '2-р баг, Баянцагаан',
  },
  {
    code: '85-43-053',
    name: '2-р баг, Рашаант',
  },
  {
    code: '62-55-053',
    name: '2-р баг, Уужим',
  },
  {
    code: '84-46-055',
    name: '3-р баг, Баянхайрхан',
  },
  {
    code: '23-04-051',
    name: '1-р баг, Эрдэнэчандмань',
  },
  {
    code: '62-55-051',
    name: '1-р баг, Өвөр модот',
  },
  {
    code: '84-46-053',
    name: '2-р баг, Тахилт',
  },
  {
    code: '62-55-057',
    name: '4-р баг, Шивээт',
  },
  {
    code: '64-04-059',
    name: '5-р баг, Товгор',
  },
  {
    code: '84-46-051',
    name: '1-р баг, Талын булаг',
  },
  {
    code: '62-55-055',
    name: '3-р баг, Бэрх',
  },
  {
    code: '64-04-057',
    name: '4-р баг, Могой',
  },
  {
    code: '64-04-055',
    name: '3-р баг, Буйлсан',
  },
  {
    code: '43-46-051',
    name: '1-р баг, Оргих',
  },
  {
    code: '62-55-059',
    name: '5-р баг, Шунхлай',
  },
  {
    code: '64-04-053',
    name: '2-р баг, Оройн бууц',
  },
  {
    code: '64-04-051',
    name: '1-р баг, Баянбулаг',
  },
  {
    code: '84-46-059',
    name: '5-р баг, Урд гол',
  },
  {
    code: '84-46-057',
    name: '4-р баг, Сүлжээ',
  },
  {
    code: '43-46-053',
    name: '2-р баг, Хуурч',
  },
  {
    code: '43-46-055',
    name: '3-р баг, Тийрэг',
  },
  {
    code: '23-04-057',
    name: '4-р баг, Баянбулаг',
  },
  {
    code: '23-04-059',
    name: '5-р баг, Идэрмэг',
  },
  {
    code: '23-04-053',
    name: '2-р баг, Эхэнбүрд',
  },
  {
    code: '23-04-055',
    name: '3-р баг, Баян',
  },
  {
    code: '23-04-061',
    name: '6-р баг, Дундбүрд',
  },
  {
    code: '67-49-051',
    name: '1-р баг, Гурван сайхан',
  },
  {
    code: '67-49-053',
    name: '2-р баг, Хармай',
  },
  {
    code: '23-04-063',
    name: '7-р баг, Бэрх',
  },
  {
    code: '85-16-057',
    name: '4-р баг, Тохой',
  },
  {
    code: '85-16-055',
    name: '3-р баг, Суврага',
  },
  {
    code: '85-16-059',
    name: '5-р баг, Зэлийн гол',
  },
  {
    code: '81-01-061',
    name: '6-р баг, Өлзийт',
  },
  {
    code: '85-16-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '85-16-051',
    name: '1-р баг, Баяннуур',
  },
  {
    code: '81-01-057',
    name: '4-р баг, Богдын гол',
  },
  {
    code: '44-40-059',
    name: '5-р баг, Улаан-Уул',
  },
  {
    code: '81-01-055',
    name: '3-р баг, Чигэстэй',
  },
  {
    code: '81-01-059',
    name: '5-р баг, Товцог',
  },
  {
    code: '81-01-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '81-01-051',
    name: '1-р баг, Жинст',
  },
  {
    code: '83-13-057',
    name: '3-р баг',
  },
  {
    code: '83-13-053',
    name: '2-р баг, Улаан толгой',
  },
  {
    code: '44-40-051',
    name: '1-р баг, Бүрдэнэ',
  },
  {
    code: '83-13-055',
    name: '4-р баг, Бугын гол',
  },
  {
    code: '44-40-053',
    name: '2-р баг, Еншөөв',
  },
  {
    code: '44-40-055',
    name: '3-р баг, Цагаан хөтөл',
  },
  {
    code: '83-13-051',
    name: '1-р баг, Хатуу',
  },
  {
    code: '44-40-057',
    name: '4-р баг, Дөрвөлж',
  },
  {
    code: '42-04-053',
    name: '2-р баг',
  },
  {
    code: '42-04-051',
    name: '1-р баг',
  },
  {
    code: '45-04-053',
    name: '2-р баг, Энхтал',
  },
  {
    code: '11-19-061',
    name: '6-р хороо',
  },
  {
    code: '81-10-051',
    name: '1-р баг, Бужир',
  },
  {
    code: '11-19-063',
    name: '7-р хороо',
  },
  {
    code: '81-10-053',
    name: '2-р баг, Жавхлан',
  },
  {
    code: '11-19-065',
    name: '8-р хороо',
  },
  {
    code: '81-10-055',
    name: '3-р баг, Зайгал',
  },
  {
    code: '11-19-067',
    name: '9-р хороо',
  },
  {
    code: '45-04-051',
    name: '1-р баг, Баян-Өлзийт',
  },
  {
    code: '81-10-057',
    name: '4-р баг, Хачиг',
  },
  {
    code: '11-19-069',
    name: '10-р хороо',
  },
  {
    code: '62-55-091',
    name: '6-р баг, Дулаан',
  },
  {
    code: '62-01-053',
    name: '2-р баг, Эмт',
  },
  {
    code: '62-01-051',
    name: '1-р баг, Согоот',
  },
  {
    code: '62-01-057',
    name: '4-р баг, Өлзийт',
  },
  {
    code: '62-01-055',
    name: '3-р баг, Дэлгэрэх',
  },
  {
    code: '62-01-059',
    name: '5-р баг, Арвайхээр',
  },
  {
    code: '67-58-063',
    name: '7-р баг, Бүрхээр',
  },
  {
    code: '67-58-061',
    name: '6-р баг, Жаргалант',
  },
  {
    code: '83-04-053',
    name: '2-р баг, Улаан хад',
  },
  {
    code: '83-04-051',
    name: '1-р баг, Хар нуур',
  },
  {
    code: '11-19-071',
    name: '11-р хороо',
  },
  {
    code: '11-19-073',
    name: '12-р хороо',
  },
  {
    code: '11-19-075',
    name: '13-р хороо',
  },
  {
    code: '11-19-077',
    name: '14-р хороо',
  },
  {
    code: '83-04-059',
    name: '5-р баг, Борбургас',
  },
  {
    code: '11-19-079',
    name: '15-р хороо',
  },
  {
    code: '83-04-057',
    name: '4-р баг, Чихэртэй',
  },
  {
    code: '83-04-055',
    name: '3-р баг, Бардам',
  },
  {
    code: '62-01-063',
    name: '7-р баг, Дэлгэрэхийн дэнж',
  },
  {
    code: '62-01-061',
    name: '6-р баг, Ягаантолгой',
  },
  {
    code: '43-01-063',
    name: '7-р баг, Ган зам',
  },
  {
    code: '62-01-067',
    name: '9-р баг, Бурхи',
  },
  {
    code: '85-07-051',
    name: '1-р баг, Гурван жигэртэй',
  },
  {
    code: '43-01-061',
    name: '6-р баг, Орхон',
  },
  {
    code: '62-01-065',
    name: '8-р баг, Рашаант',
  },
  {
    code: '84-01-069',
    name: '10-р баг, Тахилт',
  },
  {
    code: '84-01-067',
    name: '9-р баг, Рашаант',
  },
  {
    code: '21-01-059',
    name: '5-р баг',
  },
  {
    code: '85-07-055',
    name: '3-р баг, Байшинт',
  },
  {
    code: '62-01-069',
    name: '10-р баг, Ноён',
  },
  {
    code: '84-01-065',
    name: '8-р баг, Наран',
  },
  {
    code: '21-01-057',
    name: '4-р баг',
  },
  {
    code: '85-07-053',
    name: '2-р баг, Хар алтат',
  },
  {
    code: '84-01-063',
    name: '7-р баг, Магсаржав',
  },
  {
    code: '21-01-055',
    name: '3-р баг',
  },
  {
    code: '67-58-051',
    name: '1-р баг, Дэлгэрхаан',
  },
  {
    code: '84-01-061',
    name: '6-р баг, Жаргалан',
  },
  {
    code: '21-01-053',
    name: '2-р баг',
  },
  {
    code: '11-19-081',
    name: '16-р хороо',
  },
  {
    code: '21-01-051',
    name: '1-р баг',
  },
  {
    code: '64-58-051',
    name: '1-р баг, Сэнжит',
  },
  {
    code: '67-58-055',
    name: '3-р баг, Ренчинжугнай',
  },
  {
    code: '11-19-083',
    name: '17-р хороо',
  },
  {
    code: '44-07-051',
    name: '1-р баг, Тойг',
  },
  {
    code: '64-58-053',
    name: '2-р баг, Ямаат',
  },
  {
    code: '67-58-053',
    name: '2-р баг, Зуун мод',
  },
  {
    code: '11-19-085',
    name: '18-р хороо',
  },
  {
    code: '44-07-053',
    name: '2-р баг, Зараа',
  },
  {
    code: '64-58-055',
    name: '3-р баг, Өвгөнжаргалант',
  },
  {
    code: '67-58-059',
    name: '5-р баг, Халбан',
  },
  {
    code: '11-19-087',
    name: '19-р хороо',
  },
  {
    code: '44-07-055',
    name: '3-р баг, Хаяа',
  },
  {
    code: '64-58-057',
    name: '4-р баг, Жанжин',
  },
  {
    code: '67-58-057',
    name: '4-р баг, Уранхайрхан',
  },
  {
    code: '11-19-089',
    name: '20-р хороо',
  },
  {
    code: '44-07-057',
    name: '4-р баг, Чулуун гишгэр',
  },
  {
    code: '64-58-059',
    name: '5-р баг, Эрхэт тамч',
  },
  {
    code: '43-01-065',
    name: '8-р баг, Буур хээр',
  },
  {
    code: '41-28-051',
    name: '1-р баг, Найрамдал',
  },
  {
    code: '41-28-053',
    name: '2-р баг, Хөшөөт',
  },
  {
    code: '43-01-051',
    name: '1-р баг, Хонгорморьт',
  },
  {
    code: '82-28-059',
    name: '5-р баг, Алтайн-Оргил',
  },
  {
    code: '21-01-069',
    name: '10-р баг',
  },
  {
    code: '21-01-067',
    name: '9-р баг',
  },
  {
    code: '64-04-063',
    name: '7-р баг, Баянсайр',
  },
  {
    code: '21-01-065',
    name: '8-р баг',
  },
  {
    code: '64-04-061',
    name: '6-р баг, Зүүнхаяа',
  },
  {
    code: '84-01-073',
    name: '12-р баг, Цамбагарав',
  },
  {
    code: '21-01-063',
    name: '7-р баг',
  },
  {
    code: '64-58-061',
    name: '6-р баг',
  },
  {
    code: '84-01-071',
    name: '11-р баг, Хайрхан',
  },
  {
    code: '21-01-061',
    name: '6-р баг',
  },
  {
    code: '43-01-055',
    name: '3-р баг, Салхит',
  },
  {
    code: '43-01-053',
    name: '2-р баг, Цагаан-Эрэг',
  },
  {
    code: '65-55-061',
    name: '6-р баг, Өлзийт',
  },
  {
    code: '43-01-059',
    name: '5-р баг, Боргүвээ',
  },
  {
    code: '62-01-071',
    name: '11-р баг, Хүйс толгой',
  },
  {
    code: '43-01-057',
    name: '4-р баг, Баянхаан',
  },
  {
    code: '65-55-059',
    name: '5-р баг, Тээл',
  },
  {
    code: '65-55-057',
    name: '4-р баг, Хан-Өндөр',
  },
  {
    code: '65-55-055',
    name: '3-р баг, Эрдэнэ-Уул',
  },
  {
    code: '23-22-059',
    name: '5-р баг, Онон',
  },
  {
    code: '23-22-057',
    name: '4-р баг, Дэлгэрхаан',
  },
  {
    code: '64-49-061',
    name: '6-р баг, Улаан уул',
  },
  {
    code: '67-04-061',
    name: '6-р баг, Хатгал тосон',
  },
  {
    code: '82-28-051',
    name: '1-р баг, Бүс-Уул',
  },
  {
    code: '23-22-051',
    name: '1-р баг, Баян-Өндөр',
  },
  {
    code: '82-28-053',
    name: '2-р баг, Тамч',
  },
  {
    code: '67-04-063',
    name: 'Хатгал тосгон',
  },
  {
    code: '82-28-055',
    name: '3-р баг, Зүйл',
  },
  {
    code: '23-22-055',
    name: '3-р баг, Баянгол',
  },
  {
    code: '82-28-057',
    name: '4-р баг, Алтансоёмбо',
  },
  {
    code: '23-22-053',
    name: '2-р баг, Мандалхаан',
  },
  {
    code: '65-55-053',
    name: '2-р баг, Идэр-Улаан',
  },
  {
    code: '65-55-051',
    name: '1-р баг, Алаг-Уул',
  },
  {
    code: '84-01-059',
    name: '5-р баг, Буянт',
  },
  {
    code: '22-16-055',
    name: '3-р баг, Наранбулаг',
  },
  {
    code: '84-01-057',
    name: '4-р баг, Бугат',
  },
  {
    code: '81-70-059',
    name: '5-р баг, Чандмань',
  },
  {
    code: '84-01-055',
    name: '3-р баг, Бичигт',
  },
  {
    code: '67-04-051',
    name: '1-р баг, Шувуут',
  },
  {
    code: '81-70-057',
    name: '4-р баг, Хэц-Улаан',
  },
  {
    code: '22-16-051',
    name: '1-р баг, Гүн худаг',
  },
  {
    code: '84-01-053',
    name: '2-р баг, Баатархайрхан',
  },
  {
    code: '81-70-055',
    name: '3-р баг, Өргөн',
  },
  {
    code: '22-16-053',
    name: '2-р баг, Тосонгийн гол',
  },
  {
    code: '84-01-051',
    name: '1-р баг, Алагтолгой',
  },
  {
    code: '67-04-055',
    name: '3-р баг, Яргис',
  },
  {
    code: '81-70-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '67-04-053',
    name: '2-р баг, Ужиг /Цагаан бэлчир/',
  },
  {
    code: '81-70-051',
    name: '1-р баг, Зүйл',
  },
  {
    code: '67-04-059',
    name: '5-р баг, Манхан',
  },
  {
    code: '67-04-057',
    name: '4-р баг, Баясгалан',
  },
  {
    code: '41-52-057',
    name: '4-р баг, Төв',
  },
  {
    code: '41-52-055',
    name: '3-р баг, Хайлааст',
  },
  {
    code: '41-52-053',
    name: '2-р баг, Төмстэй',
  },
  {
    code: '41-52-051',
    name: '1-р баг, Тосон',
  },
  {
    code: '62-10-061',
    name: '6-р баг, Ширээ',
  },
  {
    code: '63-31-057',
    name: '4-р баг, Ундрах',
  },
  {
    code: '63-31-055',
    name: '3-р баг, Хульж',
  },
  {
    code: '63-31-059',
    name: '5-р баг, Хүрэмт',
  },
  {
    code: '62-10-053',
    name: '2-р баг, Эргэн дэнж',
  },
  {
    code: '85-31-059',
    name: '5-р баг, Намир',
  },
  {
    code: '41-61-053',
    name: '2-р баг, Хайрхан',
  },
  {
    code: '62-10-055',
    name: '3-р баг, Цагаан булан',
  },
  {
    code: '41-61-055',
    name: '3-р баг, Уянга',
  },
  {
    code: '62-10-057',
    name: '4-р баг, Хаяа',
  },
  {
    code: '85-31-055',
    name: '3-р баг, Орлого',
  },
  {
    code: '62-10-059',
    name: '5-р баг, Цавын-Ихэр',
  },
  {
    code: '85-31-057',
    name: '4-р баг, Баянгол',
  },
  {
    code: '41-61-051',
    name: '1-р баг, Баянтуул',
  },
  {
    code: '85-31-051',
    name: '1-р баг, Холбоо',
  },
  {
    code: '85-31-053',
    name: '2-р баг, Улиаст',
  },
  {
    code: '41-61-057',
    name: '4-р баг, Сант',
  },
  {
    code: '62-10-051',
    name: '1-р баг, Өндөр өнц',
  },
  {
    code: '63-31-053',
    name: '2-р баг, Угалз',
  },
  {
    code: '63-31-051',
    name: '1-р баг, Мануулт',
  },
  {
    code: '81-55-057',
    name: '4-р баг, Агьт',
  },
  {
    code: '81-55-051',
    name: '1-р баг, Цэцэрлэг',
  },
  {
    code: '84-10-051',
    name: '1-р баг, Нарийн гол',
  },
  {
    code: '81-55-055',
    name: '3-р баг, Баянбулаг',
  },
  {
    code: '81-55-053',
    name: '2-р баг, Онц',
  },
  {
    code: '82-37-059',
    name: '5-р баг, Сайн-Уст',
  },
  {
    code: '84-10-057',
    name: '4-р баг, Цагаан-Эрэг',
  },
  {
    code: '82-37-057',
    name: '4-р баг, Хүйсийн говь',
  },
  {
    code: '84-10-059',
    name: '5-р баг, Норжинхайрхан',
  },
  {
    code: '62-46-057',
    name: '4-р баг, Шуранга',
  },
  {
    code: '82-37-055',
    name: '3-р баг, Сангийн далай',
  },
  {
    code: '84-10-053',
    name: '2-р баг, Цагаанбургас',
  },
  {
    code: '62-46-059',
    name: '5-р баг, Бадрал',
  },
  {
    code: '82-37-053',
    name: '2-р баг, Завхан гол',
  },
  {
    code: '84-10-055',
    name: '3-р баг, Наранхайрхан',
  },
  {
    code: '62-46-053',
    name: '2-р баг, Таац',
  },
  {
    code: '82-37-051',
    name: '1-р баг, Цоохор',
  },
  {
    code: '62-46-055',
    name: '3-р баг, Шивээ-Овоо',
  },
  {
    code: '62-46-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '64-13-057',
    name: '4-р баг, Их баян',
  },
  {
    code: '64-13-055',
    name: '3-р баг, Бага баян',
  },
  {
    code: '64-13-053',
    name: '2-р баг, Баян-Аараг',
  },
  {
    code: '64-13-051',
    name: '1-р баг, Их халбагант',
  },
  {
    code: '82-43-053',
    name: '2-р баг, Баянгол',
  },
  {
    code: '82-43-051',
    name: '1-р баг, Бүрэн',
  },
  {
    code: '82-43-057',
    name: '4-р баг, Жаргалт',
  },
  {
    code: '64-13-059',
    name: '5-р баг, Хатан суудал',
  },
  {
    code: '82-43-055',
    name: '3-р баг, Дэрстэй',
  },
  {
    code: '46-25-055',
    name: '3-р баг, Дэрсэнэ-Ус',
  },
  {
    code: '46-25-057',
    name: '4-р баг, Эмгэнбулаг',
  },
  {
    code: '67-67-053',
    name: '2-р баг, Булган тал',
  },
  {
    code: '22-37-063',
    name: '7-р баг, Хадын булаг',
  },
  {
    code: '46-25-059',
    name: '5-р баг, Богт',
  },
  {
    code: '67-67-051',
    name: '1-р баг, Бөөрөлж',
  },
  {
    code: '22-37-065',
    name: '8-р баг, Алтан овоо',
  },
  {
    code: '44-16-055',
    name: '3-р баг',
  },
  {
    code: '44-16-053',
    name: '2-р баг',
  },
  {
    code: '44-16-051',
    name: '1-р баг',
  },
  {
    code: '67-67-057',
    name: '4-р баг, Дуурга',
  },
  {
    code: '67-67-055',
    name: '3-р баг, Зэрлэг',
  },
  {
    code: '22-37-061',
    name: '6-р баг, Жаргалант',
  },
  {
    code: '46-25-051',
    name: '1-р баг, Хармагтай',
  },
  {
    code: '67-67-059',
    name: '5-р баг, Удган',
  },
  {
    code: '46-25-053',
    name: '2-р баг, Төхөм',
  },
  {
    code: '22-37-055',
    name: '3-р баг, Бадрах',
  },
  {
    code: '46-19-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '64-49-057',
    name: '4-р баг, Худаг урт',
  },
  {
    code: '22-37-057',
    name: '4-р баг, Хонгор',
  },
  {
    code: '46-19-055',
    name: '3-р баг, Жаргалант',
  },
  {
    code: '64-49-059',
    name: '5-р баг, Бийрийн уулзвар',
  },
  {
    code: '22-37-051',
    name: '1-р баг, Хөдлөн хайлааст',
  },
  {
    code: '22-37-053',
    name: '2-р баг, Цагаан овоо',
  },
  {
    code: '46-19-051',
    name: '1-р баг, Өехий',
  },
  {
    code: '84-46-061',
    name: '6-р баг, Жаргалант',
  },
  {
    code: '44-22-051',
    name: '1-р баг, Алхантээг',
  },
  {
    code: '44-22-053',
    name: '2-р баг, Баянхошуу',
  },
  {
    code: '64-49-051',
    name: '1-р баг, Бурхант',
  },
  {
    code: '22-37-059',
    name: '5-р баг, Билүүт',
  },
  {
    code: '46-19-057',
    name: '4-р баг, Далай',
  },
  {
    code: '64-49-053',
    name: '2-р баг, Байн ам',
  },
  {
    code: '64-49-055',
    name: '3-р баг, Ёлын ам',
  },
  {
    code: '44-22-059',
    name: '5-р баг, Төхөм',
  },
  {
    code: '44-22-055',
    name: '3-р баг, Өехий',
  },
  {
    code: '44-22-057',
    name: '4-р баг, Сэрвэн баянхошуу',
  },
  {
    code: '62-46-065',
    name: '8-р баг, Онги',
  },
  {
    code: '62-46-061',
    name: '6-р баг, Бөөрөлжүүт',
  },
  {
    code: '62-46-063',
    name: '7-р баг, Өлт',
  },
  {
    code: '63-37-055',
    name: '3-р баг, Далан',
  },
  {
    code: '63-37-053',
    name: '2-р баг, Харгал',
  },
  {
    code: '63-37-051',
    name: '1-р баг, Хужирт',
  },
  {
    code: '63-37-059',
    name: '5-р баг, Жаргалант',
  },
  {
    code: '63-37-057',
    name: '4-р баг, Эрэн',
  },
  {
    code: '63-22-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '41-07-053',
    name: '2-р баг, Хөшөөт',
  },
  {
    code: '85-52-055',
    name: '3-р баг, Хайрхан',
  },
  {
    code: '85-52-057',
    name: '4-р баг, Дэлгэр',
  },
  {
    code: '48-13-051',
    name: '1-р баг, Элгэн',
  },
  {
    code: '48-28-057',
    name: '4-р баг, Дэрт 1',
  },
  {
    code: '65-10-059',
    name: '5-р баг, Баянцагаан',
  },
  {
    code: '48-28-059',
    name: '5-р баг, Дэрт 2',
  },
  {
    code: '41-07-051',
    name: '1-р баг, Аргалын уул',
  },
  {
    code: '48-13-055',
    name: '3-р баг, Чулуут',
  },
  {
    code: '48-28-053',
    name: '2-р баг, Буянт 2',
  },
  {
    code: '65-10-055',
    name: '3-р баг, Эрдэнэ-Уул',
  },
  {
    code: '48-13-053',
    name: '2-р баг, Дэрсэнэ ус',
  },
  {
    code: '48-28-055',
    name: '3-р баг, Тагт',
  },
  {
    code: '65-10-057',
    name: '4-р баг, Зуслан',
  },
  {
    code: '48-13-059',
    name: '5-р баг, Суугаант',
  },
  {
    code: '65-10-051',
    name: '1-р баг, Асайт',
  },
  {
    code: '48-13-057',
    name: '4-р баг, Гурвансайхан',
  },
  {
    code: '48-28-051',
    name: '1-р баг, Буянт 1',
  },
  {
    code: '65-10-053',
    name: '2-р баг, Хоолт',
  },
  {
    code: '63-22-055',
    name: '3-р баг, Баянгол',
  },
  {
    code: '85-52-051',
    name: '1-р баг, Хангай',
  },
  {
    code: '63-22-053',
    name: '2-р баг, Баясгалант',
  },
  {
    code: '85-52-053',
    name: '2-р баг, Бугат',
  },
  {
    code: '63-22-059',
    name: '5-р баг, Эрхт',
  },
  {
    code: '63-22-057',
    name: '4-р баг, Баян-Уул',
  },
  {
    code: '48-28-061',
    name: '6-р баг, Рашаант',
  },
  {
    code: '81-61-059',
    name: '5-р баг, Батсуурь',
  },
  {
    code: '82-22-051',
    name: '1-р баг, Бүрэн',
  },
  {
    code: '81-61-057',
    name: '4-р баг, Шотой',
  },
  {
    code: '81-61-055',
    name: '3-р баг, Сангийн далай',
  },
  {
    code: '82-22-055',
    name: '3-р баг, Завхан гол',
  },
  {
    code: '81-61-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '82-22-053',
    name: '2-р баг, Тээл',
  },
  {
    code: '81-61-051',
    name: '1-р баг, Оройн товгор',
  },
  {
    code: '22-07-061',
    name: '6-р баг, Ширээт',
  },
  {
    code: '48-37-051',
    name: '1-р баг, Шувуутай',
  },
  {
    code: '48-37-053',
    name: '2-р баг, Олдох',
  },
  {
    code: '22-31-059',
    name: '5-р баг, Дэлгэр',
  },
  {
    code: '22-31-057',
    name: '4-р баг, Жавхлант',
  },
  {
    code: '22-31-055',
    name: '3-р баг, Тэгш',
  },
  {
    code: '22-31-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '48-37-055',
    name: '3-р баг, Уул',
  },
  {
    code: '22-31-051',
    name: '1-р баг, Баян',
  },
  {
    code: '48-37-057',
    name: '4-р баг, Бүлээн',
  },
  {
    code: '46-34-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '63-07-053',
    name: '2-р баг, Шар тал',
  },
  {
    code: '46-34-055',
    name: '3-р баг, Хондот',
  },
  {
    code: '46-34-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '46-34-051',
    name: '1-р баг, Мандах',
  },
  {
    code: '63-07-051',
    name: '1-р баг, Өлзийт',
  },
  {
    code: '22-07-053',
    name: '2-р баг, Дэлгэр',
  },
  {
    code: '48-22-051',
    name: '1-р баг, Алаг-Өндөр',
  },
  {
    code: '22-07-055',
    name: '3-р баг, Төв',
  },
  {
    code: '48-22-053',
    name: '2-р баг, Саруул',
  },
  {
    code: '48-22-055',
    name: '3-р баг, Долоод',
  },
  {
    code: '22-07-051',
    name: '1-р баг, Баян',
  },
  {
    code: '48-22-057',
    name: '4-р баг, Бумбат',
  },
  {
    code: '22-07-057',
    name: '4-р баг, Дөхөм',
  },
  {
    code: '22-07-059',
    name: '5-р баг, Хонгор',
  },
  {
    code: '81-46-051',
    name: '1-р баг, Шургах',
  },
  {
    code: '61-04-055',
    name: '3-р баг, Дулаан уул',
  },
  {
    code: '81-46-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '81-31-061',
    name: '6-р баг, Хужирт',
  },
  {
    code: '81-46-059',
    name: '5-р баг, Баян-айраг',
  },
  {
    code: '61-04-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '81-46-055',
    name: '3-р баг, Нуур',
  },
  {
    code: '61-04-051',
    name: '1-р баг, Улаан толгой',
  },
  {
    code: '81-46-057',
    name: '4-р баг, Баянтэгш',
  },
  {
    code: '44-31-051',
    name: '1-р баг, Сангийн далай',
  },
  {
    code: '81-46-061',
    name: '6-р баг, Өвөгдий',
  },
  {
    code: '44-31-055',
    name: '3-р баг, Аргалант',
  },
  {
    code: '44-31-053',
    name: '2-р баг, Баянбогд',
  },
  {
    code: '21-10-053',
    name: '2-р баг, Хар чулуут',
  },
  {
    code: '21-10-051',
    name: '1-р баг, Заяат',
  },
  {
    code: '83-34-053',
    name: '2-р баг, Хөх хөтөл',
  },
  {
    code: '21-10-059',
    name: '5-р баг, Улз',
  },
  {
    code: '83-34-055',
    name: '3-р баг, Хулжаа',
  },
  {
    code: '21-10-057',
    name: '4-р баг, Хошуу',
  },
  {
    code: '21-10-055',
    name: '3-р баг, Урт',
  },
  {
    code: '83-34-051',
    name: '1-р баг, Их ойгор',
  },
  {
    code: '44-31-057',
    name: '4-р баг, Нүдэн',
  },
  {
    code: '83-34-057',
    name: '4-р баг, Согоог',
  },
  {
    code: '83-34-059',
    name: '5-р баг, Баян зүрх',
  },
  {
    code: '84-40-053',
    name: '2-р баг, Цагаанбургас',
  },
  {
    code: '84-40-051',
    name: '1-р баг, Баянбулаг',
  },
  {
    code: '84-40-057',
    name: '4-р баг, Улаанбураа',
  },
  {
    code: '84-40-055',
    name: '3-р баг, Баруун салаа',
  },
  {
    code: '11-04-051',
    name: '1-р хороо',
  },
  {
    code: '11-04-053',
    name: '2-р хороо',
  },
  {
    code: '84-40-059',
    name: '5-р баг, Дунд ус',
  },
  {
    code: '81-31-059',
    name: '5-р баг, Онц',
  },
  {
    code: '82-52-055',
    name: '3-р баг, Цагаан-уул',
  },
  {
    code: '82-52-053',
    name: '2-р баг, Цэцэг нуур',
  },
  {
    code: '82-52-057',
    name: '4-р баг, Өлзийт',
  },
  {
    code: '81-31-051',
    name: '1-р баг, Буянт',
  },
  {
    code: '81-31-053',
    name: '2-р баг, Баянбулаг',
  },
  {
    code: '81-31-055',
    name: '3-р баг, Бадрал',
  },
  {
    code: '81-31-057',
    name: '4-р баг, Соёл',
  },
  {
    code: '11-19-051',
    name: '1-р хороо',
  },
  {
    code: '11-19-053',
    name: '2-р хороо',
  },
  {
    code: '11-19-055',
    name: '3-р хороо',
  },
  {
    code: '11-19-057',
    name: '4-р хороо',
  },
  {
    code: '11-19-059',
    name: '5-р хороо',
  },
  {
    code: '82-52-051',
    name: '1-р баг, Сангийн далай',
  },
  {
    code: '23-13-057',
    name: '4-р баг, Улаан-Эрэг',
  },
  {
    code: '85-37-051',
    name: '1-р баг, Баянзүрх',
  },
  {
    code: '23-13-055',
    name: '3-р баг, Дулаан',
  },
  {
    code: '67-13-061',
    name: '6-р баг, Эрчим',
  },
  {
    code: '85-37-055',
    name: '3-р баг, Өндөр мод',
  },
  {
    code: '85-37-053',
    name: '2-р баг, Боршоо',
  },
  {
    code: '85-37-059',
    name: '5-р баг, Хар мод',
  },
  {
    code: '85-37-057',
    name: '4-р баг, Үүрэг нуур',
  },
  {
    code: '67-28-055',
    name: '3-р баг, Ходон',
  },
  {
    code: '11-10-103',
    name: '27-р хороо',
  },
  {
    code: '67-28-057',
    name: '4-р баг, Далайн зах',
  },
  {
    code: '11-10-101',
    name: '26-р хороо',
  },
  {
    code: '67-28-051',
    name: '1-р баг, Хөндий',
  },
  {
    code: '67-28-053',
    name: '2-р баг, Хоолойн зах',
  },
  {
    code: '11-10-105',
    name: '28-р хороо',
  },
  {
    code: '23-13-053',
    name: '2-р баг, Хэрлэн',
  },
  {
    code: '67-28-059',
    name: '5-р баг, Ёлт',
  },
  {
    code: '23-13-051',
    name: '1-р баг, Баянбулаг',
  },
  {
    code: '43-10-055',
    name: '3-р баг, Гонир',
  },
  {
    code: '85-22-057',
    name: '4-р баг, Баян-Эрдэнэ',
  },
  {
    code: '85-22-055',
    name: '3-р баг, Баянхайрхан',
  },
  {
    code: '85-22-053',
    name: '2-р баг, Цалгар',
  },
  {
    code: '41-37-051',
    name: '1-р баг, Чандмань',
  },
  {
    code: '41-37-055',
    name: '3-р баг, Эрдэнэ',
  },
  {
    code: '41-37-053',
    name: '2-р баг, Замт',
  },
  {
    code: '41-22-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '41-22-053',
    name: '2-р баг, Улаан ухаа',
  },
  {
    code: '41-22-055',
    name: '3-р баг, Эрдэнэ',
  },
  {
    code: '67-28-061',
    name: '6-р баг, Зөөлөн',
  },
  {
    code: '85-22-051',
    name: '1-р баг, Баянмандал',
  },
  {
    code: '43-10-051',
    name: '1-р баг, Хараа',
  },
  {
    code: '43-10-053',
    name: '2-р баг, Баян',
  },
  {
    code: '65-25-059',
    name: '5-р баг, Бөөрөлжүүт',
  },
  {
    code: '65-25-051',
    name: '1-р баг, Тэрх',
  },
  {
    code: '65-25-053',
    name: '2-р баг, Цагааннуур',
  },
  {
    code: '65-25-055',
    name: '3-р баг, Хорго',
  },
  {
    code: '21-10-061',
    name: '6-р баг, Өвөр эрээн',
  },
  {
    code: '65-25-057',
    name: '4-р баг, Суман',
  },
  {
    code: '21-25-053',
    name: '2-р баг, Ар хоолой',
  },
  {
    code: '83-34-065',
    name: '8-р баг, Билүү 2',
  },
  {
    code: '21-25-051',
    name: '1-р баг, Барчин',
  },
  {
    code: '21-25-057',
    name: '4-р баг, Очир хүрээ',
  },
  {
    code: '83-34-061',
    name: '6-р баг, Даян',
  },
  {
    code: '21-25-055',
    name: '3-р баг, Баян',
  },
  {
    code: '83-34-063',
    name: '7-р баг, Билүү',
  },
  {
    code: '21-25-059',
    name: '5-р баг, Галын гол',
  },
  {
    code: '43-25-051',
    name: '1-р баг, Орхон',
  },
  {
    code: '43-25-053',
    name: '2-р баг, Бэлэндалай',
  },
  {
    code: '67-13-051',
    name: '1-р баг, Сангийн далай',
  },
  {
    code: '67-13-053',
    name: '2-р баг, Бүрэнхаан',
  },
  {
    code: '65-25-063',
    name: '7-р баг, Алтаад',
  },
  {
    code: '65-25-061',
    name: '6-р баг, Мөрөн',
  },
  {
    code: '67-13-055',
    name: '3-р баг, Их уул',
  },
  {
    code: '23-28-057',
    name: '4-р баг, Баяновоо',
  },
  {
    code: '67-13-057',
    name: '4-р баг, Баянхошуу',
  },
  {
    code: '23-28-055',
    name: '3-р баг, Балж',
  },
  {
    code: '67-13-059',
    name: '5-р баг, Туяа',
  },
  {
    code: '23-28-053',
    name: '2-р баг, Агац',
  },
  {
    code: '23-28-051',
    name: '1-р баг, Онон',
  },
  {
    code: '46-13-057',
    name: '4-р баг, Урт',
  },
  {
    code: '46-13-055',
    name: '3-р баг, Тост',
  },
  {
    code: '46-13-053',
    name: '2-р баг, Баясах',
  },
  {
    code: '46-13-051',
    name: '1-р баг, Гоёот',
  },
  {
    code: '62-40-061',
    name: '6-р баг, Алтантал',
  },
  {
    code: '44-01-051',
    name: '1-р баг',
  },
  {
    code: '65-22-053',
    name: '2-р баг, Хануй',
  },
  {
    code: '44-01-053',
    name: '2-р баг',
  },
  {
    code: '65-22-051',
    name: '1-р баг, Азарга',
  },
  {
    code: '21-40-055',
    name: '3-р баг, Цагаанчулуут',
  },
  {
    code: '63-10-055',
    name: '3-р баг, Бугат',
  },
  {
    code: '84-31-057',
    name: '4-р баг, Давст',
  },
  {
    code: '64-43-051',
    name: '1-р баг, Уу-булан',
  },
  {
    code: '63-10-053',
    name: '2-р баг, Ханжаргалант',
  },
  {
    code: '84-31-059',
    name: '5-р баг, Улаантолгой',
  },
  {
    code: '64-43-053',
    name: '2-р баг, Хүйс',
  },
  {
    code: '21-40-051',
    name: '1-р баг, Дэлгэр',
  },
  {
    code: '84-31-053',
    name: '2-р баг, Хужирт',
  },
  {
    code: '21-40-053',
    name: '2-р баг, Галуут',
  },
  {
    code: '84-31-055',
    name: '3-р баг, Баянхайрхан',
  },
  {
    code: '64-43-059',
    name: '5-р баг, Бодь',
  },
  {
    code: '84-31-051',
    name: '1-р баг, Цэцэг гол',
  },
  {
    code: '63-10-051',
    name: '1-р баг, Баянтөгөл',
  },
  {
    code: '64-43-055',
    name: '3-р баг, Хөнөг',
  },
  {
    code: '64-43-057',
    name: '4-р баг, Цагаан ус',
  },
  {
    code: '44-01-059',
    name: '5-р баг, Зүүнбаян',
  },
  {
    code: '65-22-059',
    name: '5-р баг, Баянгол',
  },
  {
    code: '44-01-055',
    name: '3-р баг',
  },
  {
    code: '65-22-057',
    name: '4-р баг, Бэлхи',
  },
  {
    code: '23-52-061',
    name: '6-р баг, Өлгий',
  },
  {
    code: '44-01-057',
    name: '4-р баг',
  },
  {
    code: '65-22-055',
    name: '3-р баг, Донгой',
  },
  {
    code: '23-52-059',
    name: '5-р баг, Хүйх',
  },
  {
    code: '67-25-055',
    name: '3-р баг, Энх тал',
  },
  {
    code: '85-01-069',
    name: '10-р баг',
  },
  {
    code: '67-25-053',
    name: '2-р баг, Талын ус',
  },
  {
    code: '85-01-067',
    name: '9-р баг',
  },
  {
    code: '67-25-059',
    name: '5-р баг, Их ац',
  },
  {
    code: '85-01-065',
    name: '8-р баг',
  },
  {
    code: '67-25-057',
    name: '4-р баг, Цэнгэл',
  },
  {
    code: '85-01-063',
    name: '7-р баг',
  },
  {
    code: '23-52-051',
    name: '1-р баг, Бор-Өндөр',
  },
  {
    code: '85-01-061',
    name: '6-р баг',
  },
  {
    code: '23-52-053',
    name: '2-р баг, Холбоо',
  },
  {
    code: '23-52-055',
    name: '3-р баг, Бумбат',
  },
  {
    code: '67-25-051',
    name: '1-р баг, Тээл',
  },
  {
    code: '23-52-057',
    name: '4-р баг, Уурхайчин',
  },
  {
    code: '48-25-051',
    name: '1-р баг, Суварга',
  },
  {
    code: '48-25-055',
    name: '3-р баг, Буянт',
  },
  {
    code: '48-25-053',
    name: '2-р баг, Наран',
  },
  {
    code: '44-10-059',
    name: '5-р баг, Олон-Овоо',
  },
  {
    code: '64-52-051',
    name: '1-р баг, Хөх бүрд',
  },
  {
    code: '44-10-057',
    name: '4-р баг, Цомог',
  },
  {
    code: '64-52-055',
    name: '3-р баг, Норовлин',
  },
  {
    code: '64-52-053',
    name: '2-р баг, Сонор',
  },
  {
    code: '85-01-059',
    name: '5-р баг',
  },
  {
    code: '22-10-055',
    name: '3-р баг, Аман-Ус',
  },
  {
    code: '62-40-055',
    name: '3-р баг, Хүрэмт',
  },
  {
    code: '65-13-051',
    name: '1-р баг, Хөхнуур',
  },
  {
    code: '11-10-051',
    name: '1-р хороо',
  },
  {
    code: '85-01-057',
    name: '4-р баг',
  },
  {
    code: '22-10-053',
    name: '2-р баг, Бадрах',
  },
  {
    code: '62-40-057',
    name: '4-р баг, Урт',
  },
  {
    code: '85-01-055',
    name: '3-р баг',
  },
  {
    code: '22-10-051',
    name: '1-р баг, Өрнө дэрс',
  },
  {
    code: '62-40-059',
    name: '5-р баг, Их булаг',
  },
  {
    code: '11-10-055',
    name: '3-р хороо',
  },
  {
    code: '85-01-053',
    name: '2-р баг',
  },
  {
    code: '11-10-053',
    name: '2-р хороо',
  },
  {
    code: '85-01-051',
    name: '1-р баг',
  },
  {
    code: '65-13-059',
    name: '6-р баг, Эрдэнэтолгой',
  },
  {
    code: '11-10-059',
    name: '5-р хороо',
  },
  {
    code: '65-13-057',
    name: '4-р баг, Бугат',
  },
  {
    code: '11-10-057',
    name: '4-р хороо',
  },
  {
    code: '62-40-051',
    name: '1-р баг, Туяа',
  },
  {
    code: '65-13-055',
    name: '3-р баг, Борт',
  },
  {
    code: '22-10-057',
    name: '4-р баг, Овоот',
  },
  {
    code: '62-40-053',
    name: '2-р баг, Арвайнтал',
  },
  {
    code: '65-13-053',
    name: '2-р баг, Хан-Өндөр',
  },
  {
    code: '44-10-051',
    name: '1-р баг, Элдэв',
  },
  {
    code: '64-52-059',
    name: '5-р баг, Дэлгэр мөрөн',
  },
  {
    code: '64-52-057',
    name: '4-р баг, Цорж',
  },
  {
    code: '44-10-055',
    name: '3-р баг, Бичигт',
  },
  {
    code: '44-10-053',
    name: '2-р баг, Өнгөт',
  },
  {
    code: '41-73-059',
    name: '5-р баг, Хүүлэй хан',
  },
  {
    code: '41-73-057',
    name: '4-р баг, Сүүл буга',
  },
  {
    code: '11-10-061',
    name: '6-р хороо',
  },
  {
    code: '65-13-061',
    name: '5-р баг, Тайхар',
  },
  {
    code: '85-55-057',
    name: '4-р баг, Арбулаг',
  },
  {
    code: '11-10-065',
    name: '8-р хороо',
  },
  {
    code: '43-22-063',
    name: '7-р баг, Минжийнхангай',
  },
  {
    code: '85-55-055',
    name: '3-р баг, Хунт',
  },
  {
    code: '11-10-063',
    name: '7-р хороо',
  },
  {
    code: '43-22-061',
    name: '6-р баг, Баянхангай',
  },
  {
    code: '85-55-053',
    name: '2-р баг, Даланхуруу',
  },
  {
    code: '11-10-069',
    name: '10-р хороо',
  },
  {
    code: '43-22-067',
    name: '9-р баг, Баянарцат',
  },
  {
    code: '85-55-051',
    name: '1-р баг, Хулж',
  },
  {
    code: '11-10-067',
    name: '9-р хороо',
  },
  {
    code: '43-22-065',
    name: '8-р баг, Тарни',
  },
  {
    code: '41-73-055',
    name: '3-р баг, Майхан',
  },
  {
    code: '41-73-053',
    name: '2-р баг, Талын хайрхан',
  },
  {
    code: '41-73-051',
    name: '1-р баг, Оргил',
  },
  {
    code: '11-10-073',
    name: '12-р хороо',
  },
  {
    code: '11-10-071',
    name: '11-р хороо',
  },
  {
    code: '11-10-077',
    name: '14-р хороо',
  },
  {
    code: '43-22-053',
    name: '2-р баг, Ширхэнцэг',
  },
  {
    code: '11-10-075',
    name: '13-р хороо',
  },
  {
    code: '43-22-051',
    name: '1-р баг, Төмөр зам',
  },
  {
    code: '43-22-057',
    name: '4-р баг, Хэрх',
  },
  {
    code: '11-10-079',
    name: '15-р хороо',
  },
  {
    code: '43-22-055',
    name: '3-р баг, Баянсуудал',
  },
  {
    code: '43-22-059',
    name: '5-р баг, Түнхэл',
  },
  {
    code: '43-40-051',
    name: '1-р баг, Тарвагатай',
  },
  {
    code: '43-40-053',
    name: '2-р баг, Баянцагаан',
  },
  {
    code: '11-16-101',
    name: '26-р хороо',
  },
  {
    code: '48-16-051',
    name: '1-р баг, Толь',
  },
  {
    code: '23-43-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '48-16-053',
    name: '2-р баг, Таргат',
  },
  {
    code: '11-10-083',
    name: '17-р хороо',
  },
  {
    code: '11-16-109',
    name: '30-р хороо',
  },
  {
    code: '11-10-081',
    name: '16-р хороо',
  },
  {
    code: '11-16-107',
    name: '29-р хороо',
  },
  {
    code: '11-10-087',
    name: '19-р хороо',
  },
  {
    code: '11-16-105',
    name: '28-р хороо',
  },
  {
    code: '11-10-085',
    name: '18-р хороо',
  },
  {
    code: '11-16-103',
    name: '27-р хороо',
  },
  {
    code: '11-10-089',
    name: '20-р хороо',
  },
  {
    code: '23-43-051',
    name: '1-р баг, Баян-Өлзийт',
  },
  {
    code: '48-16-055',
    name: '3-р баг, Ар шавагтай',
  },
  {
    code: '23-43-053',
    name: '2-р баг, Ангирт',
  },
  {
    code: '48-16-057',
    name: '4-р баг, Номгон',
  },
  {
    code: '23-43-055',
    name: '3-р баг, Онон',
  },
  {
    code: '11-16-111',
    name: '31-р хороо',
  },
  {
    code: '84-22-055',
    name: '3-р баг, Бураа',
  },
  {
    code: '67-43-051',
    name: '1-р баг, Шивлэг',
  },
  {
    code: '84-22-057',
    name: '4-р баг, Эхэн',
  },
  {
    code: '67-43-053',
    name: '2-р баг, Тоом',
  },
  {
    code: '11-10-091',
    name: '21-р хороо',
  },
  {
    code: '84-22-051',
    name: '1-р баг, Гүвээ',
  },
  {
    code: '67-43-055',
    name: '3-р баг, Мунгараг',
  },
  {
    code: '84-22-053',
    name: '2-р баг, Бургасан',
  },
  {
    code: '11-10-095',
    name: '23-р хороо',
  },
  {
    code: '11-10-093',
    name: '22-р хороо',
  },
  {
    code: '11-10-099',
    name: '25-р хороо',
  },
  {
    code: '84-22-059',
    name: '5-р баг, Хөндлөн',
  },
  {
    code: '11-16-113',
    name: '32-р хороо',
  },
  {
    code: '11-10-097',
    name: '24-р хороо',
  },
  {
    code: '62-22-053',
    name: '2-р баг, Гучин',
  },
  {
    code: '67-43-057',
    name: '4-р баг, Соёо',
  },
  {
    code: '62-22-051',
    name: '1-р баг, Хөөвөр',
  },
  {
    code: '67-43-059',
    name: '5-р баг, Төгөл',
  },
  {
    code: '62-22-057',
    name: '4-р баг, Аргуйт',
  },
  {
    code: '62-22-055',
    name: '3-р баг, Аргалант',
  },
  {
    code: '85-46-059',
    name: '5-р баг',
  },
  {
    code: '21-22-059',
    name: '5-р баг, Мэнэн',
  },
  {
    code: '21-22-057',
    name: '4-р баг, Буян-Өндөр',
  },
  {
    code: '21-22-055',
    name: '3-р баг, Түмэнхаан',
  },
  {
    code: '11-01-057',
    name: '4-р хороо',
  },
  {
    code: '85-46-051',
    name: '1-р баг',
  },
  {
    code: '11-01-055',
    name: '3-р хороо',
  },
  {
    code: '85-46-053',
    name: '2-р баг',
  },
  {
    code: '85-46-055',
    name: '3-р баг',
  },
  {
    code: '43-13-053',
    name: '2-р баг, Буурагчин',
  },
  {
    code: '11-01-059',
    name: '5-р хороо',
  },
  {
    code: '85-46-057',
    name: '4-р баг',
  },
  {
    code: '43-13-055',
    name: '3-р баг, Бугант',
  },
  {
    code: '43-13-051',
    name: '1-р баг, Тавин',
  },
  {
    code: '65-40-061',
    name: '6-р баг, Өндөр сант',
  },
  {
    code: '11-01-053',
    name: '2-р хороо',
  },
  {
    code: '11-01-051',
    name: '1-р хороо',
  },
  {
    code: '21-22-053',
    name: '2-р баг, Баянхангай',
  },
  {
    code: '21-22-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '82-01-059',
    name: '5-р баг, Рашаант',
  },
  {
    code: '46-31-055',
    name: '3-р баг, Жавхлант',
  },
  {
    code: '85-46-069',
    name: '11-р баг',
  },
  {
    code: '82-01-057',
    name: '4-р баг, Харзат',
  },
  {
    code: '46-31-057',
    name: '4-р баг, Баян',
  },
  {
    code: '46-31-051',
    name: '1-р баг, Номгон',
  },
  {
    code: '46-31-053',
    name: '2-р баг, Гавилууд',
  },
  {
    code: '82-01-051',
    name: '1-р баг, Баянхайрхан',
  },
  {
    code: '85-46-061',
    name: '6-р баг',
  },
  {
    code: '65-40-059',
    name: '5-р баг, Орхон',
  },
  {
    code: '85-46-063',
    name: '8-р баг',
  },
  {
    code: '82-01-055',
    name: '3-р баг, Жаргалант',
  },
  {
    code: '85-46-065',
    name: '9-р баг',
  },
  {
    code: '82-01-053',
    name: '2-р баг, Баяншанд',
  },
  {
    code: '85-46-067',
    name: '10-р баг',
  },
  {
    code: '65-40-053',
    name: '2-р баг, Хөөвөр',
  },
  {
    code: '65-40-051',
    name: '1-р баг, Хотонт',
  },
  {
    code: '65-40-057',
    name: '4-р баг, Улаан чулуу',
  },
  {
    code: '65-40-055',
    name: '3-р баг, Бургалтай',
  },
  {
    code: '21-22-061',
    name: '6-р баг, Эрдэнэбадрах',
  },
  {
    code: '46-31-059',
    name: '5-р баг, Хайрхан',
  },
  {
    code: '67-16-055',
    name: '3-р баг, Рашаант',
  },
  {
    code: '67-16-057',
    name: '4-р баг, Хужирт',
  },
  {
    code: '67-16-051',
    name: '1-р баг, Нүхт',
  },
  {
    code: '48-43-061',
    name: '6-р баг, Сангийн далай',
  },
  {
    code: '67-16-053',
    name: '2-р баг, Зүрх',
  },
  {
    code: '48-43-063',
    name: '7-р баг',
  },
  {
    code: '82-01-061',
    name: '6-р баг, Наран',
  },
  {
    code: '23-25-051',
    name: '1-р баг, Арвин',
  },
  {
    code: '67-16-059',
    name: '5-р баг, Галт',
  },
  {
    code: '48-34-051',
    name: '1-р баг, Онги',
  },
  {
    code: '23-25-057',
    name: '4-р баг, Сангийндалай',
  },
  {
    code: '48-34-053',
    name: '2-р баг, Мааньт',
  },
  {
    code: '23-25-059',
    name: '5-р баг, Жаргалант',
  },
  {
    code: '48-34-055',
    name: '3-р баг, Найз',
  },
  {
    code: '23-25-053',
    name: '2-р баг, Оч',
  },
  {
    code: '48-34-057',
    name: '4-р баг, Төгрөг',
  },
  {
    code: '23-25-055',
    name: '3-р баг, Баянбадрал',
  },
  {
    code: '23-25-061',
    name: '6-р баг, Буянтбулаг',
  },
  {
    code: '84-04-055',
    name: '3-р баг, Барлаг',
  },
  {
    code: '84-04-057',
    name: '4-р баг, Тахилт',
  },
  {
    code: '84-04-051',
    name: '1-р баг, Бодонч',
  },
  {
    code: '84-04-053',
    name: '2-р баг, Алтангадас',
  },
  {
    code: '21-13-053',
    name: '2-р баг, Хулсан шанд',
  },
  {
    code: '21-13-055',
    name: '3-р баг, Баян-Уул',
  },
  {
    code: '21-13-057',
    name: '4-р баг, Чулуут',
  },
  {
    code: '85-10-051',
    name: '1-р баг, Торхилог',
  },
  {
    code: '46-04-053',
    name: '2-р баг, Наран',
  },
  {
    code: '46-04-055',
    name: '3-р баг, Төхөм',
  },
  {
    code: '81-40-063',
    name: '7-р баг, Оргих',
  },
  {
    code: '81-40-061',
    name: '6-р баг, Идэр',
  },
  {
    code: '85-10-055',
    name: '3-р баг, Хандгайт',
  },
  {
    code: '85-10-053',
    name: '2-р баг, Зүүнхөвөө',
  },
  {
    code: '46-04-051',
    name: '1-р баг, Баян',
  },
  {
    code: '21-13-051',
    name: '1-р баг, Өндөр хошуу',
  },
  {
    code: '41-10-051',
    name: '1-р баг, Ноён шанд',
  },
  {
    code: '62-31-053',
    name: '2-р баг, Баянтээг',
  },
  {
    code: '67-52-057',
    name: '4-р баг, Хужирт',
  },
  {
    code: '62-31-055',
    name: '3-р баг, Өндөрхөмөг',
  },
  {
    code: '67-52-055',
    name: '3-р баг, Тосон',
  },
  {
    code: '62-31-057',
    name: '4-р баг, Цагаан-Овоо',
  },
  {
    code: '67-52-053',
    name: '2-р баг, Өвгөд',
  },
  {
    code: '67-52-051',
    name: '1-р баг, Агар',
  },
  {
    code: '81-40-059',
    name: '5-р баг, Баян-Улаан',
  },
  {
    code: '81-40-057',
    name: '4-р баг, Рашаант',
  },
  {
    code: '22-01-051',
    name: '1-р баг',
  },
  {
    code: '81-40-055',
    name: '3-р баг, Улаантолгой',
  },
  {
    code: '22-01-053',
    name: '2-р баг',
  },
  {
    code: '81-40-053',
    name: '2-р баг, Хайрхан',
  },
  {
    code: '22-01-055',
    name: '3-р баг',
  },
  {
    code: '81-40-051',
    name: '1-р баг, Дархан-Уул',
  },
  {
    code: '22-01-057',
    name: '4-р баг',
  },
  {
    code: '22-01-059',
    name: '5-р баг',
  },
  {
    code: '41-10-053',
    name: '2-р баг, Нарст',
  },
  {
    code: '62-31-051',
    name: '1-р баг, Шарга',
  },
  {
    code: '67-52-059',
    name: '5-р баг, Шарга',
  },
  {
    code: '67-52-061',
    name: '6-р баг, Жаргалант',
  },
  {
    code: '64-34-059',
    name: '5-р баг, Мандал',
  },
  {
    code: '48-07-051',
    name: '1-р баг, Шилийн гол',
  },
  {
    code: '64-34-057',
    name: '4-р баг, Баяннуур',
  },
  {
    code: '22-01-061',
    name: '6-р баг',
  },
  {
    code: '64-34-055',
    name: '3-р баг, Үнэгт',
  },
  {
    code: '22-01-063',
    name: '7-р баг',
  },
  {
    code: '64-34-053',
    name: '2-р баг, Сүмбэр',
  },
  {
    code: '22-01-065',
    name: '8-р баг',
  },
  {
    code: '64-34-051',
    name: '1-р баг, Хайрхан',
  },
  {
    code: '22-01-067',
    name: '9-р баг',
  },
  {
    code: '48-07-053',
    name: '2-р баг, Энгэр-Ус',
  },
  {
    code: '48-07-055',
    name: '3-р баг, Аргатай',
  },
  {
    code: '44-37-057',
    name: '4-р баг, Хөвсгөл',
  },
  {
    code: '44-37-055',
    name: '3-р баг, Элст',
  },
  {
    code: '44-37-053',
    name: '2-р баг, Чулуут',
  },
  {
    code: '44-37-051',
    name: '1-р баг, Жавхлант',
  },
  {
    code: '64-34-061',
    name: '6-р баг, Баян хошуу',
  },
  {
    code: '81-13-057',
    name: '4-р баг, Төөнт',
  },
  {
    code: '81-13-055',
    name: '2-р баг, Минж',
  },
  {
    code: '81-13-053',
    name: '1-р баг, Асгат',
  },
  {
    code: '81-13-051',
    name: '3-р баг, Наран',
  },
  {
    code: '82-46-051',
    name: '1-р баг, Чандмань-Уул',
  },
  {
    code: '82-46-053',
    name: '2-р баг, Өлзийбулаг',
  },
  {
    code: '62-04-055',
    name: '3-р баг, Өлзийт хошуу',
  },
  {
    code: '62-04-057',
    name: '4-р баг, Хөөвөр',
  },
  {
    code: '62-04-051',
    name: '1-р баг, Цагаан овоо',
  },
  {
    code: '62-04-053',
    name: '2-р баг, Хүүхдийн-Ус',
  },
  {
    code: '82-46-055',
    name: '3-р баг, Эрдэнэ-Уул',
  },
  {
    code: '82-46-057',
    name: '4-р баг, Хүрхрээ',
  },
  {
    code: '85-28-057',
    name: '4-р баг, Хөдөлмөр',
  },
  {
    code: '41-46-053',
    name: '2-р баг, Дуут-Хуримт',
  },
  {
    code: '85-28-055',
    name: '3-р баг, Хулст нуур',
  },
  {
    code: '41-46-051',
    name: '1-р баг, Тарган',
  },
  {
    code: '41-46-055',
    name: '3-р баг, Давст',
  },
  {
    code: '21-04-053',
    name: '2-р баг, Хайрхан',
  },
  {
    code: '81-28-057',
    name: '4-р баг, Нуур',
  },
  {
    code: '21-04-051',
    name: '4-р баг, Наран',
  },
  {
    code: '81-28-055',
    name: '3-р баг, Дархан-Уул',
  },
  {
    code: '85-28-053',
    name: '2-р баг, Өлгий нуур',
  },
  {
    code: '21-04-057',
    name: '1-р баг, Түргэн',
  },
  {
    code: '81-28-053',
    name: '2-р баг, Баянзүрх',
  },
  {
    code: '85-28-051',
    name: '1-р баг, Чаргат',
  },
  {
    code: '21-04-055',
    name: '3-р баг, Яргай',
  },
  {
    code: '81-28-051',
    name: '1-р баг, Хөдрөг',
  },
  {
    code: '44-28-057',
    name: '4-р баг, Өлзийт',
  },
  {
    code: '65-49-059',
    name: '5-р баг, Ихбулаг',
  },
  {
    code: '65-49-057',
    name: '4-р баг, Хонгорж',
  },
  {
    code: '81-28-059',
    name: '5-р баг, Хайрхан',
  },
  {
    code: '65-49-051',
    name: '1-р баг, Чулуут',
  },
  {
    code: '82-07-061',
    name: '6-р баг, Алтангадас',
  },
  {
    code: '44-28-051',
    name: '1-р баг, Улаан шороот',
  },
  {
    code: '44-28-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '65-49-055',
    name: '3-р баг, Хужирт',
  },
  {
    code: '44-28-055',
    name: '3-р баг, Цохио',
  },
  {
    code: '65-49-053',
    name: '2-р баг, Туулант',
  },
  {
    code: '21-19-051',
    name: '1-р баг, Сэвсүүл жараахай',
  },
  {
    code: '82-07-059',
    name: '5-р баг, Баянговь',
  },
  {
    code: '21-19-053',
    name: '2-р баг, Харзат',
  },
  {
    code: '21-19-059',
    name: '5-р баг, Улз',
  },
  {
    code: '21-19-055',
    name: '3-р баг, Чух',
  },
  {
    code: '21-19-057',
    name: '4-р баг, Номинт',
  },
  {
    code: '82-07-051',
    name: '1-р баг, Баян богд',
  },
  {
    code: '82-07-053',
    name: '2-р баг, Чандмань хайрхан',
  },
  {
    code: '82-07-055',
    name: '3-р баг, Баянхайрхан',
  },
  {
    code: '82-07-057',
    name: '4-р баг, Хүйсийн говь',
  },
  {
    code: '64-07-055',
    name: '3-р баг, Хангал',
  },
  {
    code: '64-07-057',
    name: '4-р баг, Бүрд',
  },
  {
    code: '84-49-053',
    name: '2-р баг, Намаржин',
  },
  {
    code: '84-49-051',
    name: '1-р баг, Баянгол',
  },
  {
    code: '62-19-059',
    name: '5-р баг, Онгон',
  },
  {
    code: '84-49-057',
    name: '4-р баг, Шураг',
  },
  {
    code: '84-49-055',
    name: '3-р баг, Хонгио',
  },
  {
    code: '64-07-051',
    name: '1-р баг, Сангийн далай',
  },
  {
    code: '64-07-053',
    name: '2-р баг, Ар жаргалант',
  },
  {
    code: '84-49-059',
    name: '5-р баг, Хар ус',
  },
  {
    code: '62-19-051',
    name: '1-р баг, Ар жаргалант',
  },
  {
    code: '62-19-053',
    name: '2-р баг, Их боригдой',
  },
  {
    code: '62-19-055',
    name: '3-р баг, Донгит',
  },
  {
    code: '62-19-057',
    name: '4-р баг, Ар хөшөөт',
  },
  {
    code: '67-61-051',
    name: '1-р баг, Шивэрт',
  },
  {
    code: '67-61-057',
    name: '4-р баг, Хөхөө',
  },
  {
    code: '67-61-059',
    name: '5-р баг, Хайрхан толгой',
  },
  {
    code: '67-61-053',
    name: '2-р баг, Ёлгос',
  },
  {
    code: '67-61-055',
    name: '3-р баг, Улаан асга',
  },
  {
    code: '41-55-051',
    name: '1-р баг, Цагаан уул',
  },
  {
    code: '81-37-057',
    name: '4-р баг, Тариат',
  },
  {
    code: '81-37-059',
    name: '5-р баг, Бор-Өндөр',
  },
  {
    code: '63-46-059',
    name: '5-р баг, Хонгор',
  },
  {
    code: '81-37-053',
    name: '2-р баг, Айраг нуур',
  },
  {
    code: '63-28-051',
    name: '1-р баг, Хөгнө хан',
  },
  {
    code: '81-37-055',
    name: '3-р баг, Шар нуруу',
  },
  {
    code: '63-28-053',
    name: '2-р баг, Хар чулуут',
  },
  {
    code: '41-55-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '63-46-055',
    name: '3-р баг, Уньт',
  },
  {
    code: '63-28-055',
    name: '3-р баг, Улаан шивээт',
  },
  {
    code: '41-55-055',
    name: '3-р баг, Төв',
  },
  {
    code: '63-46-057',
    name: '4-р баг, Тээл',
  },
  {
    code: '81-37-051',
    name: '1-р баг, Баян-Айраг',
  },
  {
    code: '63-28-057',
    name: '4-р баг, Аргалхайрхан',
  },
  {
    code: '63-46-051',
    name: '1-р баг',
  },
  {
    code: '63-46-053',
    name: '2-р баг, Хантай',
  },
  {
    code: '81-22-051',
    name: '1-р баг, Мануустай',
  },
  {
    code: '81-22-055',
    name: '3-р баг, Загастай',
  },
  {
    code: '48-43-051',
    name: '1-р баг, Цавчир',
  },
  {
    code: '64-25-061',
    name: '6-р баг, Хориулт',
  },
  {
    code: '81-22-053',
    name: '2-р баг, Цэцэрлэг',
  },
  {
    code: '48-43-053',
    name: '2-р баг, Өнгөт',
  },
  {
    code: '48-43-055',
    name: '3-р баг, Тэнгэлэг',
  },
  {
    code: '81-22-057',
    name: '4-р баг, Дархан-Уул',
  },
  {
    code: '48-43-057',
    name: '4-р баг, Рашаант',
  },
  {
    code: '48-43-059',
    name: '5-р баг, Цагаан-Овоо',
  },
  {
    code: '22-28-057',
    name: '4-р баг, Баянцогт',
  },
  {
    code: '22-28-053',
    name: '2-р баг, Хошмиг',
  },
  {
    code: '43-49-055',
    name: '3-р баг, Дулаанхаан',
  },
  {
    code: '22-28-055',
    name: '3-р баг, Баян-Овоо',
  },
  {
    code: '43-49-053',
    name: '2-р баг, Охиндий',
  },
  {
    code: '43-49-051',
    name: '1-р баг, Дэлгэрхаан',
  },
  {
    code: '22-28-051',
    name: '1-р баг, Лхүмбэ',
  },
  {
    code: '64-25-057',
    name: '4-р баг, Цэлгэр',
  },
  {
    code: '64-25-055',
    name: '3-р баг, Алтай',
  },
  {
    code: '83-25-059',
    name: '5-р баг, Ямаат',
  },
  {
    code: '64-25-053',
    name: '2-р баг, Гурван гол',
  },
  {
    code: '83-25-057',
    name: '4-р баг, Улаанчулуун',
  },
  {
    code: '64-25-051',
    name: '1-р баг, Луугар',
  },
  {
    code: '83-25-055',
    name: '3-р баг, Ховд',
  },
  {
    code: '83-25-053',
    name: '2-р баг, Чихтэй',
  },
  {
    code: '83-25-051',
    name: '1-р баг, Бахлаг',
  },
  {
    code: '64-25-059',
    name: '5-р баг, Буянт',
  },
  {
    code: '83-25-067',
    name: '9-р баг, Цагааннуур',
  },
  {
    code: '83-25-065',
    name: '8-р баг, Асгат',
  },
  {
    code: '83-25-063',
    name: '7-р баг, Хосхарагай',
  },
  {
    code: '83-25-061',
    name: '6-р баг, Хызылхайын',
  },
  {
    code: '46-40-051',
    name: '1-р баг, Замын шанд',
  },
  {
    code: '46-40-053',
    name: '2-р баг, Бортээг',
  },
  {
    code: '46-40-055',
    name: '3-р баг, Найз',
  },
  {
    code: '62-49-061',
    name: '6-р баг, Марзат',
  },
  {
    code: '11-25-085',
    name: '18-р хороо',
  },
  {
    code: '11-25-087',
    name: '19-р хороо',
  },
  {
    code: '65-04-061',
    name: '6-р баг, Дайрбор',
  },
  {
    code: '11-25-081',
    name: '16-р хороо',
  },
  {
    code: '62-37-051',
    name: '1-р баг, Царги',
  },
  {
    code: '11-25-083',
    name: '17-р хороо',
  },
  {
    code: '62-37-053',
    name: '2-р баг, Цахиурт',
  },
  {
    code: '62-37-059',
    name: '5-р баг, Майхан',
  },
  {
    code: '62-37-055',
    name: '3-р баг, Улаан-Овоо',
  },
  {
    code: '62-37-057',
    name: '4-р баг, Залаа',
  },
  {
    code: '65-19-055',
    name: '3-р баг, Байшир',
  },
  {
    code: '65-19-057',
    name: '4-р баг, Хөшөөт',
  },
  {
    code: '11-25-079',
    name: '15-р хороо',
  },
  {
    code: '65-19-051',
    name: '1-р баг, Ямаат',
  },
  {
    code: '65-19-053',
    name: '2-р баг, Бодонт',
  },
  {
    code: '11-25-075',
    name: '13-р хороо',
  },
  {
    code: '11-25-077',
    name: '14-р хороо',
  },
  {
    code: '11-25-071',
    name: '11-р хороо',
  },
  {
    code: '23-49-057',
    name: '4-р баг, Баянмод',
  },
  {
    code: '65-04-051',
    name: '1-р баг, Улаанчулуу',
  },
  {
    code: '11-25-073',
    name: '12-р хороо',
  },
  {
    code: '23-49-055',
    name: '3-р баг, Согоот',
  },
  {
    code: '65-04-053',
    name: '2-р баг, Хөнөг',
  },
  {
    code: '23-49-053',
    name: '2-р баг, Нугаар',
  },
  {
    code: '65-04-055',
    name: '3-р баг, Дэл',
  },
  {
    code: '23-49-051',
    name: '1-р баг, Хужхан',
  },
  {
    code: '65-04-057',
    name: '4-р баг, Баян-Уул',
  },
  {
    code: '65-04-059',
    name: '5-р баг, Цац',
  },
  {
    code: '63-16-061',
    name: '6-р баг, Хулст',
  },
  {
    code: '41-01-061',
    name: '6-р баг, Баруун зуунмод',
  },
  {
    code: '11-25-067',
    name: '9-р хороо',
  },
  {
    code: '11-25-069',
    name: '10-р хороо',
  },
  {
    code: '11-25-063',
    name: '7-р хороо',
  },
  {
    code: '11-25-065',
    name: '8-р хороо',
  },
  {
    code: '41-16-051',
    name: '1-р баг, Цант хөдөө',
  },
  {
    code: '41-16-053',
    name: '2-р баг, Өгөөмөр',
  },
  {
    code: '11-25-061',
    name: '6-р хороо',
  },
  {
    code: '63-16-059',
    name: '5-р баг, Хөгнө',
  },
  {
    code: '63-16-057',
    name: '4-р баг, Бэрх',
  },
  {
    code: '63-16-055',
    name: '3-р баг, Агьт',
  },
  {
    code: '63-16-053',
    name: '2-р баг, Авзага',
  },
  {
    code: '63-01-061',
    name: '6-р баг, Булган',
  },
  {
    code: '63-16-051',
    name: '1-р баг, Тогоо',
  },
  {
    code: '41-16-055',
    name: '3-р баг, Цавчир',
  },
  {
    code: '62-49-053',
    name: '2-р баг, Нарт',
  },
  {
    code: '63-01-055',
    name: '3-р баг, Агуйт',
  },
  {
    code: '62-49-051',
    name: '1-р баг, Бурхант',
  },
  {
    code: '63-01-057',
    name: '4-р баг, Рашаант',
  },
  {
    code: '63-01-051',
    name: '1-р баг, Ачуут',
  },
  {
    code: '63-01-053',
    name: '2-р баг, Хужирт',
  },
  {
    code: '11-25-057',
    name: '4-р хороо',
  },
  {
    code: '11-25-059',
    name: '5-р хороо',
  },
  {
    code: '62-49-059',
    name: '5-р баг, Ар агуйт',
  },
  {
    code: '11-25-053',
    name: '2-р хороо',
  },
  {
    code: '62-49-057',
    name: '4-р баг, Дэрсэн хонхор',
  },
  {
    code: '63-01-059',
    name: '5-р баг, Жаргалант',
  },
  {
    code: '11-25-055',
    name: '3-р хороо',
  },
  {
    code: '62-49-055',
    name: '3-р баг, Эмээлт',
  },
  {
    code: '41-01-059',
    name: '5-р баг, Нацагдорж',
  },
  {
    code: '11-25-051',
    name: '1-р хороо',
  },
  {
    code: '41-01-051',
    name: '1-р баг, Номт',
  },
  {
    code: '41-01-053',
    name: '2-р баг, Ланс',
  },
  {
    code: '41-01-055',
    name: '3-р баг, Баянхошуу',
  },
  {
    code: '41-01-057',
    name: '4-р баг, Зүүндэлгэр',
  },
  {
    code: '43-04-055',
    name: '3-р баг, Цөх',
  },
  {
    code: '43-04-051',
    name: '1-р баг, Бүргэдэй',
  },
  {
    code: '43-04-053',
    name: '2-р баг, Суварга',
  },
  {
    code: '21-31-055',
    name: '3-р баг, Баян-Уул',
  },
  {
    code: '21-31-053',
    name: '2-р баг, Батхаан',
  },
  {
    code: '21-31-051',
    name: '1-р баг, Баян-Өлзийт',
  },
  {
    code: '82-19-051',
    name: '1-р баг, Баян-Өндөр',
  },
  {
    code: '82-19-053',
    name: '2-р баг, Баянхонгор',
  },
  {
    code: '82-19-055',
    name: '3-р баг, Баянбуурал',
  },
  {
    code: '23-07-055',
    name: '3-р баг, Хурх',
  },
  {
    code: '82-19-057',
    name: '4-р баг, Баянсан',
  },
  {
    code: '23-07-053',
    name: '2-р баг, Барх',
  },
  {
    code: '82-19-059',
    name: '5-р баг, Гуулин',
  },
  {
    code: '23-07-051',
    name: '1-р баг, Онон',
  },
  {
    code: '43-19-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '43-19-053',
    name: '2-р баг, Бэлчир',
  },
  {
    code: '43-19-055',
    name: '3-р баг, Мангирт',
  },
  {
    code: '67-34-051',
    name: '1-р баг, Мухар хөндий',
  },
  {
    code: '23-07-057',
    name: '4-р баг, Норовлин',
  },
  {
    code: '67-34-053',
    name: '2-р баг, Сэлэнгэ',
  },
  {
    code: '67-34-055',
    name: '3-р баг, Тээл',
  },
  {
    code: '85-01-071',
    name: '11-р баг',
  },
  {
    code: '67-34-057',
    name: '4-р баг, Сүүл Улаан',
  },
  {
    code: '67-34-059',
    name: '5-р баг, Цэнгэл',
  },
  {
    code: '23-34-053',
    name: '2-р баг, Долоод',
  },
  {
    code: '23-34-051',
    name: '1-р баг, Хэрлэнбаян улаан',
  },
  {
    code: '45-07-051',
    name: '1-р баг',
  },
  {
    code: '81-67-059',
    name: '5-р баг, Хайрхан',
  },
  {
    code: '45-07-055',
    name: '3-р баг, Салхит',
  },
  {
    code: '81-67-055',
    name: '3-р баг, Алтан',
  },
  {
    code: '67-07-057',
    name: '4-р баг, Сүмбэр',
  },
  {
    code: '45-07-053',
    name: '2-р баг',
  },
  {
    code: '81-67-057',
    name: '2-р баг, Баянзүрх',
  },
  {
    code: '67-07-059',
    name: '5-р баг, Тарган нуур',
  },
  {
    code: '81-67-051',
    name: '1-р баг, Багануур',
  },
  {
    code: '23-34-057',
    name: '4-р баг, Хэрлэн тооно',
  },
  {
    code: '67-07-053',
    name: '2-р баг, Бор гол',
  },
  {
    code: '81-67-053',
    name: '4-р баг, Мөсөн',
  },
  {
    code: '23-34-055',
    name: '3-р баг, Аварга',
  },
  {
    code: '67-07-055',
    name: '3-р баг, Бэл булаг',
  },
  {
    code: '67-07-051',
    name: '1-р баг, Хавтага',
  },
  {
    code: '43-31-051',
    name: '1-р баг, Хөтөл',
  },
  {
    code: '43-31-053',
    name: '2-р баг, Гавшгай',
  },
  {
    code: '65-31-057',
    name: '4-р баг, Могой',
  },
  {
    code: '43-31-055',
    name: '3-р баг, Номгон',
  },
  {
    code: '65-31-059',
    name: '5-р баг, Өгөөмөр',
  },
  {
    code: '65-31-053',
    name: '2-р баг, Асгат',
  },
  {
    code: '65-31-055',
    name: '3-р баг, Жарантай',
  },
  {
    code: '67-07-061',
    name: '6-р баг, Урт булаг',
  },
  {
    code: '65-31-051',
    name: '1-р баг, Хайрхан',
  },
  {
    code: '65-37-059',
    name: '5-р баг, Баян',
  },
  {
    code: '65-37-051',
    name: '1-р баг, Жаргалант',
  },
  {
    code: '65-37-053',
    name: '2-р баг, Номгон',
  },
  {
    code: '65-37-055',
    name: '3-р баг, Цайдам',
  },
  {
    code: '65-37-057',
    name: '4-р баг, Цагаан хад',
  },
  {
    code: '48-01-059',
    name: '5-р баг, Аривжих',
  },
  {
    code: '46-28-053',
    name: '2-р баг, Хоолт',
  },
  {
    code: '46-28-051',
    name: '1-р баг, Сайншанд',
  },
  {
    code: '67-10-059',
    name: '5-р баг, Бэлтэс',
  },
  {
    code: '46-28-055',
    name: '3-р баг, Бүйлсэн',
  },
  {
    code: '67-10-057',
    name: '4-р баг, Агар',
  },
  {
    code: '81-64-051',
    name: '1-р баг, Чандмань',
  },
  {
    code: '67-10-055',
    name: '3-р баг, Тоом',
  },
  {
    code: '81-64-053',
    name: '2-р баг, Баянулаан',
  },
  {
    code: '67-10-053',
    name: '2-р баг, Хайс',
  },
  {
    code: '81-64-055',
    name: '3-р баг, Хөгжил',
  },
  {
    code: '67-10-051',
    name: '1-р баг, Эмт',
  },
  {
    code: '81-64-057',
    name: '4-р баг, Сайхан',
  },
  {
    code: '48-01-051',
    name: '1-р баг, Наран',
  },
  {
    code: '48-01-053',
    name: '2-р баг, Тэвш',
  },
  {
    code: '48-01-055',
    name: '3-р баг, Далай',
  },
  {
    code: '48-01-057',
    name: '4-р баг, Үйзэн',
  },
  {
    code: '63-25-055',
    name: '3-р баг, Бүхт',
  },
  {
    code: '44-25-051',
    name: '1-р баг, Сүмийн булаг',
  },
  {
    code: '63-25-053',
    name: '2-р баг, Халиун',
  },
  {
    code: '22-34-051',
    name: '1-р баг, Халзан шанд',
  },
  {
    code: '63-25-051',
    name: '1-р баг, Арбулаг',
  },
  {
    code: '22-34-053',
    name: '2-р баг, Сахиул',
  },
  {
    code: '85-40-053',
    name: '2-р баг, Тарвагатай',
  },
  {
    code: '85-40-055',
    name: '3-р баг, Мянган',
  },
  {
    code: '22-25-051',
    name: '1-р баг, Сэргэлэн',
  },
  {
    code: '63-25-059',
    name: '5-р баг, Мандал',
  },
  {
    code: '63-25-057',
    name: '4-р баг, Мааньт',
  },
  {
    code: '85-40-051',
    name: '1-р баг, Бургастай',
  },
  {
    code: '22-25-055',
    name: '3-р баг, Үнэгт',
  },
  {
    code: '22-25-053',
    name: '2-р баг, Өлзийт',
  },
  {
    code: '22-25-059',
    name: '5-р баг, Өгөөмөр',
  },
  {
    code: '85-40-057',
    name: '4-р баг, Толь',
  },
  {
    code: '22-25-057',
    name: '4-р баг, Дэлгэрхаан',
  },
  {
    code: '85-40-059',
    name: '5-р баг, Хөхөө',
  },
  {
    code: '22-34-055',
    name: '3-р баг, Сайншанд',
  },
  {
    code: '22-34-057',
    name: '4-р баг, Хатавч',
  },
  {
    code: '44-25-057',
    name: '4-р баг, Сэнж',
  },
  {
    code: '44-25-055',
    name: '3-р баг, Баянмөнх',
  },
  {
    code: '44-25-053',
    name: '2-р баг, Сүмбэр',
  },
  {
    code: '85-40-061',
    name: '6-р баг, Хархираа',
  },
  {
    code: '48-10-051',
    name: '1-р баг, Ажирхай',
  },
  {
    code: '85-25-051',
    name: '1-р баг, Гүн бүрд',
  },
  {
    code: '85-25-053',
    name: '2-р баг, Алдар',
  },
  {
    code: '85-25-055',
    name: '3-р баг, Хужирт',
  },
  {
    code: '85-25-057',
    name: '4-р баг, Улаан-Үзүүр',
  },
  {
    code: '48-10-055',
    name: '3-р баг, Хонгор',
  },
  {
    code: '48-10-053',
    name: '2-р баг, Морьт',
  },
  {
    code: '84-37-051',
    name: '1-р баг, Цагаантүнгэ',
  },
  {
    code: '84-37-053',
    name: '2-р баг, Нарийн гол',
  },
  {
    code: '84-37-055',
    name: '3-р баг, Жаргалан',
  },
  {
    code: '84-37-057',
    name: '4-р баг, Улиаст',
  },
  {
    code: '84-37-059',
    name: '5-р баг, Хөх үзүүр',
  },
  {
    code: '65-28-051',
    name: '1-р баг, Хөх сүм',
  },
  {
    code: '65-28-055',
    name: '3-р баг, Урантолгой',
  },
  {
    code: '65-28-053',
    name: '2-р баг, Баян-Өндөр',
  },
  {
    code: '65-28-057',
    name: '4-р баг, Өртөнт',
  },
  {
    code: '67-64-051',
    name: '1-р баг, Сангийн далай',
  },
  {
    code: '67-64-053',
    name: '2-р баг, Баяннуур',
  },
  {
    code: '43-37-053',
    name: '2-р баг, Ар нуга',
  },
  {
    code: '67-64-055',
    name: '3-р баг, Баянзүрх',
  },
  {
    code: '43-37-051',
    name: '1-р баг, Жаргалмандах',
  },
  {
    code: '67-64-057',
    name: '4-р баг, Нүхт',
  },
  {
    code: '45-10-053',
    name: '2-р баг, Дархан',
  },
  {
    code: '45-10-055',
    name: '3-р баг, Санжинт',
  },
  {
    code: '45-10-051',
    name: '1-р баг, Хайрхан',
  },
  {
    code: '41-34-051',
    name: '1-р баг, Гуна',
  },
  {
    code: '41-34-053',
    name: '2-р баг, Сарлаг',
  },
  {
    code: '63-34-059',
    name: '5-р баг, Ингэт',
  },
  {
    code: '41-34-055',
    name: '3-р баг, Даргиат',
  },
  {
    code: '63-34-055',
    name: '3-р баг, Сэлэнгэбүрэн',
  },
  {
    code: '63-34-057',
    name: '4-р баг, Атар',
  },
  {
    code: '63-34-051',
    name: '1-р баг, Таримал',
  },
  {
    code: '63-34-053',
    name: '2-р баг, Тариахтай',
  },
  {
    code: '48-01-061',
    name: '6-р баг, Боржигон',
  },
  {
    code: '48-01-063',
    name: '7-р баг, Нарлаг',
  },
  {
    code: '48-01-065',
    name: '8-р баг, Айраг',
  },
  {
    code: '48-01-067',
    name: '9-р баг, Мандал',
  },
  {
    code: '82-34-053',
    name: '2-р баг, Гүү бариач',
  },
  {
    code: '82-34-055',
    name: '3-р баг, Олон булаг',
  },
  {
    code: '82-34-051',
    name: '1-р баг, Сүүж',
  },
  {
    code: '82-34-057',
    name: '4-р баг, Чацран',
  },
  {
    code: '83-31-061',
    name: '6-р баг, Бураат',
  },
  {
    code: '21-37-053',
    name: '2-р баг, Сүмбэр',
  },
  {
    code: '63-19-053',
    name: '2-р баг, Лах',
  },
  {
    code: '11-16-057',
    name: '4-р хороо',
  },
  {
    code: '21-37-051',
    name: '1-р баг, Хулстай',
  },
  {
    code: '63-19-055',
    name: '3-р баг, Доргонт',
  },
  {
    code: '11-16-055',
    name: '3-р хороо',
  },
  {
    code: '23-10-051',
    name: '1-р баг, Сайхан',
  },
  {
    code: '21-37-057',
    name: '4-р баг, Хөх нуур',
  },
  {
    code: '63-19-057',
    name: '4-р баг, Төв',
  },
  {
    code: '11-16-053',
    name: '2-р хороо',
  },
  {
    code: '23-10-053',
    name: '2-р баг, Жаргалант',
  },
  {
    code: '21-37-055',
    name: '3-р баг, Энгэр шанд',
  },
  {
    code: '11-16-051',
    name: '1-р хороо',
  },
  {
    code: '23-10-055',
    name: '3-р баг, Адарга',
  },
  {
    code: '63-40-057',
    name: '4-р баг, Хялганат',
  },
  {
    code: '63-19-051',
    name: '1-р баг, Хараат',
  },
  {
    code: '11-16-059',
    name: '5-р хороо',
  },
  {
    code: '85-34-059',
    name: '5-р баг, Цэцэрлэг',
  },
  {
    code: '63-40-051',
    name: '1-р баг, Сөрт',
  },
  {
    code: '67-01-071',
    name: '11-р баг',
  },
  {
    code: '63-40-053',
    name: '2-р баг, Хангал',
  },
  {
    code: '67-01-073',
    name: '12-р баг',
  },
  {
    code: '63-40-055',
    name: '3-р баг',
  },
  {
    code: '67-01-075',
    name: '13-р баг',
  },
  {
    code: '85-34-051',
    name: '1-р баг, Цалуу',
  },
  {
    code: '23-10-057',
    name: '4-р баг, дуурлиг',
  },
  {
    code: '85-34-053',
    name: '2-р баг, Батсайхан',
  },
  {
    code: '85-34-055',
    name: '3-р баг, Цагааннуур',
  },
  {
    code: '85-34-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '45-01-063',
    name: '7-р баг',
  },
  {
    code: '82-16-051',
    name: '1-р баг, Ихэс',
  },
  {
    code: '45-01-065',
    name: '8-р баг',
  },
  {
    code: '45-01-061',
    name: '6-р баг',
  },
  {
    code: '67-01-067',
    name: '9-р баг',
  },
  {
    code: '82-16-057',
    name: '4-р баг, Үйлдвэр',
  },
  {
    code: '67-01-069',
    name: '10-р баг',
  },
  {
    code: '82-16-055',
    name: '3-р баг, Жавхлант',
  },
  {
    code: '82-16-053',
    name: '2-р баг, Хужирт',
  },
  {
    code: '67-01-061',
    name: '6-р баг',
  },
  {
    code: '67-01-063',
    name: '7-р баг',
  },
  {
    code: '67-01-065',
    name: '8-р баг',
  },
  {
    code: '41-25-051',
    name: '1-р баг, Бараат',
  },
  {
    code: '41-25-055',
    name: '3-р баг, Бүрд',
  },
  {
    code: '45-01-067',
    name: '9-р баг',
  },
  {
    code: '41-25-053',
    name: '2-р баг, Цээл',
  },
  {
    code: '45-01-069',
    name: '10-р баг',
  },
  {
    code: '43-28-055',
    name: '3-р баг, Хонгор-Овоо',
  },
  {
    code: '45-01-051',
    name: '1-р баг',
  },
  {
    code: '43-28-053',
    name: '2-р баг, Баянцогт',
  },
  {
    code: '45-01-053',
    name: '2-р баг',
  },
  {
    code: '43-28-051',
    name: '1-р баг, Рашаант',
  },
  {
    code: '67-01-055',
    name: '3-р баг',
  },
  {
    code: '42-07-053',
    name: '2-р баг',
  },
  {
    code: '65-43-051',
    name: '2-р баг, Хан-уул',
  },
  {
    code: '67-01-057',
    name: '4-р баг',
  },
  {
    code: '42-07-051',
    name: '1-р баг',
  },
  {
    code: '65-43-053',
    name: '1-р баг, Баянгол',
  },
  {
    code: '67-01-059',
    name: '5-р баг',
  },
  {
    code: '67-01-051',
    name: '1-р баг',
  },
  {
    code: '65-43-055',
    name: '3-р баг, Цахир',
  },
  {
    code: '67-01-053',
    name: '2-р баг',
  },
  {
    code: '45-01-059',
    name: '5-р баг',
  },
  {
    code: '45-01-055',
    name: '3-р баг',
  },
  {
    code: '45-01-057',
    name: '4-р баг',
  },
  {
    code: '11-16-089',
    name: '20-р хороо',
  },
  {
    code: '83-22-065',
    name: '8-р баг, Бүргэд',
  },
  {
    code: '11-16-087',
    name: '19-р хороо',
  },
  {
    code: '83-22-067',
    name: '9-р баг, Хөх толгой',
  },
  {
    code: '67-46-055',
    name: '3-р баг, Турт',
  },
  {
    code: '11-16-085',
    name: '18-р хороо',
  },
  {
    code: '83-22-061',
    name: '6-р баг, Бугат',
  },
  {
    code: '11-16-083',
    name: '17-р хороо',
  },
  {
    code: '83-22-063',
    name: '7-р баг, Хөх сэрх',
  },
  {
    code: '83-22-069',
    name: '10-р баг, Хүйтэн нуур',
  },
  {
    code: '85-19-051',
    name: '1-р баг, Даланбулаг',
  },
  {
    code: '11-16-081',
    name: '16-р хороо',
  },
  {
    code: '84-19-053',
    name: '2-р баг, Хөх бэлчир',
  },
  {
    code: '85-19-057',
    name: '4-р баг, Хайрхан',
  },
  {
    code: '84-19-051',
    name: '1-р баг, Шивэр',
  },
  {
    code: '84-19-057',
    name: '4-р баг, Босго',
  },
  {
    code: '67-46-053',
    name: '2-р баг, Хороо',
  },
  {
    code: '85-19-053',
    name: '2-р баг, Баянгол',
  },
  {
    code: '84-19-055',
    name: '3-р баг, Цагаан бургас',
  },
  {
    code: '67-46-051',
    name: '1-р баг, Тураг',
  },
  {
    code: '85-19-055',
    name: '3-р баг, Жаргалант',
  },
  {
    code: '81-49-057',
    name: '4-р баг, Зүр',
  },
  {
    code: '83-22-055',
    name: '3-р баг, Хар уул',
  },
  {
    code: '81-49-055',
    name: '3-р баг, Баян-Уул',
  },
  {
    code: '11-16-099',
    name: '25-р хороо',
  },
  {
    code: '83-22-057',
    name: '4-р баг, Чихэртэй',
  },
  {
    code: '81-49-053',
    name: '2-р баг, Нисэг',
  },
  {
    code: '11-16-097',
    name: '24-р хороо',
  },
  {
    code: '83-22-051',
    name: '1-р баг, Далакөл',
  },
  {
    code: '81-49-051',
    name: '1-р баг, Дооно',
  },
  {
    code: '11-16-095',
    name: '23-р хороо',
  },
  {
    code: '83-22-053',
    name: '2-р баг, Саралахаз',
  },
  {
    code: '83-16-061',
    name: '6-р баг, Сөнхөл',
  },
  {
    code: '83-22-059',
    name: '5-р баг, Рашаант',
  },
  {
    code: '83-16-063',
    name: '7-р баг, Улаанхус',
  },
  {
    code: '41-19-053',
    name: '2-р баг, Галуут',
  },
  {
    code: '11-16-093',
    name: '22-р хороо',
  },
  {
    code: '41-19-051',
    name: '1-р баг, Байдлаг',
  },
  {
    code: '11-16-091',
    name: '21-р хороо',
  },
  {
    code: '11-16-067',
    name: '9-р хороо',
  },
  {
    code: '83-16-053',
    name: '2-р баг, Сайхан',
  },
  {
    code: '11-16-065',
    name: '8-р хороо',
  },
  {
    code: '83-16-055',
    name: '3-р баг, Булган',
  },
  {
    code: '11-16-063',
    name: '7-р хороо',
  },
  {
    code: '83-16-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '62-52-061',
    name: '6-р баг, Жалбаа',
  },
  {
    code: '11-16-061',
    name: '6-р хороо',
  },
  {
    code: '83-16-059',
    name: '5-р баг, Хужирт',
  },
  {
    code: '62-52-063',
    name: '7-р баг, Шанх',
  },
  {
    code: '11-16-069',
    name: '10-р хороо',
  },
  {
    code: '83-16-051',
    name: '1-р баг, Улаагчин',
  },
  {
    code: '62-52-065',
    name: '8-р баг, Орхон',
  },
  {
    code: '11-16-079',
    name: '15-р хороо',
  },
  {
    code: '11-16-077',
    name: '14-р хороо',
  },
  {
    code: '62-52-051',
    name: '1-р баг, Вангийн-Овоо',
  },
  {
    code: '11-16-075',
    name: '13-р хороо',
  },
  {
    code: '62-52-053',
    name: '2-р баг, Ганган-Орхон',
  },
  {
    code: '11-16-073',
    name: '12-р хороо',
  },
  {
    code: '62-52-055',
    name: '3-р баг, Эрдэнэтолгой',
  },
  {
    code: '11-16-071',
    name: '11-р хороо',
  },
  {
    code: '62-52-057',
    name: '4-р баг, Нарийн хүр',
  },
  {
    code: '62-52-059',
    name: '5-р баг, Онгоцон-Ухаа',
  },
  {
    code: '11-07-081',
    name: '16-р хороо',
  },
  {
    code: '11-07-083',
    name: '17-р хороо',
  },
  {
    code: '11-07-085',
    name: '18-р хороо',
  },
  {
    code: '11-07-087',
    name: '19-р хороо',
  },
  {
    code: '11-07-089',
    name: '20-р хороо',
  },
  {
    code: '23-40-051',
    name: '1-р баг, Зөөлөн',
  },
  {
    code: '11-07-071',
    name: '11-р хороо',
  },
  {
    code: '11-07-073',
    name: '12-р хороо',
  },
  {
    code: '11-07-075',
    name: '13-р хороо',
  },
  {
    code: '42-01-051',
    name: '1-р баг',
  },
  {
    code: '11-07-077',
    name: '14-р хороо',
  },
  {
    code: '23-40-059',
    name: '5-р баг, Чандган',
  },
  {
    code: '11-07-079',
    name: '15-р хороо',
  },
  {
    code: '23-40-057',
    name: '4-р баг, Цагаан толгой',
  },
  {
    code: '23-40-055',
    name: '3-р баг, Бүрээт',
  },
  {
    code: '62-43-051',
    name: '1-р баг, Хоолт',
  },
  {
    code: '23-40-053',
    name: '2-р баг, Өлзийт',
  },
  {
    code: '62-43-055',
    name: '3-р баг, Мазар',
  },
  {
    code: '62-43-053',
    name: '2-р баг, Их-Ус',
  },
  {
    code: '62-43-059',
    name: '5-р баг, Баян',
  },
  {
    code: '62-43-057',
    name: '4-р баг, Сайн төгрөг',
  },
  {
    code: '42-01-055',
    name: '3-р баг',
  },
  {
    code: '42-01-053',
    name: '2-р баг',
  },
  {
    code: '42-01-059',
    name: '5-р баг',
  },
  {
    code: '42-01-057',
    name: '4-р баг',
  },
  {
    code: '64-01-067',
    name: '9-р баг, Есөнбулаг',
  },
  {
    code: '64-16-051',
    name: '1-р баг, Мандалхайрхан',
  },
  {
    code: '42-01-061',
    name: '6-р баг',
  },
  {
    code: '64-01-063',
    name: '7-р баг, Цахир',
  },
  {
    code: '64-16-053',
    name: '2-р баг, Уранхайрхан',
  },
  {
    code: '64-01-065',
    name: '8-р баг, Шаргалжуут',
  },
  {
    code: '64-16-055',
    name: '3-р баг, Асгамба',
  },
  {
    code: '23-01-061',
    name: '6-р баг, Цогт-Өндөр',
  },
  {
    code: '64-16-057',
    name: '4-р баг, Мэргэн',
  },
  {
    code: '62-28-061',
    name: '6-р баг, Дэвшил',
  },
  {
    code: '23-01-065',
    name: '8-р баг, Ишгэн толгой',
  },
  {
    code: '23-01-063',
    name: '7-р баг, Номгон',
  },
  {
    code: '64-01-061',
    name: '6-р баг, Гэгээн шавь',
  },
  {
    code: '11-07-093',
    name: '22-р хороо',
  },
  {
    code: '11-07-095',
    name: '23-р хороо',
  },
  {
    code: '23-16-055',
    name: '3-р баг, Сүмбэр',
  },
  {
    code: '23-16-057',
    name: '4-р баг, Жавхлант',
  },
  {
    code: '23-01-053',
    name: '2-р баг, Булаг',
  },
  {
    code: '23-16-051',
    name: '1-р баг, Дэлгэрхаан',
  },
  {
    code: '23-01-051',
    name: '1-р баг, Хэрлэн',
  },
  {
    code: '23-16-053',
    name: '2-р баг, Наран',
  },
  {
    code: '23-01-057',
    name: '4-р баг, Сариг',
  },
  {
    code: '23-01-055',
    name: '3-р баг, Баянмөнх',
  },
  {
    code: '23-01-059',
    name: '5-р баг, Өндөрхаан',
  },
  {
    code: '21-28-053',
    name: '2-р баг, Ялалт',
  },
  {
    code: '21-28-055',
    name: '3-р баг, Ташгай',
  },
  {
    code: '11-07-091',
    name: '21-р хороо',
  },
  {
    code: '21-28-051',
    name: '1-р баг, Сүмбэр',
  },
  {
    code: '45-01-085',
    name: '18-р баг, Малчин',
  },
  {
    code: '45-01-081',
    name: '16-р баг',
  },
  {
    code: '45-01-083',
    name: '17-р баг, Өргөө баг',
  },
  {
    code: '81-04-061',
    name: '6-р баг, Мандаат',
  },
  {
    code: '64-31-061',
    name: '6-р баг, Буянт',
  },
  {
    code: '64-46-057',
    name: '4-р баг, Залаа-Овоо',
  },
  {
    code: '64-46-055',
    name: '3-р баг, Чандмань-Овоо',
  },
  {
    code: '81-19-051',
    name: '1-р баг, Мандал',
  },
  {
    code: '64-46-053',
    name: '2-р баг, Баян-Улаан',
  },
  {
    code: '81-19-053',
    name: '2-р баг, Олонбулаг',
  },
  {
    code: '64-46-051',
    name: '1-р баг, Баянбулаг',
  },
  {
    code: '81-19-055',
    name: '3-р баг, Олонтүрүү',
  },
  {
    code: '45-01-073',
    name: '12-р баг',
  },
  {
    code: '64-31-057',
    name: '4-р баг, Баянбүрд',
  },
  {
    code: '84-43-051',
    name: '1-р баг, Хажинга',
  },
  {
    code: '45-01-075',
    name: '13-р баг',
  },
  {
    code: '64-31-055',
    name: '3-р баг, Өлзийт',
  },
  {
    code: '45-01-071',
    name: '11-р баг',
  },
  {
    code: '64-31-059',
    name: '5-р баг, Наран',
  },
  {
    code: '82-40-061',
    name: '6-р баг, Баян-Улаан',
  },
  {
    code: '82-40-063',
    name: '7-р баг, Баян тоорой',
  },
  {
    code: '81-04-051',
    name: '1-р баг, Алдар',
  },
  {
    code: '84-43-057',
    name: '4-р баг, Цэцэг нуур',
  },
  {
    code: '81-04-057',
    name: '4-р баг, Өгөөмөр',
  },
  {
    code: '84-43-059',
    name: '5-р баг, Хөшөөт',
  },
  {
    code: '81-04-059',
    name: '5-р баг, Чигэстэй',
  },
  {
    code: '84-43-053',
    name: '2-р баг, Баянгол',
  },
  {
    code: '45-01-077',
    name: '14-р баг',
  },
  {
    code: '64-31-053',
    name: '2-р баг, Баян',
  },
  {
    code: '81-04-053',
    name: '2-р баг, Аргалант',
  },
  {
    code: '84-43-055',
    name: '3-р баг, Баян-Овоо',
  },
  {
    code: '45-01-079',
    name: '15-р баг',
  },
  {
    code: '64-31-051',
    name: '1-р баг, Тэмээт',
  },
  {
    code: '81-04-055',
    name: '3-р баг, Богдын гол',
  },
  {
    code: '11-07-061',
    name: '6-р хороо',
  },
  {
    code: '11-07-063',
    name: '7-р хороо',
  },
  {
    code: '11-07-065',
    name: '8-р хороо',
  },
  {
    code: '11-07-067',
    name: '9-р хороо',
  },
  {
    code: '11-07-069',
    name: '10-р хороо',
  },
  {
    code: '82-40-051',
    name: '1-р баг, Рашаант',
  },
  {
    code: '82-40-053',
    name: '2-р баг, Далан',
  },
  {
    code: '81-58-051',
    name: '1-р баг, Арц',
  },
  {
    code: '82-40-055',
    name: '3-р баг, Гэгээт',
  },
  {
    code: '82-40-057',
    name: '4-р баг, Төгрөг',
  },
  {
    code: '82-40-059',
    name: '5-р баг, Баян-Өндөр',
  },
  {
    code: '81-58-057',
    name: '4-р баг, Баянхайрхан',
  },
  {
    code: '81-58-053',
    name: '2-р баг, Жавцаг',
  },
  {
    code: '81-58-055',
    name: '3-р баг, Дэлгэр',
  },
  {
    code: '11-07-051',
    name: '1-р хороо',
  },
  {
    code: '11-07-053',
    name: '2-р хороо',
  },
  {
    code: '11-07-055',
    name: '3-р хороо',
  },
  {
    code: '83-31-055',
    name: '3-р баг, Хонгор өлөн',
  },
  {
    code: '11-07-057',
    name: '4-р хороо',
  },
  {
    code: '83-31-053',
    name: '2-р баг, Толбо нуур',
  },
  {
    code: '11-07-059',
    name: '5-р хороо',
  },
  {
    code: '83-31-059',
    name: '5-р баг, Хөх толгой',
  },
  {
    code: '83-31-057',
    name: '4-р баг, Дөрөө нуур',
  },
  {
    code: '81-43-059',
    name: '5-р баг, Шар нуруу',
  },
  {
    code: '81-43-057',
    name: '4-р баг, Ойгон',
  },
  {
    code: '83-31-051',
    name: '1-р баг, Хош',
  },
  {
    code: '81-43-051',
    name: '1-р баг, Баянцагаан',
  },
  {
    code: '81-43-055',
    name: '3-р баг, Цорго',
  },
  {
    code: '81-43-053',
    name: '2-р баг, Аргалант',
  },
  {
    code: '67-55-057',
    name: '4-р баг, Булган',
  },
  {
    code: '84-28-055',
    name: '3-р баг, Хаг',
  },
  {
    code: '84-28-053',
    name: '2-р баг, Борт',
  },
  {
    code: '67-55-051',
    name: '1-р баг, Уялган',
  },
  {
    code: '67-55-053',
    name: '2-р баг, Үүр',
  },
  {
    code: '67-55-055',
    name: '3-р баг, Дархинт',
  },
  {
    code: '84-28-057',
    name: '4-р баг, Сэнхэр',
  },
  {
    code: '67-40-061',
    name: '6-р баг',
  },
  {
    code: '22-04-053',
    name: '2-р баг, Дөхөм',
  },
  {
    code: '22-04-051',
    name: '1-р баг, Өлзийт',
  },
  {
    code: '84-28-051',
    name: '1-р баг, Алаг',
  },
  {
    code: '22-04-057',
    name: '4-р баг, Жаргалант',
  },
  {
    code: '41-64-051',
    name: '1-р баг, Сүмбэр',
  },
  {
    code: '22-04-055',
    name: '3-р баг, Их-Уул',
  },
  {
    code: '41-64-053',
    name: '2-р баг, Жавхлант',
  },
  {
    code: '67-40-059',
    name: '5-р баг, Бийж',
  },
  {
    code: '41-79-059',
    name: '5-р баг, Улаанхудаг',
  },
  {
    code: '67-40-057',
    name: '4-р баг, Алтгана',
  },
  {
    code: '84-13-059',
    name: '5-р баг, Булган',
  },
  {
    code: '67-40-055',
    name: '3-р баг, Баян-Эрхт',
  },
  {
    code: '84-13-057',
    name: '4-р баг, Мөнгөн аяга',
  },
  {
    code: '67-40-053',
    name: '2-р баг, Навчилтай',
  },
  {
    code: '41-79-053',
    name: '2-р баг, Баргилт',
  },
  {
    code: '84-13-055',
    name: '3-р баг, Мөрөн',
  },
  {
    code: '67-40-051',
    name: '1-р баг, Зуны гол',
  },
  {
    code: '41-79-051',
    name: '1-р баг, Баян-Уул',
  },
  {
    code: '84-13-053',
    name: '2-р баг, Дэлгэр',
  },
  {
    code: '41-79-057',
    name: '4-р баг, Угалзат',
  },
  {
    code: '84-13-051',
    name: '1-р баг, Булаг',
  },
  {
    code: '41-79-055',
    name: '3-р баг, Буянт',
  },
  {
    code: '44-34-059',
    name: '5-р баг, Аман-Ус',
  },
  {
    code: '44-34-055',
    name: '3-р баг, Агаруут',
  },
  {
    code: '44-34-057',
    name: '4-р баг, Сулинхээр',
  },
  {
    code: '83-07-051',
    name: '1-р баг, Хаш',
  },
  {
    code: '83-07-053',
    name: '2-р баг, Баянбулаг',
  },
  {
    code: '83-07-055',
    name: '3-р баг, Улаанхаргана',
  },
  {
    code: '83-07-057',
    name: '4-р баг, Цагаан түнгэ',
  },
  {
    code: '46-07-053',
    name: '2-р баг, Харзаг',
  },
  {
    code: '46-07-051',
    name: '1-р баг, Могойт',
  },
  {
    code: '46-07-055',
    name: '3-р баг, Налих',
  },
  {
    code: '44-34-051',
    name: '1-р баг, Халив',
  },
  {
    code: '44-34-053',
    name: '2-р баг, Эргэл',
  },
  {
    code: '81-19-057',
    name: '4-р баг, Нуга',
  },
  {
    code: '44-19-051',
    name: '1-р баг, Бүрдэнэ',
  },
  {
    code: '44-19-053',
    name: '2-р баг, Баян',
  },
  {
    code: '44-19-055',
    name: '3-р баг, Зүлэгт',
  },
  {
    code: '46-22-053',
    name: '2-р баг, Ганзагад',
  },
  {
    code: '46-22-051',
    name: '1-р баг, Сайран',
  },
  {
    code: '22-19-053',
    name: '2-р баг, Шарбүрд',
  },
  {
    code: '22-19-051',
    name: '1-р баг, Ихбулаг',
  },
  {
    code: '44-34-061',
    name: '6-р баг, Замын шанд',
  },
  {
    code: '22-19-059',
    name: '5-р баг, Хавирга',
  },
  {
    code: '22-19-057',
    name: '4-р баг, Цөнгөрөг',
  },
  {
    code: '22-19-055',
    name: '3-р баг, Нүдэн',
  },
  {
    code: '44-04-057',
    name: '4-р баг, Цагаан дөрвөлж',
  },
  {
    code: '44-04-055',
    name: '3-р баг, Нүдэн',
  },
  {
    code: '44-04-053',
    name: '2-р баг, Сайн-Ус',
  },
  {
    code: '44-04-051',
    name: '1-р баг, Нард',
  },
  {
    code: '46-37-051',
    name: '1-р баг, Жанжин',
  },
  {
    code: '46-37-053',
    name: '2-р баг, Тулга',
  },
  {
    code: '82-10-053',
    name: '2-р баг, Урт',
  },
  {
    code: '46-37-055',
    name: '3-р баг, Хүрмэн',
  },
  {
    code: '82-10-051',
    name: '1-р баг, Мянгай',
  },
  {
    code: '82-10-057',
    name: '4-р баг, Буудай',
  },
  {
    code: '82-10-055',
    name: '3-р баг, Их булаг',
  },
  {
    code: '82-10-059',
    name: '5-р баг, Хүрэмт',
  },
  {
    code: '65-52-053',
    name: '2-р баг, Зуунмод',
  },
  {
    code: '64-01-057',
    name: '4-р баг, Угалз',
  },
  {
    code: '62-28-059',
    name: '5-р баг, Хад',
  },
  {
    code: '65-52-055',
    name: '3-р баг, Халуун-Ус',
  },
  {
    code: '64-01-059',
    name: '5-р баг, Цагаанчулуут',
  },
  {
    code: '62-28-057',
    name: '4-р баг, Баян-Улаан',
  },
  {
    code: '64-01-053',
    name: '2-р баг, Эрдэнэмандал',
  },
  {
    code: '62-28-055',
    name: '3-р баг, Цохиот',
  },
  {
    code: '65-52-051',
    name: '1-р баг, Өлзийт гол',
  },
  {
    code: '64-01-055',
    name: '3-р баг, Дуурсах',
  },
  {
    code: '62-28-053',
    name: '2-р баг, Цахиурт',
  },
  {
    code: '62-28-051',
    name: '1-р баг, Эмгэд',
  },
  {
    code: '62-13-051',
    name: '1-р баг, Бөмбий',
  },
  {
    code: '62-13-055',
    name: '3-р баг, Өвөр зүлэгт',
  },
  {
    code: '62-13-053',
    name: '2-р баг, Батхаан',
  },
  {
    code: '62-13-059',
    name: '5-р баг, Бумбат',
  },
  {
    code: '64-01-051',
    name: '1-р баг, Номгон',
  },
  {
    code: '62-13-057',
    name: '4-р баг, Хар тойром',
  },
  {
    code: '65-52-057',
    name: '4-р баг, Хайрхан',
  },
  {
    code: '65-52-059',
    name: '5-р баг, Хүрэм',
  },
  {
    code: '82-25-055',
    name: '3-р баг, Далан',
  },
  {
    code: '82-25-051',
    name: '1-р баг, Хуримт',
  },
  {
    code: '82-25-053',
    name: '2-р баг, Галуут',
  },
]

const Countries = [
  {
    num_code: '496',
    alpha_2_code: 'MN',
    alpha_3_code: 'MNG',
    en_short_name: 'Mongolia',
    name: 'Mongolian',
  },
  {
    num_code: '4',
    alpha_2_code: 'AF',
    alpha_3_code: 'AFG',
    en_short_name: 'Afghanistan',
    name: 'Afghan',
  },
  {
    num_code: '248',
    alpha_2_code: 'AX',
    alpha_3_code: 'ALA',
    en_short_name: '\u00c5land Islands',
    name: '\u00c5land Island',
  },
  {
    num_code: '8',
    alpha_2_code: 'AL',
    alpha_3_code: 'ALB',
    en_short_name: 'Albania',
    name: 'Albanian',
  },
  {
    num_code: '12',
    alpha_2_code: 'DZ',
    alpha_3_code: 'DZA',
    en_short_name: 'Algeria',
    name: 'Algerian',
  },
  {
    num_code: '16',
    alpha_2_code: 'AS',
    alpha_3_code: 'ASM',
    en_short_name: 'American Samoa',
    name: 'American Samoan',
  },
  {
    num_code: '20',
    alpha_2_code: 'AD',
    alpha_3_code: 'AND',
    en_short_name: 'Andorra',
    name: 'Andorran',
  },
  {
    num_code: '24',
    alpha_2_code: 'AO',
    alpha_3_code: 'AGO',
    en_short_name: 'Angola',
    name: 'Angolan',
  },
  {
    num_code: '660',
    alpha_2_code: 'AI',
    alpha_3_code: 'AIA',
    en_short_name: 'Anguilla',
    name: 'Anguillan',
  },
  {
    num_code: '10',
    alpha_2_code: 'AQ',
    alpha_3_code: 'ATA',
    en_short_name: 'Antarctica',
    name: 'Antarctic',
  },
  {
    num_code: '28',
    alpha_2_code: 'AG',
    alpha_3_code: 'ATG',
    en_short_name: 'Antigua and Barbuda',
    name: 'Antiguan or Barbudan',
  },
  {
    num_code: '32',
    alpha_2_code: 'AR',
    alpha_3_code: 'ARG',
    en_short_name: 'Argentina',
    name: 'Argentine',
  },
  {
    num_code: '51',
    alpha_2_code: 'AM',
    alpha_3_code: 'ARM',
    en_short_name: 'Armenia',
    name: 'Armenian',
  },
  {
    num_code: '533',
    alpha_2_code: 'AW',
    alpha_3_code: 'ABW',
    en_short_name: 'Aruba',
    name: 'Aruban',
  },
  {
    num_code: '36',
    alpha_2_code: 'AU',
    alpha_3_code: 'AUS',
    en_short_name: 'Australia',
    name: 'Australian',
  },
  {
    num_code: '40',
    alpha_2_code: 'AT',
    alpha_3_code: 'AUT',
    en_short_name: 'Austria',
    name: 'Austrian',
  },
  {
    num_code: '31',
    alpha_2_code: 'AZ',
    alpha_3_code: 'AZE',
    en_short_name: 'Azerbaijan',
    name: 'Azerbaijani, Azeri',
  },
  {
    num_code: '44',
    alpha_2_code: 'BS',
    alpha_3_code: 'BHS',
    en_short_name: 'Bahamas',
    name: 'Bahamian',
  },
  {
    num_code: '48',
    alpha_2_code: 'BH',
    alpha_3_code: 'BHR',
    en_short_name: 'Bahrain',
    name: 'Bahraini',
  },
  {
    num_code: '50',
    alpha_2_code: 'BD',
    alpha_3_code: 'BGD',
    en_short_name: 'Bangladesh',
    name: 'Bangladeshi',
  },
  {
    num_code: '52',
    alpha_2_code: 'BB',
    alpha_3_code: 'BRB',
    en_short_name: 'Barbados',
    name: 'Barbadian',
  },
  {
    num_code: '112',
    alpha_2_code: 'BY',
    alpha_3_code: 'BLR',
    en_short_name: 'Belarus',
    name: 'Belarusian',
  },
  {
    num_code: '56',
    alpha_2_code: 'BE',
    alpha_3_code: 'BEL',
    en_short_name: 'Belgium',
    name: 'Belgian',
  },
  {
    num_code: '84',
    alpha_2_code: 'BZ',
    alpha_3_code: 'BLZ',
    en_short_name: 'Belize',
    name: 'Belizean',
  },
  {
    num_code: '204',
    alpha_2_code: 'BJ',
    alpha_3_code: 'BEN',
    en_short_name: 'Benin',
    name: 'Beninese, Beninois',
  },
  {
    num_code: '60',
    alpha_2_code: 'BM',
    alpha_3_code: 'BMU',
    en_short_name: 'Bermuda',
    name: 'Bermudian, Bermudan',
  },
  {
    num_code: '64',
    alpha_2_code: 'BT',
    alpha_3_code: 'BTN',
    en_short_name: 'Bhutan',
    name: 'Bhutanese',
  },
  {
    num_code: '68',
    alpha_2_code: 'BO',
    alpha_3_code: 'BOL',
    en_short_name: 'Bolivia (Plurinational State of)',
    name: 'Bolivian',
  },
  {
    num_code: '535',
    alpha_2_code: 'BQ',
    alpha_3_code: 'BES',
    en_short_name: 'Bonaire, Sint Eustatius and Saba',
    name: 'Bonaire',
  },
  {
    num_code: '70',
    alpha_2_code: 'BA',
    alpha_3_code: 'BIH',
    en_short_name: 'Bosnia and Herzegovina',
    name: 'Bosnian or Herzegovinian',
  },
  {
    num_code: '72',
    alpha_2_code: 'BW',
    alpha_3_code: 'BWA',
    en_short_name: 'Botswana',
    name: 'Motswana, Botswanan',
  },
  {
    num_code: '74',
    alpha_2_code: 'BV',
    alpha_3_code: 'BVT',
    en_short_name: 'Bouvet Island',
    name: 'Bouvet Island',
  },
  {
    num_code: '76',
    alpha_2_code: 'BR',
    alpha_3_code: 'BRA',
    en_short_name: 'Brazil',
    name: 'Brazilian',
  },
  {
    num_code: '86',
    alpha_2_code: 'IO',
    alpha_3_code: 'IOT',
    en_short_name: 'British Indian Ocean Territory',
    name: 'BIOT',
  },
  {
    num_code: '96',
    alpha_2_code: 'BN',
    alpha_3_code: 'BRN',
    en_short_name: 'Brunei Darussalam',
    name: 'Bruneian',
  },
  {
    num_code: '100',
    alpha_2_code: 'BG',
    alpha_3_code: 'BGR',
    en_short_name: 'Bulgaria',
    name: 'Bulgarian',
  },
  {
    num_code: '854',
    alpha_2_code: 'BF',
    alpha_3_code: 'BFA',
    en_short_name: 'Burkina Faso',
    name: 'Burkinab\u00e9',
  },
  {
    num_code: '108',
    alpha_2_code: 'BI',
    alpha_3_code: 'BDI',
    en_short_name: 'Burundi',
    name: 'Burundian',
  },
  {
    num_code: '132',
    alpha_2_code: 'CV',
    alpha_3_code: 'CPV',
    en_short_name: 'Cabo Verde',
    name: 'Cabo Verdean',
  },
  {
    num_code: '116',
    alpha_2_code: 'KH',
    alpha_3_code: 'KHM',
    en_short_name: 'Cambodia',
    name: 'Cambodian',
  },
  {
    num_code: '120',
    alpha_2_code: 'CM',
    alpha_3_code: 'CMR',
    en_short_name: 'Cameroon',
    name: 'Cameroonian',
  },
  {
    num_code: '124',
    alpha_2_code: 'CA',
    alpha_3_code: 'CAN',
    en_short_name: 'Canada',
    name: 'Canadian',
  },
  {
    num_code: '136',
    alpha_2_code: 'KY',
    alpha_3_code: 'CYM',
    en_short_name: 'Cayman Islands',
    name: 'Caymanian',
  },
  {
    num_code: '140',
    alpha_2_code: 'CF',
    alpha_3_code: 'CAF',
    en_short_name: 'Central African Republic',
    name: 'Central African',
  },
  {
    num_code: '148',
    alpha_2_code: 'TD',
    alpha_3_code: 'TCD',
    en_short_name: 'Chad',
    name: 'Chadian',
  },
  {
    num_code: '152',
    alpha_2_code: 'CL',
    alpha_3_code: 'CHL',
    en_short_name: 'Chile',
    name: 'Chilean',
  },
  {
    num_code: '156',
    alpha_2_code: 'CN',
    alpha_3_code: 'CHN',
    en_short_name: 'China',
    name: 'Chinese',
  },
  {
    num_code: '162',
    alpha_2_code: 'CX',
    alpha_3_code: 'CXR',
    en_short_name: 'Christmas Island',
    name: 'Christmas Island',
  },
  {
    num_code: '166',
    alpha_2_code: 'CC',
    alpha_3_code: 'CCK',
    en_short_name: 'Cocos (Keeling) Islands',
    name: 'Cocos Island',
  },
  {
    num_code: '170',
    alpha_2_code: 'CO',
    alpha_3_code: 'COL',
    en_short_name: 'Colombia',
    name: 'Colombian',
  },
  {
    num_code: '174',
    alpha_2_code: 'KM',
    alpha_3_code: 'COM',
    en_short_name: 'Comoros',
    name: 'Comoran, Comorian',
  },
  {
    num_code: '178',
    alpha_2_code: 'CG',
    alpha_3_code: 'COG',
    en_short_name: 'Congo (Republic of the)',
    name: 'Congolese',
  },
  {
    num_code: '180',
    alpha_2_code: 'CD',
    alpha_3_code: 'COD',
    en_short_name: 'Congo (Democratic Republic of the)',
    name: 'Congolese',
  },
  {
    num_code: '184',
    alpha_2_code: 'CK',
    alpha_3_code: 'COK',
    en_short_name: 'Cook Islands',
    name: 'Cook Island',
  },
  {
    num_code: '188',
    alpha_2_code: 'CR',
    alpha_3_code: 'CRI',
    en_short_name: 'Costa Rica',
    name: 'Costa Rican',
  },
  {
    num_code: '384',
    alpha_2_code: 'CI',
    alpha_3_code: 'CIV',
    en_short_name: "C\u00f4te d'Ivoire",
    name: 'Ivorian',
  },
  {
    num_code: '191',
    alpha_2_code: 'HR',
    alpha_3_code: 'HRV',
    en_short_name: 'Croatia',
    name: 'Croatian',
  },
  {
    num_code: '192',
    alpha_2_code: 'CU',
    alpha_3_code: 'CUB',
    en_short_name: 'Cuba',
    name: 'Cuban',
  },
  {
    num_code: '531',
    alpha_2_code: 'CW',
    alpha_3_code: 'CUW',
    en_short_name: 'Cura\u00e7ao',
    name: 'Cura\u00e7aoan',
  },
  {
    num_code: '196',
    alpha_2_code: 'CY',
    alpha_3_code: 'CYP',
    en_short_name: 'Cyprus',
    name: 'Cypriot',
  },
  {
    num_code: '203',
    alpha_2_code: 'CZ',
    alpha_3_code: 'CZE',
    en_short_name: 'Czech Republic',
    name: 'Czech',
  },
  {
    num_code: '208',
    alpha_2_code: 'DK',
    alpha_3_code: 'DNK',
    en_short_name: 'Denmark',
    name: 'Danish',
  },
  {
    num_code: '262',
    alpha_2_code: 'DJ',
    alpha_3_code: 'DJI',
    en_short_name: 'Djibouti',
    name: 'Djiboutian',
  },
  {
    num_code: '212',
    alpha_2_code: 'DM',
    alpha_3_code: 'DMA',
    en_short_name: 'Dominica',
    name: 'Dominican',
  },
  {
    num_code: '214',
    alpha_2_code: 'DO',
    alpha_3_code: 'DOM',
    en_short_name: 'Dominican Republic',
    name: 'Dominican',
  },
  {
    num_code: '218',
    alpha_2_code: 'EC',
    alpha_3_code: 'ECU',
    en_short_name: 'Ecuador',
    name: 'Ecuadorian',
  },
  {
    num_code: '818',
    alpha_2_code: 'EG',
    alpha_3_code: 'EGY',
    en_short_name: 'Egypt',
    name: 'Egyptian',
  },
  {
    num_code: '222',
    alpha_2_code: 'SV',
    alpha_3_code: 'SLV',
    en_short_name: 'El Salvador',
    name: 'Salvadoran',
  },
  {
    num_code: '226',
    alpha_2_code: 'GQ',
    alpha_3_code: 'GNQ',
    en_short_name: 'Equatorial Guinea',
    name: 'Equatorial Guinean, Equatoguinean',
  },
  {
    num_code: '232',
    alpha_2_code: 'ER',
    alpha_3_code: 'ERI',
    en_short_name: 'Eritrea',
    name: 'Eritrean',
  },
  {
    num_code: '233',
    alpha_2_code: 'EE',
    alpha_3_code: 'EST',
    en_short_name: 'Estonia',
    name: 'Estonian',
  },
  {
    num_code: '231',
    alpha_2_code: 'ET',
    alpha_3_code: 'ETH',
    en_short_name: 'Ethiopia',
    name: 'Ethiopian',
  },
  {
    num_code: '238',
    alpha_2_code: 'FK',
    alpha_3_code: 'FLK',
    en_short_name: 'Falkland Islands (Malvinas)',
    name: 'Falkland Island',
  },
  {
    num_code: '234',
    alpha_2_code: 'FO',
    alpha_3_code: 'FRO',
    en_short_name: 'Faroe Islands',
    name: 'Faroese',
  },
  {
    num_code: '242',
    alpha_2_code: 'FJ',
    alpha_3_code: 'FJI',
    en_short_name: 'Fiji',
    name: 'Fijian',
  },
  {
    num_code: '246',
    alpha_2_code: 'FI',
    alpha_3_code: 'FIN',
    en_short_name: 'Finland',
    name: 'Finnish',
  },
  {
    num_code: '250',
    alpha_2_code: 'FR',
    alpha_3_code: 'FRA',
    en_short_name: 'France',
    name: 'French',
  },
  {
    num_code: '254',
    alpha_2_code: 'GF',
    alpha_3_code: 'GUF',
    en_short_name: 'French Guiana',
    name: 'French Guianese',
  },
  {
    num_code: '258',
    alpha_2_code: 'PF',
    alpha_3_code: 'PYF',
    en_short_name: 'French Polynesia',
    name: 'French Polynesian',
  },
  {
    num_code: '260',
    alpha_2_code: 'TF',
    alpha_3_code: 'ATF',
    en_short_name: 'French Southern Territories',
    name: 'French Southern Territories',
  },
  {
    num_code: '266',
    alpha_2_code: 'GA',
    alpha_3_code: 'GAB',
    en_short_name: 'Gabon',
    name: 'Gabonese',
  },
  {
    num_code: '270',
    alpha_2_code: 'GM',
    alpha_3_code: 'GMB',
    en_short_name: 'Gambia',
    name: 'Gambian',
  },
  {
    num_code: '268',
    alpha_2_code: 'GE',
    alpha_3_code: 'GEO',
    en_short_name: 'Georgia',
    name: 'Georgian',
  },
  {
    num_code: '276',
    alpha_2_code: 'DE',
    alpha_3_code: 'DEU',
    en_short_name: 'Germany',
    name: 'German',
  },
  {
    num_code: '288',
    alpha_2_code: 'GH',
    alpha_3_code: 'GHA',
    en_short_name: 'Ghana',
    name: 'Ghanaian',
  },
  {
    num_code: '292',
    alpha_2_code: 'GI',
    alpha_3_code: 'GIB',
    en_short_name: 'Gibraltar',
    name: 'Gibraltar',
  },
  {
    num_code: '300',
    alpha_2_code: 'GR',
    alpha_3_code: 'GRC',
    en_short_name: 'Greece',
    name: 'Greek, Hellenic',
  },
  {
    num_code: '304',
    alpha_2_code: 'GL',
    alpha_3_code: 'GRL',
    en_short_name: 'Greenland',
    name: 'Greenlandic',
  },
  {
    num_code: '308',
    alpha_2_code: 'GD',
    alpha_3_code: 'GRD',
    en_short_name: 'Grenada',
    name: 'Grenadian',
  },
  {
    num_code: '312',
    alpha_2_code: 'GP',
    alpha_3_code: 'GLP',
    en_short_name: 'Guadeloupe',
    name: 'Guadeloupe',
  },
  {
    num_code: '316',
    alpha_2_code: 'GU',
    alpha_3_code: 'GUM',
    en_short_name: 'Guam',
    name: 'Guamanian, Guambat',
  },
  {
    num_code: '320',
    alpha_2_code: 'GT',
    alpha_3_code: 'GTM',
    en_short_name: 'Guatemala',
    name: 'Guatemalan',
  },
  {
    num_code: '831',
    alpha_2_code: 'GG',
    alpha_3_code: 'GGY',
    en_short_name: 'Guernsey',
    name: 'Channel Island',
  },
  {
    num_code: '324',
    alpha_2_code: 'GN',
    alpha_3_code: 'GIN',
    en_short_name: 'Guinea',
    name: 'Guinean',
  },
  {
    num_code: '624',
    alpha_2_code: 'GW',
    alpha_3_code: 'GNB',
    en_short_name: 'Guinea-Bissau',
    name: 'Bissau-Guinean',
  },
  {
    num_code: '328',
    alpha_2_code: 'GY',
    alpha_3_code: 'GUY',
    en_short_name: 'Guyana',
    name: 'Guyanese',
  },
  {
    num_code: '332',
    alpha_2_code: 'HT',
    alpha_3_code: 'HTI',
    en_short_name: 'Haiti',
    name: 'Haitian',
  },
  {
    num_code: '334',
    alpha_2_code: 'HM',
    alpha_3_code: 'HMD',
    en_short_name: 'Heard Island and McDonald Islands',
    name: 'Heard Island or McDonald Islands',
  },
  {
    num_code: '336',
    alpha_2_code: 'VA',
    alpha_3_code: 'VAT',
    en_short_name: 'Vatican City State',
    name: 'Vatican',
  },
  {
    num_code: '340',
    alpha_2_code: 'HN',
    alpha_3_code: 'HND',
    en_short_name: 'Honduras',
    name: 'Honduran',
  },
  {
    num_code: '344',
    alpha_2_code: 'HK',
    alpha_3_code: 'HKG',
    en_short_name: 'Hong Kong',
    name: 'Hong Kong, Hong Kongese',
  },
  {
    num_code: '348',
    alpha_2_code: 'HU',
    alpha_3_code: 'HUN',
    en_short_name: 'Hungary',
    name: 'Hungarian, Magyar',
  },
  {
    num_code: '352',
    alpha_2_code: 'IS',
    alpha_3_code: 'ISL',
    en_short_name: 'Iceland',
    name: 'Icelandic',
  },
  {
    num_code: '356',
    alpha_2_code: 'IN',
    alpha_3_code: 'IND',
    en_short_name: 'India',
    name: 'Indian',
  },
  {
    num_code: '360',
    alpha_2_code: 'ID',
    alpha_3_code: 'IDN',
    en_short_name: 'Indonesia',
    name: 'Indonesian',
  },
  {
    num_code: '364',
    alpha_2_code: 'IR',
    alpha_3_code: 'IRN',
    en_short_name: 'Iran',
    name: 'Iranian, Persian',
  },
  {
    num_code: '368',
    alpha_2_code: 'IQ',
    alpha_3_code: 'IRQ',
    en_short_name: 'Iraq',
    name: 'Iraqi',
  },
  {
    num_code: '372',
    alpha_2_code: 'IE',
    alpha_3_code: 'IRL',
    en_short_name: 'Ireland',
    name: 'Irish',
  },
  {
    num_code: '833',
    alpha_2_code: 'IM',
    alpha_3_code: 'IMN',
    en_short_name: 'Isle of Man',
    name: 'Manx',
  },
  {
    num_code: '376',
    alpha_2_code: 'IL',
    alpha_3_code: 'ISR',
    en_short_name: 'Israel',
    name: 'Israeli',
  },
  {
    num_code: '380',
    alpha_2_code: 'IT',
    alpha_3_code: 'ITA',
    en_short_name: 'Italy',
    name: 'Italian',
  },
  {
    num_code: '388',
    alpha_2_code: 'JM',
    alpha_3_code: 'JAM',
    en_short_name: 'Jamaica',
    name: 'Jamaican',
  },
  {
    num_code: '392',
    alpha_2_code: 'JP',
    alpha_3_code: 'JPN',
    en_short_name: 'Japan',
    name: 'Japanese',
  },
  {
    num_code: '832',
    alpha_2_code: 'JE',
    alpha_3_code: 'JEY',
    en_short_name: 'Jersey',
    name: 'Channel Island',
  },
  {
    num_code: '400',
    alpha_2_code: 'JO',
    alpha_3_code: 'JOR',
    en_short_name: 'Jordan',
    name: 'Jordanian',
  },
  {
    num_code: '398',
    alpha_2_code: 'KZ',
    alpha_3_code: 'KAZ',
    en_short_name: 'Kazakhstan',
    name: 'Kazakhstani, Kazakh',
  },
  {
    num_code: '404',
    alpha_2_code: 'KE',
    alpha_3_code: 'KEN',
    en_short_name: 'Kenya',
    name: 'Kenyan',
  },
  {
    num_code: '296',
    alpha_2_code: 'KI',
    alpha_3_code: 'KIR',
    en_short_name: 'Kiribati',
    name: 'I-Kiribati',
  },
  {
    num_code: '408',
    alpha_2_code: 'KP',
    alpha_3_code: 'PRK',
    en_short_name: "Korea (Democratic People's Republic of)",
    name: 'North Korean',
  },
  {
    num_code: '410',
    alpha_2_code: 'KR',
    alpha_3_code: 'KOR',
    en_short_name: 'Korea (Republic of)',
    name: 'South Korean',
  },
  {
    num_code: '414',
    alpha_2_code: 'KW',
    alpha_3_code: 'KWT',
    en_short_name: 'Kuwait',
    name: 'Kuwaiti',
  },
  {
    num_code: '417',
    alpha_2_code: 'KG',
    alpha_3_code: 'KGZ',
    en_short_name: 'Kyrgyzstan',
    name: 'Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz',
  },
  {
    num_code: '418',
    alpha_2_code: 'LA',
    alpha_3_code: 'LAO',
    en_short_name: "Lao People's Democratic Republic",
    name: 'Lao, Laotian',
  },
  {
    num_code: '428',
    alpha_2_code: 'LV',
    alpha_3_code: 'LVA',
    en_short_name: 'Latvia',
    name: 'Latvian',
  },
  {
    num_code: '422',
    alpha_2_code: 'LB',
    alpha_3_code: 'LBN',
    en_short_name: 'Lebanon',
    name: 'Lebanese',
  },
  {
    num_code: '426',
    alpha_2_code: 'LS',
    alpha_3_code: 'LSO',
    en_short_name: 'Lesotho',
    name: 'Basotho',
  },
  {
    num_code: '430',
    alpha_2_code: 'LR',
    alpha_3_code: 'LBR',
    en_short_name: 'Liberia',
    name: 'Liberian',
  },
  {
    num_code: '434',
    alpha_2_code: 'LY',
    alpha_3_code: 'LBY',
    en_short_name: 'Libya',
    name: 'Libyan',
  },
  {
    num_code: '438',
    alpha_2_code: 'LI',
    alpha_3_code: 'LIE',
    en_short_name: 'Liechtenstein',
    name: 'Liechtenstein',
  },
  {
    num_code: '440',
    alpha_2_code: 'LT',
    alpha_3_code: 'LTU',
    en_short_name: 'Lithuania',
    name: 'Lithuanian',
  },
  {
    num_code: '442',
    alpha_2_code: 'LU',
    alpha_3_code: 'LUX',
    en_short_name: 'Luxembourg',
    name: 'Luxembourg, Luxembourgish',
  },
  {
    num_code: '446',
    alpha_2_code: 'MO',
    alpha_3_code: 'MAC',
    en_short_name: 'Macao',
    name: 'Macanese, Chinese',
  },
  {
    num_code: '807',
    alpha_2_code: 'MK',
    alpha_3_code: 'MKD',
    en_short_name: 'Macedonia (the former Yugoslav Republic of)',
    name: 'Macedonian',
  },
  {
    num_code: '450',
    alpha_2_code: 'MG',
    alpha_3_code: 'MDG',
    en_short_name: 'Madagascar',
    name: 'Malagasy',
  },
  {
    num_code: '454',
    alpha_2_code: 'MW',
    alpha_3_code: 'MWI',
    en_short_name: 'Malawi',
    name: 'Malawian',
  },
  {
    num_code: '458',
    alpha_2_code: 'MY',
    alpha_3_code: 'MYS',
    en_short_name: 'Malaysia',
    name: 'Malaysian',
  },
  {
    num_code: '462',
    alpha_2_code: 'MV',
    alpha_3_code: 'MDV',
    en_short_name: 'Maldives',
    name: 'Maldivian',
  },
  {
    num_code: '466',
    alpha_2_code: 'ML',
    alpha_3_code: 'MLI',
    en_short_name: 'Mali',
    name: 'Malian, Malinese',
  },
  {
    num_code: '470',
    alpha_2_code: 'MT',
    alpha_3_code: 'MLT',
    en_short_name: 'Malta',
    name: 'Maltese',
  },
  {
    num_code: '584',
    alpha_2_code: 'MH',
    alpha_3_code: 'MHL',
    en_short_name: 'Marshall Islands',
    name: 'Marshallese',
  },
  {
    num_code: '474',
    alpha_2_code: 'MQ',
    alpha_3_code: 'MTQ',
    en_short_name: 'Martinique',
    name: 'Martiniquais, Martinican',
  },
  {
    num_code: '478',
    alpha_2_code: 'MR',
    alpha_3_code: 'MRT',
    en_short_name: 'Mauritania',
    name: 'Mauritanian',
  },
  {
    num_code: '480',
    alpha_2_code: 'MU',
    alpha_3_code: 'MUS',
    en_short_name: 'Mauritius',
    name: 'Mauritian',
  },
  {
    num_code: '175',
    alpha_2_code: 'YT',
    alpha_3_code: 'MYT',
    en_short_name: 'Mayotte',
    name: 'Mahoran',
  },
  {
    num_code: '484',
    alpha_2_code: 'MX',
    alpha_3_code: 'MEX',
    en_short_name: 'Mexico',
    name: 'Mexican',
  },
  {
    num_code: '583',
    alpha_2_code: 'FM',
    alpha_3_code: 'FSM',
    en_short_name: 'Micronesia (Federated States of)',
    name: 'Micronesian',
  },
  {
    num_code: '498',
    alpha_2_code: 'MD',
    alpha_3_code: 'MDA',
    en_short_name: 'Moldova (Republic of)',
    name: 'Moldovan',
  },
  {
    num_code: '492',
    alpha_2_code: 'MC',
    alpha_3_code: 'MCO',
    en_short_name: 'Monaco',
    name: 'Mon\u00e9gasque, Monacan',
  },
  {
    num_code: '499',
    alpha_2_code: 'ME',
    alpha_3_code: 'MNE',
    en_short_name: 'Montenegro',
    name: 'Montenegrin',
  },
  {
    num_code: '500',
    alpha_2_code: 'MS',
    alpha_3_code: 'MSR',
    en_short_name: 'Montserrat',
    name: 'Montserratian',
  },
  {
    num_code: '504',
    alpha_2_code: 'MA',
    alpha_3_code: 'MAR',
    en_short_name: 'Morocco',
    name: 'Moroccan',
  },
  {
    num_code: '508',
    alpha_2_code: 'MZ',
    alpha_3_code: 'MOZ',
    en_short_name: 'Mozambique',
    name: 'Mozambican',
  },
  {
    num_code: '104',
    alpha_2_code: 'MM',
    alpha_3_code: 'MMR',
    en_short_name: 'Myanmar',
    name: 'Burmese',
  },
  {
    num_code: '516',
    alpha_2_code: 'NA',
    alpha_3_code: 'NAM',
    en_short_name: 'Namibia',
    name: 'Namibian',
  },
  {
    num_code: '520',
    alpha_2_code: 'NR',
    alpha_3_code: 'NRU',
    en_short_name: 'Nauru',
    name: 'Nauruan',
  },
  {
    num_code: '524',
    alpha_2_code: 'NP',
    alpha_3_code: 'NPL',
    en_short_name: 'Nepal',
    name: 'Nepali, Nepalese',
  },
  {
    num_code: '528',
    alpha_2_code: 'NL',
    alpha_3_code: 'NLD',
    en_short_name: 'Netherlands',
    name: 'Dutch, Netherlandic',
  },
  {
    num_code: '540',
    alpha_2_code: 'NC',
    alpha_3_code: 'NCL',
    en_short_name: 'New Caledonia',
    name: 'New Caledonian',
  },
  {
    num_code: '554',
    alpha_2_code: 'NZ',
    alpha_3_code: 'NZL',
    en_short_name: 'New Zealand',
    name: 'New Zealand, NZ',
  },
  {
    num_code: '558',
    alpha_2_code: 'NI',
    alpha_3_code: 'NIC',
    en_short_name: 'Nicaragua',
    name: 'Nicaraguan',
  },
  {
    num_code: '562',
    alpha_2_code: 'NE',
    alpha_3_code: 'NER',
    en_short_name: 'Niger',
    name: 'Nigerien',
  },
  {
    num_code: '566',
    alpha_2_code: 'NG',
    alpha_3_code: 'NGA',
    en_short_name: 'Nigeria',
    name: 'Nigerian',
  },
  {
    num_code: '570',
    alpha_2_code: 'NU',
    alpha_3_code: 'NIU',
    en_short_name: 'Niue',
    name: 'Niuean',
  },
  {
    num_code: '574',
    alpha_2_code: 'NF',
    alpha_3_code: 'NFK',
    en_short_name: 'Norfolk Island',
    name: 'Norfolk Island',
  },
  {
    num_code: '580',
    alpha_2_code: 'MP',
    alpha_3_code: 'MNP',
    en_short_name: 'Northern Mariana Islands',
    name: 'Northern Marianan',
  },
  {
    num_code: '578',
    alpha_2_code: 'NO',
    alpha_3_code: 'NOR',
    en_short_name: 'Norway',
    name: 'Norwegian',
  },
  {
    num_code: '512',
    alpha_2_code: 'OM',
    alpha_3_code: 'OMN',
    en_short_name: 'Oman',
    name: 'Omani',
  },
  {
    num_code: '586',
    alpha_2_code: 'PK',
    alpha_3_code: 'PAK',
    en_short_name: 'Pakistan',
    name: 'Pakistani',
  },
  {
    num_code: '585',
    alpha_2_code: 'PW',
    alpha_3_code: 'PLW',
    en_short_name: 'Palau',
    name: 'Palauan',
  },
  {
    num_code: '275',
    alpha_2_code: 'PS',
    alpha_3_code: 'PSE',
    en_short_name: 'Palestine, State of',
    name: 'Palestinian',
  },
  {
    num_code: '591',
    alpha_2_code: 'PA',
    alpha_3_code: 'PAN',
    en_short_name: 'Panama',
    name: 'Panamanian',
  },
  {
    num_code: '598',
    alpha_2_code: 'PG',
    alpha_3_code: 'PNG',
    en_short_name: 'Papua New Guinea',
    name: 'Papua New Guinean, Papuan',
  },
  {
    num_code: '600',
    alpha_2_code: 'PY',
    alpha_3_code: 'PRY',
    en_short_name: 'Paraguay',
    name: 'Paraguayan',
  },
  {
    num_code: '604',
    alpha_2_code: 'PE',
    alpha_3_code: 'PER',
    en_short_name: 'Peru',
    name: 'Peruvian',
  },
  {
    num_code: '608',
    alpha_2_code: 'PH',
    alpha_3_code: 'PHL',
    en_short_name: 'Philippines',
    name: 'Philippine, Filipino',
  },
  {
    num_code: '612',
    alpha_2_code: 'PN',
    alpha_3_code: 'PCN',
    en_short_name: 'Pitcairn',
    name: 'Pitcairn Island',
  },
  {
    num_code: '616',
    alpha_2_code: 'PL',
    alpha_3_code: 'POL',
    en_short_name: 'Poland',
    name: 'Polish',
  },
  {
    num_code: '620',
    alpha_2_code: 'PT',
    alpha_3_code: 'PRT',
    en_short_name: 'Portugal',
    name: 'Portuguese',
  },
  {
    num_code: '630',
    alpha_2_code: 'PR',
    alpha_3_code: 'PRI',
    en_short_name: 'Puerto Rico',
    name: 'Puerto Rican',
  },
  {
    num_code: '634',
    alpha_2_code: 'QA',
    alpha_3_code: 'QAT',
    en_short_name: 'Qatar',
    name: 'Qatari',
  },
  {
    num_code: '638',
    alpha_2_code: 'RE',
    alpha_3_code: 'REU',
    en_short_name: 'R\u00e9union',
    name: 'R\u00e9unionese, R\u00e9unionnais',
  },
  {
    num_code: '642',
    alpha_2_code: 'RO',
    alpha_3_code: 'ROU',
    en_short_name: 'Romania',
    name: 'Romanian',
  },
  {
    num_code: '643',
    alpha_2_code: 'RU',
    alpha_3_code: 'RUS',
    en_short_name: 'Russian Federation',
    name: 'Russian',
  },
  {
    num_code: '646',
    alpha_2_code: 'RW',
    alpha_3_code: 'RWA',
    en_short_name: 'Rwanda',
    name: 'Rwandan',
  },
  {
    num_code: '652',
    alpha_2_code: 'BL',
    alpha_3_code: 'BLM',
    en_short_name: 'Saint Barth\u00e9lemy',
    name: 'Barth\u00e9lemois',
  },
  {
    num_code: '654',
    alpha_2_code: 'SH',
    alpha_3_code: 'SHN',
    en_short_name: 'Saint Helena, Ascension and Tristan da Cunha',
    name: 'Saint Helenian',
  },
  {
    num_code: '659',
    alpha_2_code: 'KN',
    alpha_3_code: 'KNA',
    en_short_name: 'Saint Kitts and Nevis',
    name: 'Kittitian or Nevisian',
  },
  {
    num_code: '662',
    alpha_2_code: 'LC',
    alpha_3_code: 'LCA',
    en_short_name: 'Saint Lucia',
    name: 'Saint Lucian',
  },
  {
    num_code: '663',
    alpha_2_code: 'MF',
    alpha_3_code: 'MAF',
    en_short_name: 'Saint Martin (French part)',
    name: 'Saint-Martinoise',
  },
  {
    num_code: '666',
    alpha_2_code: 'PM',
    alpha_3_code: 'SPM',
    en_short_name: 'Saint Pierre and Miquelon',
    name: 'Saint-Pierrais or Miquelonnais',
  },
  {
    num_code: '670',
    alpha_2_code: 'VC',
    alpha_3_code: 'VCT',
    en_short_name: 'Saint Vincent and the Grenadines',
    name: 'Saint Vincentian, Vincentian',
  },
  {
    num_code: '882',
    alpha_2_code: 'WS',
    alpha_3_code: 'WSM',
    en_short_name: 'Samoa',
    name: 'Samoan',
  },
  {
    num_code: '674',
    alpha_2_code: 'SM',
    alpha_3_code: 'SMR',
    en_short_name: 'San Marino',
    name: 'Sammarinese',
  },
  {
    num_code: '678',
    alpha_2_code: 'ST',
    alpha_3_code: 'STP',
    en_short_name: 'Sao Tome and Principe',
    name: 'S\u00e3o Tom\u00e9an',
  },
  {
    num_code: '682',
    alpha_2_code: 'SA',
    alpha_3_code: 'SAU',
    en_short_name: 'Saudi Arabia',
    name: 'Saudi, Saudi Arabian',
  },
  {
    num_code: '686',
    alpha_2_code: 'SN',
    alpha_3_code: 'SEN',
    en_short_name: 'Senegal',
    name: 'Senegalese',
  },
  {
    num_code: '688',
    alpha_2_code: 'RS',
    alpha_3_code: 'SRB',
    en_short_name: 'Serbia',
    name: 'Serbian',
  },
  {
    num_code: '690',
    alpha_2_code: 'SC',
    alpha_3_code: 'SYC',
    en_short_name: 'Seychelles',
    name: 'Seychellois',
  },
  {
    num_code: '694',
    alpha_2_code: 'SL',
    alpha_3_code: 'SLE',
    en_short_name: 'Sierra Leone',
    name: 'Sierra Leonean',
  },
  {
    num_code: '702',
    alpha_2_code: 'SG',
    alpha_3_code: 'SGP',
    en_short_name: 'Singapore',
    name: 'Singaporean',
  },
  {
    num_code: '534',
    alpha_2_code: 'SX',
    alpha_3_code: 'SXM',
    en_short_name: 'Sint Maarten (Dutch part)',
    name: 'Sint Maarten',
  },
  {
    num_code: '703',
    alpha_2_code: 'SK',
    alpha_3_code: 'SVK',
    en_short_name: 'Slovakia',
    name: 'Slovak',
  },
  {
    num_code: '705',
    alpha_2_code: 'SI',
    alpha_3_code: 'SVN',
    en_short_name: 'Slovenia',
    name: 'Slovenian, Slovene',
  },
  {
    num_code: '90',
    alpha_2_code: 'SB',
    alpha_3_code: 'SLB',
    en_short_name: 'Solomon Islands',
    name: 'Solomon Island',
  },
  {
    num_code: '706',
    alpha_2_code: 'SO',
    alpha_3_code: 'SOM',
    en_short_name: 'Somalia',
    name: 'Somali, Somalian',
  },
  {
    num_code: '710',
    alpha_2_code: 'ZA',
    alpha_3_code: 'ZAF',
    en_short_name: 'South Africa',
    name: 'South African',
  },
  {
    num_code: '239',
    alpha_2_code: 'GS',
    alpha_3_code: 'SGS',
    en_short_name: 'South Georgia and the South Sandwich Islands',
    name: 'South Georgia or South Sandwich Islands',
  },
  {
    num_code: '728',
    alpha_2_code: 'SS',
    alpha_3_code: 'SSD',
    en_short_name: 'South Sudan',
    name: 'South Sudanese',
  },
  {
    num_code: '724',
    alpha_2_code: 'ES',
    alpha_3_code: 'ESP',
    en_short_name: 'Spain',
    name: 'Spanish',
  },
  {
    num_code: '144',
    alpha_2_code: 'LK',
    alpha_3_code: 'LKA',
    en_short_name: 'Sri Lanka',
    name: 'Sri Lankan',
  },
  {
    num_code: '729',
    alpha_2_code: 'SD',
    alpha_3_code: 'SDN',
    en_short_name: 'Sudan',
    name: 'Sudanese',
  },
  {
    num_code: '740',
    alpha_2_code: 'SR',
    alpha_3_code: 'SUR',
    en_short_name: 'Suriname',
    name: 'Surinamese',
  },
  {
    num_code: '744',
    alpha_2_code: 'SJ',
    alpha_3_code: 'SJM',
    en_short_name: 'Svalbard and Jan Mayen',
    name: 'Svalbard',
  },
  {
    num_code: '748',
    alpha_2_code: 'SZ',
    alpha_3_code: 'SWZ',
    en_short_name: 'Swaziland',
    name: 'Swazi',
  },
  {
    num_code: '752',
    alpha_2_code: 'SE',
    alpha_3_code: 'SWE',
    en_short_name: 'Sweden',
    name: 'Swedish',
  },
  {
    num_code: '756',
    alpha_2_code: 'CH',
    alpha_3_code: 'CHE',
    en_short_name: 'Switzerland',
    name: 'Swiss',
  },
  {
    num_code: '760',
    alpha_2_code: 'SY',
    alpha_3_code: 'SYR',
    en_short_name: 'Syrian Arab Republic',
    name: 'Syrian',
  },
  {
    num_code: '158',
    alpha_2_code: 'TW',
    alpha_3_code: 'TWN',
    en_short_name: 'Taiwan, Province of China',
    name: 'Chinese, Taiwanese',
  },
  {
    num_code: '762',
    alpha_2_code: 'TJ',
    alpha_3_code: 'TJK',
    en_short_name: 'Tajikistan',
    name: 'Tajikistani',
  },
  {
    num_code: '834',
    alpha_2_code: 'TZ',
    alpha_3_code: 'TZA',
    en_short_name: 'Tanzania, United Republic of',
    name: 'Tanzanian',
  },
  {
    num_code: '764',
    alpha_2_code: 'TH',
    alpha_3_code: 'THA',
    en_short_name: 'Thailand',
    name: 'Thai',
  },
  {
    num_code: '626',
    alpha_2_code: 'TL',
    alpha_3_code: 'TLS',
    en_short_name: 'Timor-Leste',
    name: 'Timorese',
  },
  {
    num_code: '768',
    alpha_2_code: 'TG',
    alpha_3_code: 'TGO',
    en_short_name: 'Togo',
    name: 'Togolese',
  },
  {
    num_code: '772',
    alpha_2_code: 'TK',
    alpha_3_code: 'TKL',
    en_short_name: 'Tokelau',
    name: 'Tokelauan',
  },
  {
    num_code: '776',
    alpha_2_code: 'TO',
    alpha_3_code: 'TON',
    en_short_name: 'Tonga',
    name: 'Tongan',
  },
  {
    num_code: '780',
    alpha_2_code: 'TT',
    alpha_3_code: 'TTO',
    en_short_name: 'Trinidad and Tobago',
    name: 'Trinidadian or Tobagonian',
  },
  {
    num_code: '788',
    alpha_2_code: 'TN',
    alpha_3_code: 'TUN',
    en_short_name: 'Tunisia',
    name: 'Tunisian',
  },
  {
    num_code: '792',
    alpha_2_code: 'TR',
    alpha_3_code: 'TUR',
    en_short_name: 'Turkey',
    name: 'Turkish',
  },
  {
    num_code: '795',
    alpha_2_code: 'TM',
    alpha_3_code: 'TKM',
    en_short_name: 'Turkmenistan',
    name: 'Turkmen',
  },
  {
    num_code: '796',
    alpha_2_code: 'TC',
    alpha_3_code: 'TCA',
    en_short_name: 'Turks and Caicos Islands',
    name: 'Turks and Caicos Island',
  },
  {
    num_code: '798',
    alpha_2_code: 'TV',
    alpha_3_code: 'TUV',
    en_short_name: 'Tuvalu',
    name: 'Tuvaluan',
  },
  {
    num_code: '800',
    alpha_2_code: 'UG',
    alpha_3_code: 'UGA',
    en_short_name: 'Uganda',
    name: 'Ugandan',
  },
  {
    num_code: '804',
    alpha_2_code: 'UA',
    alpha_3_code: 'UKR',
    en_short_name: 'Ukraine',
    name: 'Ukrainian',
  },
  {
    num_code: '784',
    alpha_2_code: 'AE',
    alpha_3_code: 'ARE',
    en_short_name: 'United Arab Emirates',
    name: 'Emirati, Emirian, Emiri',
  },
  {
    num_code: '826',
    alpha_2_code: 'GB',
    alpha_3_code: 'GBR',
    en_short_name: 'United Kingdom of Great Britain and Northern Ireland',
    name: 'British, UK',
  },
  {
    num_code: '581',
    alpha_2_code: 'UM',
    alpha_3_code: 'UMI',
    en_short_name: 'United States Minor Outlying Islands',
    name: 'American',
  },
  {
    num_code: '840',
    alpha_2_code: 'US',
    alpha_3_code: 'USA',
    en_short_name: 'United States of America',
    name: 'American',
  },
  {
    num_code: '858',
    alpha_2_code: 'UY',
    alpha_3_code: 'URY',
    en_short_name: 'Uruguay',
    name: 'Uruguayan',
  },
  {
    num_code: '860',
    alpha_2_code: 'UZ',
    alpha_3_code: 'UZB',
    en_short_name: 'Uzbekistan',
    name: 'Uzbekistani, Uzbek',
  },
  {
    num_code: '548',
    alpha_2_code: 'VU',
    alpha_3_code: 'VUT',
    en_short_name: 'Vanuatu',
    name: 'Ni-Vanuatu, Vanuatuan',
  },
  {
    num_code: '862',
    alpha_2_code: 'VE',
    alpha_3_code: 'VEN',
    en_short_name: 'Venezuela (Bolivarian Republic of)',
    name: 'Venezuelan',
  },
  {
    num_code: '704',
    alpha_2_code: 'VN',
    alpha_3_code: 'VNM',
    en_short_name: 'Vietnam',
    name: 'Vietnamese',
  },
  {
    num_code: '92',
    alpha_2_code: 'VG',
    alpha_3_code: 'VGB',
    en_short_name: 'Virgin Islands (British)',
    name: 'British Virgin Island',
  },
  {
    num_code: '850',
    alpha_2_code: 'VI',
    alpha_3_code: 'VIR',
    en_short_name: 'Virgin Islands (U.S.)',
    name: 'U.S. Virgin Island',
  },
  {
    num_code: '876',
    alpha_2_code: 'WF',
    alpha_3_code: 'WLF',
    en_short_name: 'Wallis and Futuna',
    name: 'Wallis and Futuna, Wallisian or Futunan',
  },
  {
    num_code: '732',
    alpha_2_code: 'EH',
    alpha_3_code: 'ESH',
    en_short_name: 'Western Sahara',
    name: 'Sahrawi, Sahrawian, Sahraouian',
  },
  {
    num_code: '887',
    alpha_2_code: 'YE',
    alpha_3_code: 'YEM',
    en_short_name: 'Yemen',
    name: 'Yemeni',
  },
  {
    num_code: '894',
    alpha_2_code: 'ZM',
    alpha_3_code: 'ZMB',
    en_short_name: 'Zambia',
    name: 'Zambian',
  },
  {
    num_code: '716',
    alpha_2_code: 'ZW',
    alpha_3_code: 'ZWE',
    en_short_name: 'Zimbabwe',
    name: 'Zimbabwean',
  },
]

const TransactionBanks = [
  { id: '05', name: 'Хаан банк' },
  { id: '15', name: 'Голомт банк' },
  { id: '04', name: 'Худалдаа хөгжлийн банк' },
  { id: '34', name: 'Төрийн банк' },
  { id: '32', name: 'Хас банк' },
  { id: '30', name: 'Капитрон банк' },
  { id: '21', name: 'Ариг банк' },
  { id: '19', name: 'Тээвэр хөгжлийн банк' },
  { id: '29', name: 'Үндэсний хөрөнгө оруулалтын банк' },
  { id: '38', name: 'Богд банк' },
  { id: '33', name: 'Чингис хаан банк' },
  { id: '39', name: 'М банк' },
]

const Genders = [
  { id: 0, name: 'Эрэгтэй' },
  { id: 1, name: 'Эмэгтэй' },
  { id: 2, name: 'Бусад' },
]

const Accounts = {
    '04': '',
    '15': '',
    '32': '',
    '05': 'MN750005005038170508'
}


const CompanyInfo = {
    'name': process.env.VUE_APP_BROKER_COMPANY_NAME,
    'phone': process.env.VUE_APP_BROKER_COMPANY_PHONE,
    'email': process.env.VUE_APP_BROKER_COMPANY_EMAIL,
    'address': process.env.VUE_APP_BROKER_COMPANY_ADDRESS,
    'schedule': process.env.VUE_APP_BROKER_COMPANY_SCHEDULE,
}

export { Alphabets, Occupations, Cities, Districts, Commissions, Countries, TransactionBanks, Genders, Educations, Accounts, CompanyInfo }